/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	var Colors, Computer, Page, Root, palette;
	
	styles += ".main_callout {\n  font-size: 42px;\n  font-weight: 800;\n  color: white;\n  text-shadow: 0px 2px 4px rgba(0,0,0,.2);\n}\n\n.bold_callout {\n  font-weight: 800;\n  color: #303030;\n  font-size: 36px;\n  margin: 0 auto 40px auto;\n  max-width: 1100px;\n  text-align: center;    \n}\n\n.light_callout {\n  font-weight: 300;\n  font-size: 38px;\n  text-align: center;\n  margin-bottom: 4px;\n}\n\n@media (max-width: 1018px) and (min-width: 600px) {\n  .main_callout, .light_callout, .bold_callout {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 600px) and (min-width: 414px)  {\n  .main_callout, .light_callout, .bold_callout {\n    font-size: 24px;\n  }\n}\n@media (max-width: 413px) {\n  .main_callout, .light_callout, .bold_callout {\n    font-size: 20px;\n  }\n}\n\n";
	
	window.focus_color = function() {
	  return customization('focus_color') || focus_blue;
	};
	
	window.primary_color = function() {
	  var c;
	  c = fetch('colors');
	  return c.primary_color;
	};
	
	window.seattle_salmon = 'rgb(226 97 98)';
	
	palette = ["#e36263", "#2e8190", "#95377f", "#5f4ac2", "#734487", "#2d5da8"];
	
	Colors = ReactiveComponent({
	  displayName: 'Colors',
	  render: function() {
	    var color, colors, loc, logo_color;
	    loc = fetch('location');
	    colors = fetch('colors');
	    logo_color = 'white';
	    color = seattle_salmon;
	    switch (loc.url) {
	      case '/':
	        color = seattle_salmon;
	        break;
	      case '/tour':
	        color = palette[1];
	        break;
	      case '/examples':
	      case '/examples/public_engagement':
	        color = palette[2];
	        break;
	      case '/examples/strategic_planning':
	        color = '#647931';
	        break;
	      case '/examples/decentralized_decisions':
	        color = '#205A83';
	        break;
	      case '/examples/community_visioning':
	        color = '#324b7a';
	        break;
	      case '/pricing':
	        color = palette[3];
	        break;
	      case '/contact':
	        color = palette[4];
	        break;
	      case '/create_forum':
	        color = palette[5];
	        break;
	      case '/metrics':
	        color = 'white';
	        logo_color = seattle_salmon;
	    }
	    if (colors.primary_color !== color) {
	      colors.primary_color = color;
	      colors.logo_color = logo_color;
	      save(colors);
	    }
	    return SPAN(null);
	  }
	});
	
	__webpack_require__(94);
	
	__webpack_require__(85);
	
	__webpack_require__(89);
	
	__webpack_require__(86);
	
	__webpack_require__(83);
	
	__webpack_require__(91);
	
	__webpack_require__(84);
	
	__webpack_require__(90);
	
	__webpack_require__(95);
	
	__webpack_require__(88);
	
	__webpack_require__(87);
	
	__webpack_require__(45);
	
	Page = ReactiveComponent({
	  displayName: "Page",
	  mixins: [AccessControlled],
	  render: function() {
	    var bg_pattern_opacity, doc, footer_height, loc, update_title;
	    loc = fetch('location');
	    footer_height = fetch('footer').height;
	    bg_pattern_opacity = .03;
	    doc = fetch('document');
	    update_title = function(title) {
	      if (doc.title !== title) {
	        doc.title = title;
	        return save(doc);
	      }
	    };
	    return DIV({
	      style: {
	        backgroundColor: primary_color(),
	        transition: 'background-color 500ms ease',
	        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='887' height='739.2' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='" + bg_pattern_opacity + "'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E\")",
	        minHeight: '100%'
	      }
	    }, loc.query_params.play_demo ? Video({
	      playing: true
	    }) : ProductHeader(), (function() {
	      if (loc.url.indexOf('/examples') > -1) {
	        update_title('Examples');
	        return ExamplesPage();
	      } else if (loc.url.indexOf('/docs/') > -1) {
	        return DocumentationGroup();
	      } else {
	        switch (loc.url) {
	          case '/metrics':
	            return Metrics();
	          case '/':
	            update_title('Consider.it');
	            return LandingPage();
	          case '/tour':
	            update_title('How it works');
	            return Tour();
	          case '/pricing':
	            update_title('Pricing');
	            return Pricing();
	          case '/contact':
	            update_title('Contact us');
	            return Contact();
	          case '/create_forum':
	            update_title('Create a forum');
	            return CreateForum();
	        }
	      }
	    })(), ProductFooter());
	  }
	});
	
	Computer = ReactiveComponent({
	  displayName: 'Computer',
	  render: function() {
	    return SPAN(null, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".big_button {\n  background-color: " + (primary_color()) + ";\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 50%);\n  font-weight: 700;\n  color: white;\n  padding: 22px 42px;\n  display: inline-block;\n  font-size: 24px;\n  border: none;\n  border-radius: 8px;\n  text-decoration: none;\n  border-bottom: 1px solid black;\n}\n\n"
	      }
	    }));
	  }
	});
	
	window.big_button = function() {
	  return {
	    backgroundColor: primary_color(),
	    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 50%)",
	    fontWeight: 700,
	    color: 'white',
	    padding: '22px 42px',
	    display: 'inline-block',
	    fontSize: 24,
	    border: 'none',
	    borderRadius: 8,
	    textDecoration: 'none',
	    borderBottom: "1px solid black"
	  };
	};
	
	window.BIG_BUTTON = function(text, opts) {
	  opts.style || (opts.style = {});
	  _.defaults(opts.style, big_button());
	  return BUTTON({
	    style: opts.style,
	    onClick: opts.onClick,
	    onKeyPress: function(e) {
	      if (e.which === 13 || e.which === 32) {
	        e.preventDefault();
	        return opts.onClick(e);
	      }
	    }
	  }, text);
	};
	
	styles += ".conversion_attempt {\n  border-radius: 8px;\n  font-size: " + (responsive_css_rule({
	  min_size: 16,
	  max_size: 24,
	  min_vw: 414,
	  max_vw: 700
	})) + ";\n  font-weight: 700;\n  width: 330px;\n  text-align: center;\n  padding: 24px 0;\n  display: inline-block;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.conversion_attempt.main {\n  background-color: #EC3684;\n  box-shadow: 0 1px 2px 0 rgba(0,0,0,.5);\n  color: #FFFFFF;\n  margin-right: 48px;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 50%);\n  border-bottom: 1px solid black;\n}\n.conversion_attempt.secondary {\n  border: 1px solid #585858;\n  border-radius: 8px;\n}\n";
	
	window.demo_url = function() {
	  var region;
	  region = fetch('/application').region;
	  if (!region) {
	    return null;
	  }
	  region = region.toLowerCase();
	  if (region === 'us') {
	    return 'https://galacticfederation.consider.it';
	  } else {
	    return "https://galacticfederation." + region + ".consider.it";
	  }
	};
	
	window.conversion_pages = function() {
	  return {
	    create_forum: {
	      url: '/create_forum',
	      label: 'Create a Free Forum',
	      small_label: 'Create Forum'
	    },
	    pricing: {
	      url: '/pricing',
	      label: 'View Plans'
	    },
	    demo: {
	      url: demo_url(),
	      external: true,
	      label: 'Try a Demo',
	      small_label: 'Try Demo'
	    },
	    contact: {
	      url: '/contact',
	      label: 'Contact Us'
	    },
	    tour: {
	      url: '/tour',
	      label: 'Take the Product Tour',
	      small_label: 'Take a Tour'
	    },
	    examples: {
	      url: '/examples',
	      label: "See Examples"
	    },
	    about_us: {
	      url: '/contact#about_us',
	      label: 'About us'
	    }
	  };
	};
	
	window.ConversionAttempt = ReactiveComponent({
	  displayName: "ConversionAttempt",
	  render: function() {
	    var first, portrait_phone, ref, ref1, second, w;
	    first = conversion_pages()[((ref = this.props.pages) != null ? ref[0] : void 0) || 'create_forum'];
	    second = conversion_pages()[((ref1 = this.props.pages) != null ? ref1[1] : void 0) || 'pricing'];
	    w = WINDOW_WIDTH();
	    portrait_phone = w < 690;
	    return DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center',
	        margin: '0px auto',
	        padding: (responsive_css_rule({
	          min_size: 40,
	          max_size: 80,
	          min_vw: 550,
	          max_vw: 700
	        })) + " 24px"
	      }
	    }, A({
	      target: first.external ? '_blank' : void 0,
	      className: "conversion_attempt main",
	      style: {
	        backgroundColor: this.props.backgroundColor || primary_color()
	      },
	      href: first.url
	    }, portrait_phone && first.small_label ? first.small_label : first.label), A({
	      target: second.external ? '_blank' : void 0,
	      className: 'conversion_attempt secondary',
	      href: second.url
	    }, portrait_phone && second.small_label ? second.small_label : second.label));
	  }
	});
	
	styles += "#content, #content input, #content button, #content textarea {\n  font-family: IBM Plex Sans, Helvetica Neue, sans-serif; \n}\n.condensed {\n  font-family: \"Fira Sans Condensed\", 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif; \n}\n.monospaced {\n  font-family: Menlo, Consolas, Monaco, Fira Mono, Liberation Mono, Lucida Console, monospace;\n}";
	
	Root = ReactiveComponent({
	  displayName: "Root",
	  onTouchMove: function() {
	    return window.is_swipping = true;
	  },
	  onTouchEnd: function() {
	    return window.is_swipping = false;
	  },
	  render: function() {
	    return DIV({
	      "data-url": fetch('location').url,
	      style: {
	        width: "100vw"
	      }
	    }, BrowserLocation(), BrowserHacks(), Page(), Tooltip({
	      style: {
	        padding: '16px 24px'
	      }
	    }), Popover(), Computer(), Colors());
	  }
	});
	
	window.Saas = Root;
	
	__webpack_require__(82);


/***/ },

/***/ 45:
/***/ function(module, exports) {

	var stripeSVG;
	
	styles += "[data-widget=\"UpgradeForumBanner\"], [data-widget=\"HostHeader\"].forum_editor {\n  background-color: #456ae4;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23003f99' fill-opacity='0.49' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E\");\n  width: 100%;\n}\n\n[data-widget=\"HostHeader\"].forum_editor.not-fixed {\n  position: relative;\n}\n\n\n[data-widget=\"HostHeader\"].forum_editor.fixed {\n  position: fixed;\n  z-index: 99998;\n}\n\n\n#DASHBOARD-main [data-widget=\"UpgradeForumButton\"] .btn.big, [data-widget=\"UpgradeForumButton\"] .btn.big {\n  text-transform: capitalize;\n  padding: 8px 24px;\n  font-size: 14px;\n  margin-left: 0px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 1px rgb(8 81 114);\n}\n\n#DASHBOARD-main [data-widget=\"UpgradeForumButton\"] .btn, [data-widget=\"UpgradeForumButton\"] .btn {\n  margin-left: 8px;\n  background-color: " + upgrade_color + ";\n  font-size: 10px;\n  padding: 4px 6px;\n  text-transform: lowercase;\n}";
	
	window.UpgradeForumButton = ReactiveComponent({
	  displayName: 'UpgradeForumButton',
	  render: function() {
	    var TAG;
	    TAG = this.props.tag || BUTTON;
	    return SPAN(null, TAG({
	      className: "btn " + (this.props.big ? 'big' : ''),
	      style: this.props.style || {},
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, this.props.text || "upgrade"), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	window.UpgradeForumBanner = ReactiveComponent({
	  displayName: 'UpgradeForumBanner',
	  render: function() {
	    return DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        padding: 4
	      }
	    }, BUTTON({
	      className: 'btn',
	      style: {
	        marginRight: 24,
	        backgroundColor: upgrade_color,
	        boxShadow: '0 1px 2px rgba(0,0,0,.5)'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Upgrade forum"), SPAN({
	      style: {
	        fontSize: 13,
	        color: 'white',
	        fontWeight: 700
	      }
	    }, WINDOW_WIDTH() < 956 ? "$625 one-time fee" : "$625 one-time fee to unlock data export, sign-up questions, tab-based organization, and more.", A({
	      href: "https://" + (fetch('/application').base_domain) + "/pricing",
	      target: '_blank',
	      style: {
	        textDecoration: 'underline',
	        paddingLeft: 12,
	        color: 'white',
	        fontWeight: 700,
	        fontSize: 15
	      }
	    }, "Learn more")), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	window.UpgradeForumCompact = ReactiveComponent({
	  displayName: 'UpgradeForumCompact',
	  render: function() {
	    return DIV({
	      style: {
	        position: 'absolute'
	      }
	    }, BUTTON({
	      className: 'btn',
	      title: "$625 one-time fee to unlock data export, sign-up questions, tab-based organization, and more.",
	      style: {
	        backgroundColor: upgrade_color,
	        boxShadow: '0 1px 2px rgba(0,0,0,.5)'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Upgrade forum"), A({
	      href: "https://" + (fetch('/application').base_domain) + "/pricing",
	      target: '_blank',
	      style: {
	        textDecoration: 'underline',
	        color: 'white',
	        fontWeight: 600,
	        fontSize: 13,
	        marginLeft: 24
	      }
	    }, "Learn more about our plans"), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	styles += "[data-widget=\"ModalStripePayment\"] #modal-body {\n  background-color: white;\n  padding: 64px 0 48px 0;\n}\n[data-widget=\"ModalStripePayment\"] #modal-body #payment-form {\n  box-shadow: none;\n  padding: 0;\n}";
	
	window.ModalStripePayment = ReactiveComponent({
	  displayName: 'ModalStripePayment',
	  mixins: [Modal],
	  render: function() {
	    var cancel_payment;
	    cancel_payment = (function(_this) {
	      return function() {
	        var base;
	        return typeof (base = _this.props).cancel_payment === "function" ? base.cancel_payment() : void 0;
	      };
	    })(this);
	    return wrap_in_modal(Math.min(700, HOMEPAGE_WIDTH()), cancel_payment, DIV(null, STRIPE_PAYMENT(this.props), this.props.cancel_payment != null ? BUTTON({
	      className: 'like_link',
	      style: {
	        opacity: .7,
	        textAlign: 'center',
	        display: 'block',
	        margin: '24px auto 0 auto'
	      },
	      onClick: cancel_payment
	    }, 'cancel') : void 0));
	  }
	});
	
	stripeSVG = function(props) {
	  var base_height, base_width, style;
	  base_width = 150;
	  base_height = 34;
	  svg.setSize(base_width, base_height, props);
	  style = props.style || {};
	  return SVG({
	    width: props.width,
	    height: props.height,
	    viewBox: "0 0 " + base_width + " " + base_height,
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    style: style,
	    dangerouslySetInnerHTML: {
	      __html: "<g fill=\"#635bff\"><path d=\"m146 0h-142.27a3.73 3.73 0 0 0 -3.73 3.73v26.54a3.73 3.73 0 0 0 3.73 3.73h142.27a4 4 0 0 0 4-4v-26a4 4 0 0 0 -4-4zm3 30a3 3 0 0 1 -3 3h-142.27a2.74 2.74 0 0 1 -2.73-2.73v-26.54a2.74 2.74 0 0 1 2.73-2.73h142.27a3 3 0 0 1 3 3z\"/><path d=\"m17.07 11.24h-4.3v10.76h1.92v-4.16h2.38c2.4 0 3.9-1.16 3.9-3.3s-1.5-3.3-3.9-3.3zm-.1 5h-2.28v-3.3h2.31c1.38 0 2.11.59 2.11 1.65s-.76 1.6-2.11 1.6z\"/><path d=\"m25.1 14a3.77 3.77 0 0 0 -3.8 4.09 3.81 3.81 0 1 0 7.59 0 3.76 3.76 0 0 0 -3.79-4.09zm0 6.67c-1.22 0-2-1-2-2.58s.76-2.58 2-2.58 2 1 2 2.58-.79 2.57-2 2.57z\"/><path d=\"m36.78 19.35-1.41-5.22h-1.48l-1.4 5.22-1.42-5.22h-1.85l2.37 7.88h1.56l1.44-5.16 1.44 5.16h1.56l2.37-7.88h-1.78z\"/><path d=\"m44 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.41-2.18l-1.49-.62a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.17-2.17h5.52v-.6c.02-2.16-1.2-3.87-3.52-3.87zm-1.93 3.13a1.92 1.92 0 0 1 1.93-1.63 1.56 1.56 0 0 1 1.69 1.62z\"/><path d=\"m50.69 15.3v-1.17h-1.8v7.87h1.8v-4.13a1.89 1.89 0 0 1 2-2 4.68 4.68 0 0 1 .66 0v-1.8c-.14 0-.3 0-.51 0a2.29 2.29 0 0 0 -2.15 1.23z\"/><path d=\"m57.48 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.37-2.18l-1.54-.59a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.1-2.17h5.54v-.6c0-2.19-1.24-3.9-3.52-3.9zm-1.93 3.13a1.92 1.92 0 0 1 1.92-1.62 1.56 1.56 0 0 1 1.69 1.62z\"/><path d=\"m67.56 15a2.85 2.85 0 0 0 -2.26-1c-2.21 0-3.47 1.85-3.47 4.09s1.26 4.09 3.47 4.09a2.82 2.82 0 0 0 2.26-1v.82h1.8v-10.76h-1.8zm0 3.35a2 2 0 0 1 -2 2.28c-1.31 0-2-1-2-2.52s.7-2.52 2-2.52c1.11 0 2 .81 2 2.29z\"/><path d=\"m79.31 14a2.88 2.88 0 0 0 -2.31 1v-3.76h-1.8v10.76h1.8v-.83a2.86 2.86 0 0 0 2.27 1c2.2 0 3.46-1.86 3.46-4.09s-1.22-4.08-3.42-4.08zm-.31 6.6a2 2 0 0 1 -2-2.28v-.47c0-1.48.84-2.29 2-2.29 1.3 0 2 1 2 2.52s-.75 2.52-2 2.52z\"/><path d=\"m86.93 19.66-1.93-5.53h-1.9l2.9 7.59-.3.74a1 1 0 0 1 -1.14.79 4.12 4.12 0 0 1 -.6 0v1.51a4.62 4.62 0 0 0 .73.05 2.67 2.67 0 0 0 2.78-2l3.24-8.62h-1.89z\"/><path d=\"m125 12.43a3 3 0 0 0 -2.13.87l-.14-.69h-2.39v12.92l2.72-.59v-3.13a3 3 0 0 0 1.93.7c1.94 0 3.72-1.59 3.72-5.11 0-3.22-1.8-4.97-3.71-4.97zm-.65 7.63a1.61 1.61 0 0 1 -1.28-.52v-4.11a1.64 1.64 0 0 1 1.3-.55c1 0 1.68 1.13 1.68 2.58s-.69 2.6-1.7 2.6z\"/><path d=\"m133.73 12.43c-2.62 0-4.21 2.26-4.21 5.11 0 3.37 1.88 5.08 4.56 5.08a6.12 6.12 0 0 0 3-.73v-2.25a5.79 5.79 0 0 1 -2.7.62c-1.08 0-2-.39-2.14-1.7h5.38c0-.15 0-.74 0-1 .09-2.87-1.27-5.13-3.89-5.13zm-1.47 4.07c0-1.26.77-1.79 1.45-1.79s1.4.53 1.4 1.79z\"/><path d=\"m113 13.36-.17-.82h-2.32v9.71h2.68v-6.58a1.87 1.87 0 0 1 2.05-.58v-2.55a1.8 1.8 0 0 0 -2.24.82z\"/><path d=\"m99.46 15.46c0-.44.36-.61.93-.61a5.9 5.9 0 0 1 2.7.72v-2.63a7 7 0 0 0 -2.7-.51c-2.21 0-3.68 1.18-3.68 3.16 0 3.1 4.14 2.6 4.14 3.93 0 .52-.44.69-1 .69a6.78 6.78 0 0 1 -3-.9v2.69a7.38 7.38 0 0 0 3 .64c2.26 0 3.82-1.15 3.82-3.16-.05-3.36-4.21-2.76-4.21-4.02z\"/><path d=\"m107.28 10.24-2.65.58v8.93a2.77 2.77 0 0 0 2.82 2.87 4.16 4.16 0 0 0 1.91-.37v-2.25c-.35.15-2.06.66-2.06-1v-4h2.06v-2.34h-2.06z\"/><path d=\"m116.25 11.7 2.73-.57v-2.16l-2.73.57z\"/><path d=\"m116.25 12.61h2.73v9.64h-2.73z\"/></g></svg>"
	    }
	  });
	};
	
	window.STRIPE_PAYMENT = ReactiveComponent({
	  displayName: 'STRIPE_PAYMENT',
	  componentDidMount: function() {
	    return this.configurePayment();
	  },
	  componentDidUpdate: function() {
	    return this.configurePayment();
	  },
	  render: function() {
	    return DIV(null, DIV({
	      style: {
	        marginBottom: 48,
	        color: 'black'
	      }
	    }, H1({
	      style: {
	        fontSize: 32,
	        textAlign: 'center'
	      }
	    }, "Upgrade to a Premium Forum"), DIV({
	      style: {
	        fontSize: 13,
	        margin: "12px auto",
	        maxWidth: 500
	      }
	    }, "$625 one-time fee to unlock data export, sign-up questions, and tab-based organization. Contact", A({
	      href: 'mailto:help@consider.it?subject=Consider.it alternative payment',
	      style: {
	        textDecoration: 'underline',
	        padding: "0px 4px",
	        fontWeight: 600
	      }
	    }, 'help@consider.it'), "to pay using a different method.")), stripeSVG({
	      height: 24,
	      style: {
	        position: 'absolute',
	        right: 90,
	        bottom: 48
	      }
	    }), DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center'
	      }
	    }, FORM({
	      id: "payment-form",
	      ref: "payment_form"
	    }, DIV({
	      id: "payment-element"
	    }, this.local.loading ? LOADING_INDICATOR : void 0), BUTTON({
	      id: "submit"
	    }, DIV({
	      className: "spinner hidden",
	      id: "spinner"
	    }), SPAN({
	      id: 'button-text'
	    }, "Pay now")), DIV({
	      id: "payment-message",
	      className: "hidden"
	    }))));
	  },
	  configurePayment: function() {
	    var appearance, checkStatus, elements, intent, paymentElement, payment_form, pub, setLoading, showMessage, stripe_script_loaded;
	    stripe_script_loaded = lazyLoadJavascript("https://js.stripe.com/v3/", {
	      onload: (function(_this) {
	        return function() {
	          _this.local.loading = false;
	          return save(_this.local);
	        };
	      })(this),
	      onerror: (function(_this) {
	        return function() {
	          _this.local.error = true;
	          _this.local.loading = false;
	          return save(_this.local);
	        };
	      })(this)
	    });
	    if (!stripe_script_loaded && !this.local.error) {
	      this.local.loading = true;
	      save(this.local);
	      return;
	    }
	    if (typeof Stripe === "undefined" || Stripe === null) {
	      return setTimeout(this.configurePayment, 20);
	    }
	    if (!window.stripe) {
	      pub = fetch('/payments/public_key');
	      if (!pub.public_key) {
	        return;
	      }
	      window.stripe = Stripe(pub.public_key);
	    }
	    if (!this.intent) {
	      intent = fetch('/payments/payment_intent');
	      if (!intent.secret) {
	        return;
	      }
	      this.intent = intent.secret;
	    }
	    if (!this.mounted) {
	      appearance = {
	        theme: 'stripe'
	      };
	      elements = stripe.elements({
	        appearance: appearance,
	        clientSecret: this.intent
	      });
	      paymentElement = elements.create("payment", {
	        business: {
	          name: "Consider.it"
	        }
	      });
	      paymentElement.mount("#payment-element");
	      this.mounted = true;
	      payment_form = this.refs.payment_form;
	      setLoading = function(isLoading) {
	        if (isLoading) {
	          payment_form.querySelector("#submit").disabled = true;
	          payment_form.querySelector("#spinner").classList.remove("hidden");
	          return payment_form.querySelector("#button-text").classList.add("hidden");
	        } else {
	          payment_form.querySelector("#submit").disabled = false;
	          payment_form.querySelector("#spinner").classList.add("hidden");
	          return payment_form.querySelector("#button-text").classList.remove("hidden");
	        }
	      };
	      showMessage = (function(_this) {
	        return function(messageText) {
	          var messageContainer;
	          messageContainer = payment_form.querySelector("#payment-message");
	          messageContainer.classList.remove("hidden");
	          messageContainer.textContent = messageText;
	          return setTimeout(function() {
	            messageContainer.classList.add("hidden");
	            return messageText.textContent = "";
	          }, 4000);
	        };
	      })(this);
	      checkStatus = (function(_this) {
	        return function() {
	          return stripe.retrievePaymentIntent(_this.intent).then(function(arg) {
	            var paymentIntent;
	            paymentIntent = arg.paymentIntent;
	            switch (paymentIntent.status) {
	              case "succeeded":
	                showMessage("Payment succeeded!");
	                break;
	              case "processing":
	                showMessage("Your payment is processing.");
	                break;
	              case "requires_payment_method":
	                showMessage("Your payment was not successful, please try again.");
	                break;
	              default:
	                showMessage("Something went wrong.");
	                break;
	            }
	          });
	        };
	      })(this);
	      return payment_form.addEventListener("submit", (function(_this) {
	        return function(e) {
	          var promise, url;
	          e.preventDefault();
	          setLoading(true);
	          promise = stripe.confirmPayment({
	            elements: elements,
	            confirmParams: {
	              return_url: _this.props.create_forum_after_payment ? (url = location.origin + "/payments/successful?create_forum=" + _this.props.create_forum_after_payment, _this.props.copy_from ? url += "&copy_from=" + _this.props.copy_from : void 0, url) : (url = new URL(window.location.href), fetch('edit_forum').editing ? url.searchParams.set('edit_forum', 'true') : void 0, url.searchParams.set('flash', translator('admin.thanks-for-upgrading', 'Thank you for upgrading!')), location.origin + "/payments/successful?redirect_to=" + (encodeURIComponent(url.href)))
	            }
	          });
	          return promise.then(function(arg) {
	            var error;
	            error = arg.error;
	            if (error.type === "card_error" || error.type === "validation_error") {
	              showMessage(error.message);
	            } else {
	              showMessage("An unexpected error occured.");
	            }
	            return setLoading(false);
	          });
	        };
	      })(this));
	    }
	  }
	});
	
	styles += "#payment-form {\n  width: 30vw;\n  min-width: 500px;\n  align-self: center;\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 7px;\n  padding: 40px;\n  background-color: white;\n}\n\n#payment-form * {\n  box-sizing: border-box;\n}\n\n#payment-form body {\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 100vh;\n  width: 100vw;\n}\n\n#payment-form .hidden {\n  display: none;\n}\n\n#payment-message {\n  color: rgb(105, 115, 134);\n  font-size: 16px;\n  line-height: 20px;\n  padding-top: 12px;\n  text-align: center;\n}\n\n#payment-element {\n  margin-bottom: 24px;\n}\n\n/* Buttons and links */\n#payment-form button {\n  background: #5469d4;\n  font-family: Arial, sans-serif;\n  color: #ffffff;\n  border-radius: 4px;\n  border: 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: block;\n  transition: all 0.2s ease;\n  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n  width: 100%;\n}\n#payment-form button:hover,\n#payment-form button:focus-within {\n  filter: contrast(115%);\n}\n#payment-form button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* spinner/processing state, errors */\n#payment-form .spinner,\n#payment-form .spinner:before,\n#payment-form .spinner:after {\n  border-radius: 50%;\n}\n#payment-form .spinner {\n  color: #ffffff;\n  font-size: 22px;\n  text-indent: -99999px;\n  margin: 0px auto;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  box-shadow: inset 0 0 0 2px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n}\n#payment-form .spinner:before,\n#payment-form .spinner:after {\n  position: absolute;\n  content: \"\";\n}\n#payment-form .spinner:before {\n  width: 10.4px;\n  height: 20.4px;\n  background: #5469d4;\n  border-radius: 20.4px 0 0 20.4px;\n  top: -0.2px;\n  left: -0.2px;\n  -webkit-transform-origin: 10.4px 10.2px;\n  transform-origin: 10.4px 10.2px;\n  -webkit-animation: payment-loading 2s infinite ease 1.5s;\n  animation: payment-loading 2s infinite ease 1.5s;\n}\n#payment-form .spinner:after {\n  width: 10.4px;\n  height: 10.2px;\n  background: #5469d4;\n  border-radius: 0 10.2px 10.2px 0;\n  top: -0.1px;\n  left: 10.2px;\n  -webkit-transform-origin: 0px 10.2px;\n  transform-origin: 0px 10.2px;\n  -webkit-animation: payment-loading 2s infinite ease;\n  animation: payment-loading 2s infinite ease;\n}\n\n@-webkit-keyframes payment-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes payment-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 600px) {\n  #payment-form form {\n    width: 80vw;\n    min-width: initial;\n  }\n}\n\n\n";


/***/ },

/***/ 82:
/***/ function(module, exports) {

	(function() {
	  var container, root, style;
	  style = document.createElement('style');
	  style.type = 'text/css';
	  if (style.styleSheet) {
	    style.styleSheet.cssText = window.styles;
	  } else {
	    style.appendChild(document.createTextNode(window.styles));
	  }
	  document.body.appendChild(style);
	  container = document.getElementById('content');
	  root = ReactDOM.createRoot(container);
	  return setTimeout(function() {
	    if (typeof ahoy !== "undefined" && ahoy !== null) {
	      ahoy.configure({
	        cookies: false
	      });
	    }
	    return root.render(Saas({
	      key: 'saas_root'
	    }));
	  });
	})();


/***/ },

/***/ 83:
/***/ function(module, exports) {

	var acknowledgements, forms;
	
	styles += ".contact_bg {\n  /* background-color: #f6f6f6; */\n  /* background-image: url(\"data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23aaa9ac' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E\");*/\n\n}\n\n.contact_form_wrapper {\n  background-color: white;\n  max-width: 800px;\n  margin: auto;\n  padding: 60px 80px;\n  box-shadow: 0 1px 3px rgba(0,0,0,.4);\n  border-radius: 16px;\n}\n\n@media (max-width: 500px) {\n  .contact_form_wrapper {\n    padding: 32px 32px;\n  }\n}\n\n[data-widget=\"Contact\"] button:disabled {\n  opacity: .4;\n  pointer-events: none;\n  cursor: auto;\n}\n\n";
	
	window.Contact = ReactiveComponent({
	  displayName: 'Contact',
	  render: function() {
	    var base;
	    if ((base = this.local).current_form == null) {
	      base.current_form = 0;
	    }
	    return DIV(null, this.heading(), DIV({
	      className: 'contact_bg'
	    }, this.form(), this.people()));
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      className: 'main_callout condensed'
	    }, "Hi friend, how can we help?"), DIV({
	      style: {
	        fontSize: 18,
	        color: 'white',
	        marginTop: 8
	      }
	    }, 'Please introduce yourself, we’d be delighted to hear from you.'));
	  },
	  form_chooser: function() {
	    var base, form, i, idx, len, loc, n, set_form;
	    set_form = (function(_this) {
	      return function() {
	        var loc;
	        loc = fetch('location');
	        loc.query_params.form = forms[_this.local.current_form].id;
	        return save(loc);
	      };
	    })(this);
	    if (this.local.current_form == null) {
	      loc = fetch('location');
	      if (loc.query_params.form) {
	        for (idx = i = 0, len = forms.length; i < len; idx = ++i) {
	          form = forms[idx];
	          if (form.id === loc.query_params.form) {
	            this.local.current_form = idx;
	            break;
	          }
	        }
	      }
	      (base = this.local).current_form || (base.current_form = 0);
	    }
	    return DIV({
	      style: {
	        position: 'relative',
	        textAlign: 'center',
	        top: 40
	      }
	    }, SELECT({
	      className: 'unstyled',
	      style: {
	        fontSize: 24,
	        padding: '28px 40px',
	        fontWeight: 400,
	        backgroundSize: '24px 20px',
	        backgroundColor: 'white',
	        border: '1px solid #979797',
	        borderRadius: 32
	      },
	      value: this.local.current_form,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.current_form = e.target.value;
	          save(_this.local);
	          set_form();
	          return document.activeElement.blur();
	        };
	      })(this)
	    }, (function() {
	      var j, len1, results;
	      results = [];
	      for (idx = j = 0, len1 = forms.length; j < len1; idx = ++j) {
	        n = forms[idx];
	        results.push(OPTION({
	          key: idx,
	          value: idx,
	          style: {}
	        }, n.question));
	      }
	      return results;
	    })()));
	  },
	  form: function() {
	    var current_form, disabled, error, field, i, len, ref, ref1, submit_click;
	    current_form = forms[this.local.current_form];
	    disabled = false;
	    ref = current_form.fields;
	    for (i = 0, len = ref.length; i < len; i++) {
	      field = ref[i];
	      if (!field.optional && !(((ref1 = this.local[field.label]) != null ? ref1.length : void 0) > 0)) {
	        disabled = true;
	      }
	    }
	    submit_click = (function(_this) {
	      return function(e) {
	        var c, j, len1, p, ref2;
	        e.preventDefault();
	        c = {
	          key: '/new/contact_us'
	        };
	        ref2 = _this.refs.form.elements;
	        for (j = 0, len1 = ref2.length; j < len1; j++) {
	          p = ref2[j];
	          if (p.name.length > 0) {
	            c[p.name] = p.value;
	          }
	        }
	        _this.local.errors = null;
	        _this.local.successful = null;
	        return save(c, function(resp) {
	          if (c.errors.length > 0) {
	            _this.local.errors = c.errors;
	          } else {
	            _this.local.successful = true;
	            if (!_this.logged_conversion) {
	              if (typeof plausibleEvent === "function") {
	                plausibleEvent('Contact');
	              }
	              _this.logged_conversion = true;
	            }
	          }
	          return save(_this.local);
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        paddingTop: 48,
	        paddingBottom: 110
	      }
	    }, DIV({
	      className: 'contact_form_wrapper'
	    }, FORM({
	      action: '/contact_us',
	      method: 'post',
	      ref: 'form'
	    }, (function() {
	      var j, len1, ref2, results;
	      ref2 = current_form.fields;
	      results = [];
	      for (j = 0, len1 = ref2.length; j < len1; j++) {
	        field = ref2[j];
	        results.push((function(_this) {
	          return function(field) {
	            return DIV({
	              key: field.label,
	              style: {
	                paddingBottom: 24
	              }
	            }, LABEL({
	              style: {
	                fontSize: 20,
	                display: 'block',
	                paddingBottom: 2
	              },
	              htmlFor: slugify(field.label)
	            }, field.label), field.form ? field.form() : field.tag({
	              name: slugify(field.label),
	              id: slugify(field.label),
	              required: !field.optional ? true : void 0,
	              onChange: function(e) {
	                _this.local[field.label] = e.target.value;
	                return save(_this.local);
	              },
	              style: {
	                width: '100%',
	                fontSize: 22,
	                padding: '4px 8px',
	                border: '1px solid #ddd',
	                height: field.tag === TEXTAREA ? 100 : void 0,
	                resize: field.tag === TEXTAREA ? 'vertical' : void 0
	              }
	            }), !field.optional ? DIV({
	              style: {
	                fontSize: 10,
	                color: '#777'
	              }
	            }, 'required') : void 0);
	          };
	        })(this)(field));
	      }
	      return results;
	    }).call(this), DIV({
	      style: {
	        position: 'relative',
	        top: 20,
	        textAlign: 'center'
	      }
	    }, INPUT({
	      type: 'hidden',
	      name: 'inquiry',
	      value: current_form.question
	    }), (function() {
	      var j, len1, ref2, results;
	      if (this.local.errors) {
	        ref2 = this.local.errors;
	        results = [];
	        for (j = 0, len1 = ref2.length; j < len1; j++) {
	          error = ref2[j];
	          results.push(DIV({
	            style: {
	              color: 'red',
	              fontSize: 14,
	              paddingTop: 20
	            }
	          }, error));
	        }
	        return results;
	      }
	    }).call(this), this.local.successful ? DIV({
	      style: {
	        backgroundColor: primary_color(),
	        color: 'white',
	        fontSize: 18,
	        padding: 20
	      }
	    }, 'Thank you for your message. We will be in touch.') : BUTTON({
	      disabled: disabled,
	      style: _.extend({}, big_button(), {
	        width: '100%'
	      }),
	      onClick: submit_click
	    }, 'Deliver to Consider.it')))));
	  },
	  people: function() {
	    var ack, acks, idx, num, pic;
	    acks = acknowledgements;
	    num = Math.round(Math.random() * 100) % 3;
	    return DIV({
	      id: 'about_us',
	      className: 'acknowledgements'
	    }, (function() {
	      var i, len, ref, results;
	      ref = [acks.travis, acks.core, acks.early];
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        ack = ref[idx];
	        pic = ack.pics[num] || ack.pics[0];
	        results.push(DIV({
	          key: ack.text,
	          className: "acknowledgement",
	          style: {
	            backgroundImage: "url(" + (asset("product_page/acknowledgements/" + pic.url)) + ")",
	            marginTop: idx > 0 ? -93 : void 0
	          }
	        }, DIV({
	          className: "monospaced " + (pic.dark ? 'dark' : 'light'),
	          style: {
	            position: 'absolute',
	            top: pic.top || 50,
	            left: pic.left || 400,
	            color: pic.dark ? 'white' : 'black',
	            width: (pic.width || 460) + 40,
	            fontSize: 22,
	            fontWeight: 500,
	            padding: "18px 28px"
	          },
	          dangerouslySetInnerHTML: {
	            __html: ack.text
	          }
	        })));
	      }
	      return results;
	    })());
	  }
	});
	
	styles += "@media (max-width: 680px) {\n  .acknowledgements {\n    display: none;\n  }\n}\n\n.acknowledgements .dark a {\n  color: white;\n}\n.acknowledgements .light a {\n  color: black;\n}\n\n.acknowledgements .dark, .acknowledgements .light {\n  border-radius: 8px;\n}\n.acknowledgements .dark {\n  background-color: rgba(0,0,0, .5);\n}\n.acknowledgements .light {\n  background-color: rgba(255,255,255, .5);\n}\n.acknowledgement {\n  min-height: 900px;\n  position: relative;\n  z-index: 2;\n  background-size: cover;\n  background-position: center;\n\n  /* --mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 25px) no-repeat, conic-gradient(from 135deg at top, #0000, #000 1deg 89deg, #0000 90deg) 0 0/25px 30px space no-repeat; #url(" + (asset("product_page/acknowledgements/wave.png")) + ") */\n\n  \n  animation: wavy 150s infinite alternate linear;\n}\n@keyframes wavy {\n  0%   { -webkit-mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(" + (asset("product_page/wavy.png")) + ") repeat-x 0%     0%;\n                 mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(" + (asset("product_page/wavy.png")) + ") repeat-x 0%     0%;}\n  100% { -webkit-mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(" + (asset("product_page/wavy.png")) + ") repeat-x 10000% 0%;\n                 mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(" + (asset("product_page/wavy.png")) + ") repeat-x 10000% 0%;}\n}\n";
	
	acknowledgements = {
	  travis: {
	    text: "Consider.it is led by <a href=\"https://traviskriplean.com\" target=\"_blank\">Travis Kriplean</a>. He first created it in 2010 as part of his PhD \nresearch on <a href=\"https://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.229.2396&rep=rep1&type=pdf\" target=\"_blank\">Supporting Reflective Public Dialogue</a>. \nHe’s been working on it ever since. Contact him at <a href=\"mailto:travis@consider.it\">travis@consider.it</a>, read <a href=\"https://traviskriplean.com\" target=\"_blank\">his blog</a>, or connect on <a href=\"https://www.linkedin.com/in/travis-kriplean/\" target=\"_blank\">LinkedIn</a>.",
	    pics: [
	      {
	        url: 'reading.jpeg',
	        top: 100,
	        width: 520,
	        left: 50,
	        dark: false
	      }, {
	        url: 'needles.jpeg',
	        top: 100,
	        width: 520,
	        left: "calc(50% - 460px / 2)",
	        dark: false
	      }, {
	        url: 'tetons.jpeg',
	        top: 100,
	        width: 520,
	        left: 100,
	        dark: false
	      }
	    ]
	  },
	  core: {
	    text: "Consider.it benefits from deep contributions from many fantastic people, most substantially <a href=\"https://invisible.college/@toomim\" target=\"_blank\">Michael Toomim</a>, \n<a target=\"_blank\" href=\"https://www.linkedin.com/in/kevin-miniter/\">" + (Math.random() > .5 ? 'Kevin' : 'Kevie') + " Miniter</a>, <a href=\"https://www.linkedin.com/in/ethanschaffer/\" target=\"_blank\">Ethan Schaffer</a>, and <a href=\"https://www.linkedin.com/in/evaring/\" target=\"_blank\">Eva Ringstrom</a>. ",
	    pics: [
	      {
	        url: 'prototypin.jpeg',
	        top: 100,
	        left: 80,
	        dark: false
	      }, {
	        url: 'crazy-mike.jpg',
	        top: 100,
	        left: 50,
	        dark: true
	      }, {
	        url: 'laying.jpg',
	        top: 100,
	        left: 50,
	        dark: false
	      }
	    ]
	  },
	  early: {
	    text: "Major contributors at the beginning of the project include <a href=\"https://www.cs.washington.edu/people/faculty/borning\" target=\"_blank\">Alan Borning</a>, <a href=\"https://www.dianedouglas.consulting/\" target=\"_blank\">Diane Douglas</a>, \n<a href=\"https://www.linkedin.com/in/jonathan-t-morgan-phd-4019058/\" target=\"_blank\">Jonathan Morgan</a>, <a href=\"https://www.linkedin.com/in/jessica-jones-3560575/\" target=\"_blank\">Jessica Jones</a>, <a href=\"https://www.polisci.washington.edu/people/w-lance-bennett\" target=\"_blank\">Lance Bennett</a>, <a href=\"http://hussman.unc.edu/directory/faculty/deen-freelon\" target=\"_blank\">Deen Freelon</a>, and <a href=\"https://www.andrewhamada.com/\" target=\"_blank\">Andrew Hamada</a>. ",
	    pics: [
	      {
	        url: 'cabin.jpg',
	        top: 100,
	        left: 50,
	        dark: true
	      }, {
	        url: 'kev-beach.jpeg',
	        top: 100,
	        left: 50,
	        dark: true
	      }, {
	        url: 'kev-ethan.jpg',
	        top: 38,
	        left: 38,
	        dark: false
	      }
	    ]
	  }
	};
	
	forms = [
	  {
	    id: 'general_inquiry',
	    question: "General inquiry",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT,
	        optional: true
	      }, {
	        label: 'Your email',
	        tag: INPUT,
	        optional: false
	      }, {
	        label: 'Your organization',
	        tag: INPUT,
	        optional: true
	      }, {
	        label: 'What can we help you with?',
	        tag: TEXTAREA,
	        optional: false
	      }
	    ]
	  }, {
	    id: 'request_demo',
	    question: "Let's schedule a demo",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'A basic description of your goal for a dialogue',
	        tag: TEXTAREA
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'consulting_inquiry',
	    question: 'Will your consulting services help my project?',
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'Describe your project',
	        tag: TEXTAREA
	      }, {
	        label: 'Approximate budget',
	        tag: INPUT,
	        optional: true
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'consultant_partnership',
	    question: "I'm a consultant and would like to use Consider.it with my clients",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'Describe your practice',
	        tag: TEXTAREA,
	        optional: true
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'upgrade_to_customized_forum',
	    question: "We would like help with our Forum",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }
	    ]
	  }
	];


/***/ },

/***/ 84:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(92);
	
	__webpack_require__(93);
	
	styles += "\n\n[data-widget=\"CreateForum\"] #AUTH_wrapper {\n  padding: 1.5em 0;\n}\n[data-widget=\"CreateForum\"] #AUTH_task {\n  font-size: 32px;\n  margin-bottom: 4px;\n}\n\n\n[data-widget=\"CreateForum\"] .additional_info {\n  font-size: 13px;\n  color: white;\n  opacity: 1;\n  margin-top: 8px;\n  text-shadow: none;\n  font-weight: 600;\n  position: absolute;\n  width: 100%;\n  top: 100%;\n  margin-top: 12px;\n  padding: 0 24px;\n}\n\n[data-widget=\"CreateForum\"] .button_wrapper {\n  display: flex; \n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n}\n\n[data-widget=\"CreateForum\"] .plan_button {\n  background-color: #d45283;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.50);\n  padding: 16px 32px;\n  font-size: 17px;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  height: 60px;\n}\n\n[data-widget=\"CreateForum\"] .domain_hint {\n  color: white;\n  font-size: 28px;\n  padding: 0 2px;  \n}\n\n[data-widget=\"CreateForum\"] .forum_url {\n  display: none;\n}\n\n@media (max-width: 580px) {\n  [data-widget=\"CreateForum\"] .domain_hint {\n    font-size: 16px;\n  }\n}\n@media (max-width: 530px) {\n  [data-widget=\"CreateForum\"] .domain_hint {\n    display: none;\n  }\n  [data-widget=\"CreateForum\"] .forum_url {\n    display: block;\n    font-weight: 600;\n    color: white;\n    font-size: 15px;\n    word-break: break-all;\n  }\n}\n\n";
	
	window.CreateForum = ReactiveComponent({
	  displayName: 'CreateForum',
	  render: function() {
	    var alt, alternatives, au, auth, base, ca, current_user, error, eu, forums, hide_free, hide_paid, hosted_forum, hosted_previously, idx, loc, plan_button_style, previous_forums, ref, ref1, ref2, ref3, ref4, region, us;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (current_user.logged_in == null) {
	      return SPAN(null);
	    }
	    if (!current_user.logged_in && !auth.form) {
	      auth.form = 'create account';
	      save(auth);
	    }
	    loc = fetch('location');
	    if (loc.query_params.error) {
	      this.local.errors = [decodeURIComponent(loc.query_params.error)];
	      save(this.local);
	      delete loc.query_params.error;
	      save(loc);
	    }
	    hide_free = ((ref = loc.query_params) != null ? ref.plan : void 0) === 'premium';
	    hide_paid = WINDOW_WIDTH() < 550 && !hide_free;
	    plan_button_style = {
	      opacity: !current_user.logged_in ? 0 : !(((ref1 = this.local.forum_name) != null ? ref1.length : void 0) > 0) ? .7 : void 0,
	      cursor: !current_user.logged_in || !(((ref2 = this.local.forum_name) != null ? ref2.length : void 0) > 0) ? 'auto' : 'pointer'
	    };
	    if ((base = this.local).forum_name == null) {
	      base.forum_name = loc.query_params.forum;
	    }
	    region = fetch('/application').region;
	    eu = ['Europe', 'https://eu.consider.it/create_forum'];
	    ca = ['Canada', 'https://ca.consider.it/create_forum'];
	    us = ['U.S.', 'https://consider.it/create_forum'];
	    au = ['Australia', 'https://au.consider.it/create_forum'];
	    if (region === 'US') {
	      alternatives = [eu, ca, au];
	    } else if (region === 'CA') {
	      alternatives = [us, eu, au];
	    } else if (region === 'EU') {
	      alternatives = [us, ca, au];
	    } else if (region === 'AU') {
	      alternatives = [us, ca, eu];
	    } else {
	      alternatives = [];
	    }
	    return DIV(null, DIV({
	      style: {
	        backgroundColor: "rgba(255,255,255,.5)",
	        color: "black",
	        width: 350,
	        margin: 'auto',
	        borderRadius: 16,
	        padding: '12px 24px',
	        marginTop: 48
	      }
	    }, "You're creating a forum on our ", B(null, (region === 'CA' ? 'Canadian' : region) + " server"), ". Alternatives:", (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = alternatives.length; i < len; i++) {
	        alt = alternatives[i];
	        results.push(A({
	          style: {
	            paddingLeft: 8
	          },
	          href: alt[1]
	        }, alt[0]));
	      }
	      return results;
	    })()), this.local.show_payment_form ? ModalStripePayment({
	      create_forum_after_payment: this.refs.forum_name.value,
	      copy_from: this.local.copy_from ? this.local.copy_from : void 0,
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0, current_user.logged_in ? (forums = fetch('/your_forums'), hosted_previously = forums.hosted, FORM({
	      ref: 'create_forum_form',
	      action: "/subdomain" + (screencasting() ? '?skip_seeding=true' : ''),
	      method: 'POST',
	      autoComplete: screencasting() ? "off" : void 0
	    }, DIV({
	      style: {
	        paddingTop: 40,
	        paddingBottom: 12,
	        width: 'var(--SAAS_PAGE_WIDTH)',
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      className: 'main_callout condensed',
	      style: {
	        marginBottom: 24
	      }
	    }, 'Give your new Forum a name'), DIV({
	      style: {
	        paddingBottom: 10
	      }
	    }, SPAN({
	      className: 'domain_hint'
	    }, 'https://'), INPUT({
	      defaultValue: this.local.forum_name,
	      type: 'text',
	      name: 'subdomain',
	      ref: 'forum_name',
	      style: {
	        border: "1px solid #000000",
	        padding: '8px 16px',
	        fontSize: 20,
	        margin: '0 8px',
	        boxShadow: '0 0 18px 0 rgba(162,98,162,0.50)',
	        outline: '1px solid #A262A2'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.forum_name = e.target.value;
	          _this.local.slugged_forum_name = _this.local.forum_name.toLowerCase().trim().replace(/\ /g, '-').replace(/[^\w-]/g, '');
	          return save(_this.local);
	        };
	      })(this)
	    }), SPAN({
	      className: 'domain_hint'
	    }, '.consider.it')), DIV({
	      className: 'forum_url',
	      style: {
	        visibility: !this.local.forum_name ? 'hidden' : void 0
	      }
	    }, "https://" + this.local.slugged_forum_name + ".consider.it")), (hosted_previously != null ? hosted_previously.length : void 0) > 0 ? (previous_forums = hosted_previously.slice(), previous_forums.unshift({
	      id: '',
	      name: ''
	    }), DIV({
	      style: {
	        margin: 'auto',
	        maxWidth: 600,
	        textAlign: 'center'
	      }
	    }, DIV({
	      style: {
	        color: 'white'
	      }
	    }, "Import configuration from a previous forum (optional)"), SELECT({
	      name: 'copy_from',
	      defaultValue: null,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.copy_from = e.target.value;
	          _this.local.copy_from_premium = e.target.selectedOptions[0].textContent.indexOf("Premium Forum") > -1;
	          return save(_this.local);
	        };
	      })(this)
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = previous_forums.length; i < len; i++) {
	        hosted_forum = previous_forums[i];
	        results.push(OPTION({
	          value: hosted_forum.id,
	          key: hosted_forum.id
	        }, "" + hosted_forum.name + (hosted_forum.plan > 0 ? " *Premium Forum*" : "")));
	      }
	      return results;
	    })()), this.local.copy_from_premium ? DIV({
	      style: {
	        marginTop: 14,
	        fontSize: 14,
	        color: 'white'
	      }
	    }, "The configuration of Premium features may not apply until or unless your new forum is upgraded to a Premium Forum.") : void 0)) : void 0, this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        padding: "8px 16px",
	        backgroundColor: 'rgba(255,255,255,.6)',
	        color: '#513152',
	        maxWidth: 600,
	        margin: 'auto'
	      }
	    }, (function() {
	      var i, len, ref3, results;
	      ref3 = this.local.errors;
	      results = [];
	      for (idx = i = 0, len = ref3.length; i < len; idx = ++i) {
	        error = ref3[idx];
	        results.push(DIV({
	          style: {
	            fontWeight: 500,
	            marginTop: idx !== 0 ? 10 : void 0
	          }
	        }, "" + (idx === 0 ? "Ooops! " : "") + error));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        textAlign: 'center',
	        paddingTop: 48
	      }
	    }, INPUT({
	      type: 'hidden',
	      name: 'authenticity_token',
	      value: arest.csrf()
	    }), INPUT({
	      type: 'hidden',
	      name: 'plan',
	      plan: 0
	    }), DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center'
	      }
	    }, !hide_free ? DIV({
	      className: 'button_wrapper'
	    }, BUTTON({
	      disabled: !current_user.logged_in && ((ref3 = this.local.forum_name) != null ? ref3.length : void 0) > 0 ? true : void 0,
	      className: 'big_button plan_button',
	      style: plan_button_style
	    }, giftSVG({
	      height: 28
	    }), SPAN({
	      style: {
	        marginLeft: 16
	      }
	    }, 'Create a Free Forum')), DIV({
	      className: 'additional_info'
	    }, 'Use as long as you want.', BR(null), 'No participation limits.', BR(null), 'Can be upgraded later.', BR(null), 'No card needed.')) : void 0, !hide_free && !hide_paid ? SPAN({
	      style: {
	        padding: '0 24px',
	        color: 'white',
	        fontWeight: 600
	      }
	    }, 'or') : void 0, !hide_paid ? DIV({
	      className: 'button_wrapper'
	    }, BUTTON({
	      disabled: !current_user.logged_in && ((ref4 = this.local.forum_name) != null ? ref4.length : void 0) > 0 ? true : void 0,
	      style: plan_button_style,
	      className: 'big_button plan_button',
	      onClick: (function(_this) {
	        return function(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, infinitySVG({
	      height: 15
	    }), SPAN({
	      style: {
	        marginLeft: 12
	      }
	    }, 'Create a Premium Forum')), DIV({
	      className: 'additional_info'
	    }, '$625 one-time fee to unlock data export, sign-up questions, and more.')) : void 0)), DIV({
	      style: {
	        textAlign: 'center',
	        padding: '110px 0 150px 0'
	      }
	    }, DIV({
	      style: {
	        padding: 0,
	        color: 'white',
	        fontSize: 14
	      }
	    }, 'By creating a forum, you are agreeing to the ', A({
	      treat_as_external_link: true,
	      style: {
	        color: 'white'
	      },
	      href: '/docs/legal/standard_hosting_terms',
	      target: '_blank'
	    }, 'Consider.it Forum Hosting Terms')), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, A({
	      href: '/pricing',
	      style: {
	        color: 'white',
	        fontWeight: 700,
	        textDecoration: 'underline',
	        marginLeft: !hide_free && !hide_paid ? -48 : void 0
	      }
	    }, 'More info on plans'))))) : void 0, DIV({
	      style: {
	        padding: '0px 10px'
	      }
	    }, !current_user.logged_in ? DIV({
	      style: {
	        paddingBottom: 80
	      }
	    }, H1({
	      className: 'main_callout condensed',
	      style: {
	        paddingTop: 24,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, 'To Create a Forum,'), DIV({
	      style: {
	        paddingBottom: 10,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'center',
	        fontSize: 20,
	        color: 'white',
	        fontWeight: 500
	      }
	    }, 'please introduce yourself first.'), this.drawAuth()) : void 0, current_user.logged_in && current_user.is_super_admin ? A({
	      style: {
	        opacity: .1,
	        marginTop: 40
	      },
	      onClick: logout
	    }, 'Logout') : void 0));
	  },
	  componentDidMount: function() {
	    this.setFocus();
	    return this.listenForSubmit();
	  },
	  componentDidUpdate: function() {
	    this.setFocus();
	    return this.listenForSubmit();
	  },
	  setFocus: function() {
	    if (!this.initialized && this.refs.forum_name) {
	      return setTimeout((function(_this) {
	        return function() {
	          _this.refs.forum_name.focus();
	          return _this.initialized = true;
	        };
	      })(this), 1);
	    }
	  },
	  listenForSubmit: function() {
	    if (!this.initialized && this.refs.create_forum_form) {
	      this.initialized = true;
	      return this.refs.create_forum_form.addEventListener('submit', (function(_this) {
	        return function() {
	          return typeof plausibleEvent === "function" ? plausibleEvent('New_Forum') : void 0;
	        };
	      })(this));
	    }
	  },
	  drawAuth: function() {
	    return Auth({
	      no_modal: true,
	      naked: true,
	      disallow_cancel: true,
	      primary_color: primary_color()
	    });
	  }
	});


/***/ },

/***/ 85:
/***/ function(module, exports) {

	var DEMO_AUTOPLAY_DELAY, VIDEO_FILE, caption_color, chapters, current_chapter_color, exit_demo, hover_caption_color;
	
	VIDEO_FILE = 'slowdeathstarcam';
	
	chapters = [
	  {
	    time: 6.0,
	    caption: "Pretend we're considering this proposal",
	    menu: "Consider an issue"
	  }, {
	    time: 5.0,
	    caption: "Consider.it helps us analyze its tradeoffs",
	    menu: "Analyze tradeoffs"
	  }, {
	    time: 8.5,
	    caption: "Each thought becomes a Pro or Con point",
	    menu: "Analyze tradeoffs"
	  }, {
	    time: 7.0,
	    caption: "We can learn from our peers",
	    menu: "Learn from peers"
	  }, {
	    time: 4.0,
	    caption: "...and even build from them!",
	    menu: "Learn from peers"
	  }, {
	    time: 11.0,
	    caption: "Weigh the tradeoffs on a slider",
	    menu: "Slide overall opinion"
	  }, {
	    time: 4.5,
	    caption: "Now let's share our opinion",
	    menu: "Slide overall opinion"
	  }, {
	    time: 4.5,
	    caption: "Behold: what people think, and why!",
	    menu: "See what the group thinks"
	  }, {
	    time: 4.0,
	    caption: "A histogram shows the spectrum of opinions",
	    menu: "Spectrum of opinion"
	  }, {
	    time: 4.0,
	    caption: "Points are ranked by importance to the group",
	    menu: "Top tradeoffs"
	  }, {
	    time: 8.5,
	    caption: "Now explore patterns of thought!",
	    menu: "Explore patterns of thought"
	  }, {
	    time: 6.0,
	    caption: "Learn the reservations of opposers",
	    menu: "Explore patterns of thought"
	  }, {
	    time: 12.5,
	    caption: "Inspect a peer's opinion",
	    menu: "Inspect a peer’s opinion"
	  }, {
	    time: 8.0,
	    caption: "See who resonates with the top Pro",
	    menu: "Inspect a peer’s opinion"
	  }, {
	    time: 4.0,
	    caption: "Focus on a single point",
	    menu: "Focus & discuss a single point"
	  }, {
	    time: 11.0,
	    caption: "...and discuss its implications",
	    menu: "Focus & discuss a single point"
	  }, {
	    time: 0.0,
	    caption: "Those are the basics! Learn more below",
	    menu: "Focus & discuss a single point"
	  }
	];
	
	DEMO_AUTOPLAY_DELAY = 5000;
	
	hover_caption_color = primary_color();
	
	caption_color = "black";
	
	current_chapter_color = primary_color();
	
	exit_demo = function() {
	  var loc;
	  window.scrollTo(0, 0);
	  loc = fetch('location');
	  delete loc.query_params.play_demo;
	  return save(loc);
	};
	
	window.Video = ReactiveComponent({
	  displayName: "Video",
	  render: function() {
	    this.compact = SAAS_PAGE_WIDTH() < 1000;
	    this.video_width = this.compact ? Math.min(SAAS_PAGE_WIDTH(), WINDOW_WIDTH()) : Math.min(SAAS_PAGE_WIDTH(), WINDOW_WIDTH() - 320);
	    return DIV({
	      id: 'demo',
	      style: {
	        position: 'relative',
	        backgroundColor: 'white',
	        minHeight: window.innerHeight,
	        paddingTop: 20
	      }
	    }, this.drawCaptions(), DIV({
	      style: {
	        paddingTop: 10
	      }
	    }, this.drawVideo(), !this.compact ? this.drawChapterMenu() : void 0), BUTTON({
	      style: {
	        position: 'absolute',
	        cursor: 'pointer',
	        right: 40,
	        top: 40,
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: exit_demo,
	      onKeyPress: function(e) {
	        if (e.which === 13 || e.which === 32) {
	          e.preventDefault();
	          return exit_demo();
	        }
	      }
	    }, SVG({
	      style: {
	        cursor: 'pointer'
	      },
	      viewBox: "0 0 64 64",
	      width: 24,
	      height: 24
	    }, PATH({
	      d: "M62,52c0,5.5-4.5,10-10,10H12C6.5,62,2,57.5,2,52V12C2,6.5,6.5,2,12,2h40c5.5,0,10,4.5,10,10V52z",
	      fill: seattle_salmon
	    }), PATH({
	      fill: "#fff",
	      d: "M50 21.2 42.8 14 32 24.8 21.2 14 14 21.2 24.8 32 14 42.8 21.2 50 32 39.2 42.8 50 50 42.8 39.2 32z"
	    }))));
	  },
	  drawVideo: function() {
	    var asset_path, format;
	    return VIDEO({
	      alt: "Video demo",
	      preload: "auto",
	      loop: true,
	      autoPlay: false,
	      ref: "video",
	      controls: this.props.playing,
	      style: {
	        position: 'relative',
	        width: this.video_width,
	        margin: 'auto',
	        left: !this.compact ? 160 : 10,
	        height: this.video_width * 1080 / 1920
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['mp4', 'webm'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        format = ref[i];
	        asset_path = asset("product_page/" + VIDEO_FILE + "." + format);
	        if ((asset_path != null ? asset_path.length : void 0) > 0) {
	          results.push(SOURCE({
	            key: format,
	            src: asset_path,
	            type: "video/" + format
	          }));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })());
	  },
	  drawCaptions: function() {
	    var chapter;
	    chapter = fetch("video_chapter");
	    return DIV({
	      style: _.extend({}, h1, {
	        fontWeight: 400,
	        whiteSpace: 'nowrap',
	        paddingBottom: 5,
	        position: 'relative',
	        zIndex: 1,
	        width: this.video_width - 1,
	        textAlign: 'center',
	        left: this.compact ? 10 : 140,
	        fontSize: !this.compact ? h1.fontSize : 24
	      })
	    }, DIV({
	      style: {
	        height: 70,
	        color: this.props.playing ? primary_color() : void 0
	      }
	    }, chapter.caption), SVG({
	      height: 10,
	      width: 60,
	      style: {
	        position: 'absolute',
	        left: '50%',
	        marginLeft: -60 / 2,
	        bottom: -0
	      }
	    }, POLYGON({
	      points: "0,0 30,10 60,0",
	      fill: primary_color()
	    }), POLYGON({
	      points: "0,-1 30,9 60,-1",
	      fill: 'white'
	    })));
	  },
	  drawChapterMenu: function() {
	    var chapter, current_chapter, idx, menu;
	    current_chapter = fetch("video_chapter");
	    return UL({
	      style: {
	        position: 'absolute',
	        top: 100,
	        left: 5,
	        listStyle: 'none',
	        width: 120,
	        textAlign: 'right'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = _.uniq((function() {
	        var j, len, results1;
	        results1 = [];
	        for (j = 0, len = chapters.length; j < len; j++) {
	          chapter = chapters[j];
	          results1.push(chapter.menu);
	        }
	        return results1;
	      })());
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        menu = ref[idx];
	        results.push((function(_this) {
	          return function(menu) {
	            var highlighted;
	            highlighted = menu === current_chapter.menu;
	            return LI({
	              key: idx,
	              onMouseEnter: function() {
	                _this.local.hover_chapter = menu;
	                return save(_this.local);
	              },
	              onMouseLeave: function() {
	                _this.local.hover_chapter = null;
	                return save(_this.local);
	              },
	              onClick: function() {
	                var c, chapter_time, controls, j, len1, new_chapter, v;
	                v = _this.refs.video;
	                chapter = fetch("video_chapter");
	                controls = fetch('video_controls');
	                chapter_time = 0;
	                new_chapter = null;
	                for (idx = j = 0, len1 = chapters.length; j < len1; idx = ++j) {
	                  c = chapters[idx];
	                  if (c.menu === menu) {
	                    new_chapter = c;
	                    break;
	                  }
	                  chapter_time += c.time;
	                }
	                v.currentTime = chapter_time;
	                controls.value = chapter_time / v.duration;
	                chapter.caption = new_chapter != null ? new_chapter.caption : void 0;
	                chapter.menu = new_chapter != null ? new_chapter.menu : void 0;
	                save(controls);
	                return save(chapter);
	              },
	              style: {
	                color: (highlighted || _this.local.hover_chapter === menu) ? current_chapter_color : 'black',
	                fontSize: 14,
	                fontWeight: highlighted ? 700 : 300,
	                padding: '10px 0',
	                cursor: 'pointer'
	              }
	            }, menu);
	          };
	        })(this)(menu));
	      }
	      return results;
	    }).call(this));
	  },
	  componentDidUpdate: function() {
	    return this.attachToVideo();
	  },
	  componentDidMount: function() {
	    this.attachToVideo();
	    return this.startVideo();
	  },
	  startVideo: function() {
	    var controls, e, video;
	    controls = fetch('video_controls');
	    controls.playing = true;
	    controls.value = 0;
	    try {
	      video = this.refs.video;
	      video.currentTime = 0;
	      video.play();
	    } catch (error) {
	      e = error;
	      console.error(e);
	      setTimeout((function(_this) {
	        return function() {
	          return _this.startVideo();
	        };
	      })(this), 500);
	    }
	    this.local.ready = true;
	    this.local.playing = true;
	    save(controls);
	    return save(this.local);
	  },
	  attachToVideo: function() {
	    var v;
	    v = this.refs.video;
	    if (this.v !== v) {
	      this.v = v;
	      return v.addEventListener('timeupdate', function(ev) {
	        var c, chapter, chapter_time, controls, i, idx, len, new_chapter;
	        chapter = fetch("video_chapter");
	        controls = fetch('video_controls');
	        chapter_time = 0;
	        for (idx = i = 0, len = chapters.length; i < len; idx = ++i) {
	          c = chapters[idx];
	          if (v.currentTime < chapter_time + c.time || idx === chapters.length - 1) {
	            new_chapter = c;
	            break;
	          }
	          chapter_time += c.time;
	        }
	        controls.value = v.currentTime / v.duration;
	        save(controls);
	        if (chapter.caption !== (new_chapter != null ? new_chapter.caption : void 0)) {
	          chapter.caption = new_chapter.caption;
	          chapter.menu = new_chapter.menu;
	          return save(chapter);
	        }
	      }, false);
	    }
	  }
	});


/***/ },

/***/ 86:
/***/ function(module, exports) {

	var Example, ExampleTabs, cases, get_example, set_example;
	
	get_example = function() {
	  var id, loc, parts;
	  loc = fetch('location');
	  parts = loc.url.split('/');
	  id = parts.length < 3 ? 'seattle' : parts[parts.length - 1];
	  if (id === 'public_engagement') {
	    id = 'seattle';
	  } else if (id === 'strategic_planning') {
	    id = 'wsffn';
	  } else if (id === 'decentralized_decisions') {
	    id = 'dao';
	  } else if (id === 'community_visioning') {
	    id = 'aina';
	  }
	  return cases[id];
	};
	
	set_example = function(example) {
	  var loc;
	  loc = fetch('location');
	  loc.url = "/examples/" + (example["class"] || example.id);
	  return save(loc);
	};
	
	window.ExamplesPage = ReactiveComponent({
	  displayName: 'LandingPage',
	  render: function() {
	    var active_example;
	    active_example = get_example();
	    return DIV({
	      style: {
	        paddingTop: 60
	      }
	    }, ExampleTabs({
	      examples: [
	        {
	          "case": cases.seattle,
	          label: 'Public Engagement'
	        }, {
	          "case": cases.wsffn,
	          label: 'Strategic Planning'
	        }, {
	          "case": cases.aina,
	          label: 'Community Visioning'
	        }, {
	          "case": cases.dao,
	          label: 'Decentralized Decisions'
	        }
	      ]
	    }), Example({
	      "case": active_example
	    }));
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      className: 'main_callout'
	    }, "What is your need for a dialogue?"));
	  }
	});
	
	styles += "[data-widget=\"ExampleTabs\"] {\n  width: 100%;\n  z-index: 2;\n  position: relative;\n  top: 2px;\n}\n\n[data-widget=\"ExampleTabs\"] .example_tab {\n  display: inline-block;\n  font-size: " + (responsive_css_rule({
	  min_size: 18,
	  max_size: 22,
	  min_vw: 980,
	  max_vw: 1100
	})) + ";\n  font-weight: 400;\n  padding: 14px 30px 4px 30px;\n  color: white;\n  cursor: pointer;\n  position: relative;\n}\n\n@media (max-width: 760px) {\n  [data-widget=\"ExampleTabs\"] {\n    margin-bottom: 24px;\n  }\n}\n";
	
	ExampleTabs = ReactiveComponent({
	  displayName: 'ExampleTabs',
	  render: function() {
	    var active_example, example, examples;
	    active_example = get_example();
	    examples = this.props.examples;
	    return DIV(null, UL({
	      role: 'tablist',
	      style: {
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'left',
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = examples.length; i < len; i++) {
	        example = examples[i];
	        results.push((function(_this) {
	          return function(example) {
	            var TAG, current;
	            current = example["case"] === active_example;
	            TAG = current ? H1 : DIV;
	            return LI({
	              tabIndex: 0,
	              role: 'tab',
	              className: 'condensed example_tab',
	              style: {
	                backgroundColor: current ? example["case"].color : void 0,
	                opacity: !current ? 0.3 : void 0
	              },
	              'aria-controls': 'active_example',
	              'aria-selected': current,
	              onMouseEnter: function() {
	                if (get_example() !== example["case"].id) {
	                  _this.local.hovering = example["case"];
	                  return save(_this.local);
	                }
	              },
	              onMouseLeave: function() {
	                _this.local.hovering = null;
	                return save(_this.local);
	              },
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.currentTarget.click();
	                  return e.preventDefault();
	                }
	              },
	              onClick: function() {
	                set_example(example["case"]);
	                return document.activeElement.blur();
	              }
	            }, TAG({
	              style: {
	                fontWeight: 400,
	                color: 'white'
	              }
	            }, example.label));
	          };
	        })(this)(example));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	styles += "[data-widget=\"Example\"] {\n  position: relative;\n  padding-bottom: 160px;\n}\n\n[data-widget=\"Example\"] .example_container {\n  position: relative;\n  z-index: 1;\n  padding-top: 56px;\n}\n\n[data-widget=\"Example\"] .example_heading {\n  display: flex;\n  padding-top: 48px;\n  margin: auto;\n}\n\n\n[data-widget=\"Example\"] .metrics_container {\n  flex: 0;\n  display: flex;\n  padding-top: 24px;\n  color: white;\n  flex-direction: column;\n}\n\n[data-widget=\"Example\"] .metric {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n[data-widget=\"Example\"] .metric .quantity {\n  font-size: 36px;\n  line-height: 1;\n  font-weight: 600;\n}\n\n[data-widget=\"Example\"] .metric .measurable {\n  font-size: 14px;\n  font-weight: 500\n  white-space: nowrap;\n}\n\n[data-widget=\"Example\"] .screen_wrapper {\n  flex: 1;\n  width: calc(var(--SAAS_PAGE_WIDTH) - 180px);\n}\n\n@media (max-width: 1014px) {\n  [data-widget=\"Example\"] .example_container {\n    padding-top: 32px;\n  }\n  \n  [data-widget=\"Example\"] .example_heading {\n    flex-direction: column;\n    padding-top: 8px;\n  }\n  [data-widget=\"Example\"] .metrics_container {\n    flex-direction: row;\n    justify-content: center;\n  }\n  [data-widget=\"Example\"] .metric {\n    padding: 0 16px;\n  }\n  [data-widget=\"Example\"] .metric .quantity {\n    font-size: 36px;\n  }\n  [data-widget=\"Example\"] .screen_wrapper {\n    width: var(--SAAS_PAGE_WIDTH);\n  }\n\n\n}\n@media (max-width: 500px) {\n  [data-widget=\"Example\"] .metric .quantity {\n    font-size: 26px;\n  }\n}\n\n@media (min-width: 1014px) {\n  [data-widget=\"Example\"] .screen_wrapper {\n    margin-left: 60px;\n  }\n}\n\n[data-widget=\"Example\"] .details_label {\n  font-size: 32px;\n  color: white;\n  padding: 12px 24px;\n}\n\n[data-widget=\"Example\"] .details_wrapper {\n  background-color: rgba(245,245,245,.96);\n  box-shadow: 0 1px 2px rgba(0,0,0,.2);\n  padding: 54px 68px 64px 68px;\n  border-radius: 8px;\n  width: var(--SAAS_PAGE_WIDTH);\n}\n\n[data-widget=\"Example\"] .details_body {\n  display: flex;\n  flex-direction: row; \n}\n\n[data-widget=\"Example\"] .details_testimonial {\n  flex: 1;\n  position: relative;\n  top: -32px;\n}\n\n[data-widget=\"Example\"] .details_description {\n  flex: 1;\n  max-width: 600;\n  padding-right: 40px;\n}\n \n@media (max-width: 570px) {\n  [data-widget=\"Example\"] .details_wrapper {\n    padding: 24px 18px 42px 30px;\n  }\n\n}\n\n@media (max-width: 614px) {\n  [data-widget=\"Example\"] .details_wrapper {\n    width: 100vw;\n  }\n}\n\n\n@media (max-width: 1014px) {\n\n  [data-widget=\"Example\"] .details_label {\n    font-size: 22px;\n  }\n\n  [data-widget=\"Example\"] .details_body {\n    flex-direction: column; \n  }\n\n\n  [data-widget=\"Example\"] .details_testimonial {\n    top: 24px;\n  }\n\n}\n";
	
	Example = ReactiveComponent({
	  displayName: 'Example',
	  render: function() {
	    var ex, idx, link, m;
	    ex = this.props["case"];
	    return DIV({
	      key: ex.id,
	      id: 'active_example',
	      style: {
	        background: ex.background
	      }
	    }, A({
	      name: ex.id
	    }), DIV({
	      className: 'example_container'
	    }, DIV({
	      style: {
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto'
	      }
	    }, H2({
	      className: 'condensed main_callout'
	    }, ex.heading), DIV({
	      className: 'example_heading'
	    }, DIV({
	      className: 'metrics_container'
	    }, (function() {
	      var i, len, ref, results;
	      ref = ex.metrics;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        m = ref[idx];
	        if (WINDOW_WIDTH() < 414 && idx === 1 && ex.metrics.length > 2) {
	          continue;
	        }
	        results.push(DIV({
	          className: 'metric'
	        }, DIV({
	          className: 'quantity'
	        }, m.quantity), DIV({
	          className: 'measurable'
	        }, m.metric)));
	      }
	      return results;
	    })()), DIV({
	      className: 'screen_wrapper'
	    }, DIV({
	      style: {
	        marginTop: 0
	      }
	    }, A({
	      key: ex.browser_loc,
	      href: ex.browser_loc,
	      target: '_blank',
	      style: {
	        textDecoration: 'none'
	      }
	    }, ex.screen('100%')))))), DIV({
	      className: 'details_label',
	      style: {
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto'
	      }
	    }, 'Details:'), DIV({
	      className: 'details_wrapper',
	      style: {
	        margin: 'auto'
	      }
	    }, H3({
	      className: 'bold_callout'
	    }, ex.extra_heading), DIV({
	      className: 'details_body'
	    }, DIV({
	      className: 'details_description'
	    }, DIV({
	      className: 'embedded',
	      dangerouslySetInnerHTML: {
	        __html: ex.story
	      }
	    }), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, "Explore at", ex.links.length === 1 ? [
	      ' ', A({
	        href: ex.links[0],
	        target: '_blank',
	        style: {
	          textDecoration: 'underline',
	          padding: "12px 8px"
	        }
	      }, ex.links[0]), ex === cases.wsffn ? DIV({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, '(their board-only forum is private)') : void 0
	    ] : [
	      ':', UL({
	        style: {
	          listStyle: 'none'
	        }
	      }, (function() {
	        var i, len, ref, results;
	        ref = ex.links;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          link = ref[i];
	          results.push(LI({
	            style: {}
	          }, A({
	            href: link,
	            target: '_blank',
	            style: {
	              textDecoration: 'underline',
	              color: '#007BC6',
	              fontWeight: 500,
	              padding: "6px 8px",
	              display: 'block'
	            }
	          }, link)));
	        }
	        return results;
	      })())
	    ])), DIV({
	      className: 'details_testimonial'
	    }, TestimonialGrid({
	      testimonials: [ex.testimonial],
	      top: true,
	      italic: true,
	      hide_full: true
	    }))))));
	  }
	});
	
	cases = {};
	
	cases.seattle = {
	  id: 'seattle',
	  "class": 'public_engagement',
	  color: '#B4589D',
	  background: '#B4589D',
	  heading: 'City of Seattle transforms controversial topic into productive discussion',
	  example_text: '<b>City of Seattle</b> uses Consider.it to engage residents about its affordable housing crisis',
	  browser_loc: 'https://seattle2035-key-changes.consider.it/Housing',
	  alt: 'Residents engage with the City of Seattle about a proposed housing affordability policy.',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.seattle.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: responsive_css_rule({
	          min_size: 9,
	          max_size: 32,
	          min_vw: 320,
	          max_vw: 1165
	        }),
	        fontWeight: 500,
	        margin: '30px auto 0px auto',
	        textAlign: 'center',
	        maxWidth: 800
	      }
	    }, 'Increase the diversity of housing types in lower density residential zones'), IMG({
	      alt: cases.seattle.alt,
	      src: asset('product_page/seattle_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '8,000+',
	      metric: 'opinions given'
	    }, {
	      quantity: '1,500+',
	      metric: 'comments'
	    }, {
	      quantity: '0',
	      metric: 'personal attacks'
	    }
	  ],
	  extra_heading: 'Civil public dialogue on contentious issues.',
	  story: "<p>Seattle is booming. Affordable housing is vanishing.</p>\n<p>The City of Seattle launched an <a href='https://www.seattle.gov/hala'>ambitious plan</a> to dramatically increase the supply of affordable housing.</p>\n<p>Consider.it is helping Seattle engage local residents in developing the plan. Every resident has the opportunity to provide feedback on how the plan will impact them.</p>\n<p>The structure of the Consider.it forum has encouraged civil dialogue. Neighbors are learning from each other. Neighbors are participating in building a better city. The feedback City staff receive is higher quality than other online sources, and many public meetings.</p>",
	  links: ['https://hala.consider.it', 'https://seattle2035-key-changes.consider.it', 'https://engageseattle.consider.it', 'https://yvyc.consider.it', 'https://nsf.consider.it'],
	  testimonial: testimonials.susie
	};
	
	cases.wsffn = {
	  id: 'wsffn',
	  "class": 'strategic_planning',
	  background: 'linear-gradient(143deg, #9BA43D 35%, #7D8928 100%)',
	  color: '#9BA43D',
	  heading: 'Statewide non-profit makes strategic plan for a fraction of the cost of a traditional process',
	  example_text: 'statewide non-profit made strategic plan for a fraction of the cost of a traditional process',
	  browser_loc: 'https://wsffn.consider.it',
	  alt: 'Stakeholders of the non-profit engage about key changes in proposed strategic plan.',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.wsffn.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, IMG({
	      alt: cases.wsffn.alt,
	      src: asset('product_page/wsffn_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '40',
	      metric: 'stakeholders'
	    }, {
	      quantity: '$4,000',
	      metric: 'tech + consulting'
	    }, {
	      quantity: '1',
	      metric: 'adopted plan'
	    }
	  ],
	  extra_heading: 'Lightweight strategic planning on a tight budget.',
	  story: "<p>Russ Lehman had a problem. He had just been hired as the director of the Washington Sustainable Food and Farming Network. WSFFN needed a new strategic plan, including a new name. And he needed to engage his members across the state in vetting and ultimately supporting the changes. All on a shoe-string budget.</p>\n<p>Russ set up a Consider.it forum and gathered feedback on the core points of the new plan over several weeks. Russ could now see at a glance points of agreement amongst stakeholders, as well as sticking points that he'd have to navigate.</p>\n<p>With newfound confidence, Russ drafted a full plan and proposed it to the board via a private Consider.it forum. The board used Consider.it to refine and ultimately adopt the new plan. Now they are using Consider.it to identify a new organization name.</p> \n<p>Consider.it helped get the organization pointed in the same direction and helped all stakeholders feel they were heard.</p>\n<p><b>Total cost</b>: $4k.</p>",
	  links: ['https://wsffn.consider.it'],
	  testimonial: testimonials.russ
	};
	
	cases.dao = {
	  id: 'dao',
	  "class": 'decentralized_decisions',
	  background: 'linear-gradient(141deg, #348AC7 35%, #7474BF 100%)',
	  color: '#348AC7',
	  heading: 'Worldwide decentralized network deliberates how to spend $150m',
	  example_text: 'Worldwide decentralized internet community deliberated how to spend $150m',
	  alt: "Decentralized internet community discusses a proposal.",
	  browser_loc: 'https://dao.consider.it/temporary-moratorium-on-the-dao-security-issues',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.dao.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: Math.min(32, Math.round(32 * WINDOW_WIDTH() / 1165)),
	        fontWeight: 500,
	        margin: '30px auto 20px auto',
	        textAlign: 'center',
	        maxWidth: 800
	      }
	    }, 'Temporary moratorium for security audit'), IMG({
	      alt: cases.dao.alt,
	      src: asset('product_page/dao_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '10,000+',
	      metric: 'opinions given'
	    }, {
	      quantity: '1,500+',
	      metric: 'participants'
	    }, {
	      quantity: '400+',
	      metric: 'ideas deliberated'
	    }
	  ],
	  extra_heading: 'Make decisions at scale, without hierarchy.',
	  story: "<p>The DAO was a prominent attempt to create a decentralized cooperative organization existing entirely on the internet. It set records in raising $150m of crowdfunding from thousands of individuals.</p> \n<p>The DAO had many challenges to overcome as an unprecedented social experiment. The community adopted Consider.it to help address one of these problems: aggregating and gauging community support about (1) what to invest in and (2) how to self-govern. Consider.it delivered: it became the community's primary forum for deliberating ideas and gauging community sentiment. </p>",
	  links: ['https://dao.consider.it'],
	  testimonial: testimonials.auryn
	};
	
	cases.aina = {
	  id: 'aina',
	  "class": 'community_visioning',
	  color: '#517ecb',
	  background: '#517ecb',
	  heading: 'Native Hawaiians lead effort to create a new vision for the islands in the space created by pandemic',
	  browser_loc: 'https://ainaalohafutures.consider.it/should-we-support-a-proposal-to-require-students-from-kindergarten-through-college-to-engage-i-rethinking-education-15168',
	  alt: 'Hawaiian community deliberates an idea about helping kids learn financial literacy.',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.aina.browser_loc,
	      width: width
	    }, IMG({
	      alt: cases.aina.alt,
	      src: asset('product_page/aina_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    }));
	  },
	  metrics: [
	    {
	      quantity: '400+',
	      metric: 'participants'
	    }, {
	      quantity: '3,000+',
	      metric: 'opinions given'
	    }, {
	      quantity: '150+',
	      metric: 'proposals'
	    }, {
	      quantity: '4+',
	      metric: 'bills influenced'
	    }
	  ],
	  extra_heading: 'Organizing for a regenerative future.',
	  story: "<p>\n<i>In Kēhau's words:</i>\n</p>\n<p>\n<a href=\"https://www.ainaalohafutures.com/\" target=\"_blank\">‘Āina Aloha Economic Futures</a> (AAEF) formed \nin response to the reset opportunity COVID provided us in Hawaiʻi. \nFrom spontaneous conversations among like-minded friends arose the idea to organize larger community \nconversations to set a new course for Hawaiʻi. We drafted \n<a href=\"https://www.ainaalohafutures.com/declaration\" target=\"_blank\">core values</a>, \nan <a href=\"https://www.ainaalohafutures.com/action-agenda\" target=\"_blank\">action agenda</a>, and \norganized <a href=\"https://www.ainaalohafutures.com/proposals\" target=\"_blank\">14 virtual community sessions</a> \nopen to all, which encouraged participants from across our \nisland chain to offer proposal sketches for policy changes and action initiatives.\n</p>\n\n<p>\nFollowing those sessions, Consider.it enabled us to continue a meaningful, productive one-month \nvirtual conversation about improving Hawaiʻi’s future.\nWith minimal guidance (a quick sharing of the Consider.it tutorial video), participants could \neasily offer their general level of agreement or disagreement regarding each proposal, share \nas many succinct pro/con comments as they wished regarding the proposals, read what \nothers had to say about the proposals, and adopt comments that resonated with them. \nIn real time, Consider.it created an intuitive pictorial graph of everyone’s level of \nsupport for a proposal, along with the underlying reasoning.\n</p>\n\n\n<p>All told, these Consider.it discussions involved \nnearly 500 participants who offered over 3,250 assessments of 192 proposals. Consider.it was the ideal tool \nfor us to facilitate this level of engagement. Anyone hoping to coordinate a community-wide conversation in a \nway that’s easy for participants and productive for organizers would greatly benefit from \nincluding Consider.it in their process. \n</p>\n\n<p>\nFurthermore, the Consider.it record of the robust online conversation we held has proven invaluable. We were able to develop a \n<a href=\"https://docs.google.com/document/d/1GJdVPM84fA0x9UBGpii0UjBgvEiV4INr2ES5FXmRpjk/edit\" target=\"_blank\">Policy Playbook</a> \nthat spotlighted salient points raised through the proposals and the Consider.it discussion of them. It helped AAEF garner \n<a href=\"https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0\" target=\"_blank\">many additional signatories</a> \nsupporting the effort, including three of four county mayors, three of four county councils, the largest private landowner \nin Hawai’i (Kamehameha Schools), the state government agency charged with overseeing Hawaiʻi’s visitor industry \n(Hawai’i Tourism Authority), and the University of Hawaiʻi John A. Burns School of Medicine.\n</p>\n\n\n<p>\nHawai’i state and county policy makers who each received a copy of the Playbook could readily see in our Consider.it \nrecord that a large community of engaged participants collectively arrived at the proposals offered in it, \naffording the Playbook a significant degree of impact. While AAEF did not actively lead the way in specific legislative \nbills this session, the overall momentum the AAEF Consider.it results produced played a contributing role in \nthe passage of bills relating to climate change mitigation, sustainable agriculture, raising the minimum wage, \nand protections for traditional water rights. \n</p>",
	  links: ['https://ainaalohafutures.consider.it/', 'https://www.ainaalohafutures.com/'],
	  testimonial: testimonials.kehau_example
	};


/***/ },

/***/ 87:
/***/ function(module, exports) {

	var BackToTopButton, nav;
	
	styles += "#back-to-top {\n  position: fixed;\n  right: 30px;\n  bottom: 30px;\n  height: 46px;\n  width: 46px;\n  z-index: 10;\n}\n";
	
	BackToTopButton = function() {
	  return BUTTON({
	    className: 'like_link',
	    "data-tooltip": "To top",
	    id: 'back-to-top',
	    onClick: function() {
	      return scrollTo(0, 0);
	    },
	    "aria-label": "Go back to the top of the page"
	  }, SPAN({
	    style: {
	      visibility: 'hidden',
	      fontSize: 0
	    }
	  }, 'Back to top'), SVG({
	    width: "100%",
	    height: "100%",
	    viewBox: "0 0 700 700"
	  }, PATH({
	    d: "m630 280c0-154.56-125.44-280-280-280s-280 125.44-280 280 125.44 280 280 280 280-125.44 280-280zm-539.28 0c0-142.8 116.48-259.28 259.28-259.28s259.28 116.48 259.28 259.28-116.48 259.28-259.28 259.28-259.28-116.48-259.28-259.28z",
	    stroke: 'black'
	  }), PATH({
	    d: "m360.64 416.64v-238l71.121 71.121c3.9219 3.9219 10.641 3.9219 14.559 0 3.9219-3.9219 3.9219-10.641 0-14.559l-96.32-96.324-96.32 96.32c-2.2383 2.2383-2.8008 4.4805-2.8008 7.2812s1.1211 5.0391 2.8008 7.2812c3.9219 3.9219 10.641 3.9219 14.559 0l71.121-71.121v238c0 5.6016 4.4805 10.641 10.641 10.641s10.641-4.4805 10.641-10.641z",
	    stroke: 'black'
	  })));
	};
	
	styles += ".footer_buttons {\n  position: relative;\n  margin: auto;\n  text-align: center;\n  top: -60px;\n  display: flex; \n  justify-content: center;\n}\n\n[data-url=\"/\"] .footer_buttons {\n  display: none;\n}\n\n.footer_nav {\n  margin-bottom: 35px;\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 866px; \n  margin: auto;\n  gap: 28px 28px;    \n}\n\n@media (min-width: 700px) {\n  .hide_on_desktop: {\n    display: none;\n  }\n}\n\n@media (max-width: 700px) {\n  .footer_nav {\n    padding-top: 36px;\n    flex-direction: column;\n  }\n\n  .hide_on_mobile {\n    display: none;\n  }\n}\n";
	
	window.ProductFooter = ReactiveComponent({
	  displayName: 'ProductFooter',
	  render: function() {
	    var draw_top_button, loc, ref, section, section_div;
	    loc = fetch('location');
	    section_div = function(section) {
	      var link;
	      return DIV(null, H3({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          color: '#000',
	          marginBottom: 10
	        }
	      }, section.label), UL({
	        style: {
	          listStyle: 'none'
	        }
	      }, (function() {
	        var i, len, ref, results;
	        ref = section.links;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          link = ref[i];
	          if (link != null) {
	            results.push(LI({
	              key: link.label,
	              style: {
	                marginBottom: 10
	              }
	            }, A({
	              href: link.link,
	              style: {
	                color: primary_color(),
	                textDecoration: 'underline',
	                fontSize: 16,
	                fontWeight: 500
	              }
	            }, link.label)));
	          }
	        }
	        return results;
	      })()));
	    };
	    draw_top_button = true || ((ref = loc.url) !== '/create_forum' && ref !== '/');
	    return FOOTER({
	      ref: 'footer',
	      id: 'footer',
	      style: {
	        paddingTop: loc.url === '/' || loc.url.indexOf('/examples') > -1 || loc.url === '/create_forum' || loc.url === '/contact' ? 0 : 140,
	        backgroundColor: loc.url !== '/' && loc.url.indexOf('/examples') < 0 ? 'white' : void 0,
	        bottom: 0,
	        left: 0,
	        zIndex: 2,
	        width: '100%',
	        position: 'relative',
	        marginTop: loc.url === '/contact' ? -47 : void 0
	      }
	    }, draw_top_button ? BackToTopButton() : void 0, DIV({
	      style: {
	        backgroundColor: "#F4F4F4",
	        borderTop: loc.url !== '/contact' ? "1px solid #" + 737373 : void 0,
	        padding: (loc.url === '/create_forum' || loc.url === '/contact' ? 64 : 20) + "px 0 15px 0",
	        position: 'relative',
	        zIndex: 3
	      }
	    }, DIV({
	      style: {
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto'
	      }
	    }, loc.url !== '/contact' ? DIV({
	      className: 'footer_buttons hide_on_mobile'
	    }, loc.url !== '/create_forum' ? A({
	      href: '/create_forum',
	      style: _.extend({}, big_button(), {
	        backgroundColor: loc.url === '/' || loc.url.indexOf('/examples') > -1 ? '#717171' : primary_color(),
	        maxWidth: 410,
	        flexGrow: 1
	      })
	    }, 'Create a Free Forum') : void 0, loc.url.indexOf('/examples') > -1 ? A({
	      href: '/contact?form=request_demo',
	      target: '_blank',
	      style: _.extend({}, big_button(), {
	        backgroundColor: '#717171',
	        marginLeft: 32,
	        maxWidth: 410,
	        flexGrow: 1
	      })
	    }, 'Request a demo') : loc.url !== '/create_forum' ? A({
	      className: 'hide_on_mobile',
	      href: demo_url(),
	      target: '_blank',
	      style: _.extend({}, big_button(), {
	        backgroundColor: '#717171',
	        marginLeft: 32,
	        maxWidth: 410,
	        flexGrow: 1
	      })
	    }, 'Try a Demo') : void 0) : void 0, loc.url !== '/' ? DIV({
	      className: 'footer_nav'
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = nav();
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        section = ref1[i];
	        results.push(DIV({
	          key: section.label,
	          style: {
	            textAlign: 'center',
	            flexGrow: 1
	          }
	        }, section_div(section)));
	      }
	      return results;
	    })()) : void 0, loc.url !== '/' ? DIV({
	      style: {
	        textAlign: 'center',
	        marginTop: 48
	      }
	    }, "Don't hesitate to ", A({
	      href: '/contact'
	    }, 'contact us'), '!', " Or learn more ", A({
	      href: '/contact#about_us'
	    }, 'about us'), '.') : void 0, DIV({
	      style: {
	        fontSize: 16,
	        textAlign: 'center',
	        marginTop: 48
	      }
	    }, DIV({
	      style: {
	        marginBottom: 18
	      }
	    }, A({
	      href: 'https://github.com/Considerit/ConsiderIt',
	      className: 'monospaced',
	      style: {
	        textDecoration: 'underline',
	        fontSize: 20
	      },
	      target: '_blank'
	    }, "Consider.it is Open Source", IMG({
	      alt: "github logo",
	      src: asset('product_page/github_logo.png'),
	      style: {
	        height: 18,
	        paddingLeft: 6,
	        verticalAlign: 'middle'
	      }
	    }))), DIV({
	      style: {
	        color: '#303030',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        flexWrap: 'wrap',
	        gap: "10px 20px",
	        margin: 'auto'
	      }
	    }, SPAN(null, DIV({
	      style: {
	        display: 'inline-block'
	      }
	    }, '© Consider.it. All rights reserved.'), A({
	      href: '/docs/legal/privacy_policy',
	      style: {
	        textDecoration: 'underline',
	        fontSize: 16,
	        paddingLeft: 6
	      }
	    }, 'Privacy'), ' and ', A({
	      href: '/docs/legal/terms_of_service',
	      style: {
	        textDecoration: 'underline',
	        fontSize: 16
	      }
	    }, 'Terms'), '.'), A({
	      href: 'mailto:hello@consider.it',
	      style: {
	        textDecoration: 'underline',
	        display: 'inline-block'
	      }
	    }, 'hello@consider.it'))))));
	  },
	  sizeFooter: function() {
	    var f, height;
	    f = fetch('footer');
	    height = this.refs.footer.offsetHeight;
	    if (height !== f.height) {
	      f.height = height;
	      return save(f);
	    }
	  },
	  componentDidMount: function() {
	    return this.sizeFooter();
	  },
	  componentDidUpdate: function() {
	    return this.sizeFooter();
	  }
	});
	
	nav = function() {
	  return [
	    {
	      label: 'How does it work?',
	      links: [
	        WINDOW_WIDTH() >= 900 ? {
	          label: 'Interactive Demo',
	          link: '/tour'
	        } : void 0, {
	          label: 'Feature Tour',
	          link: '/tour#features'
	        }, {
	          label: 'Try a Demo Forum',
	          link: demo_url()
	        }
	      ]
	    }, {
	      label: 'I want a forum for…',
	      links: [
	        {
	          label: 'Public Involvement',
	          link: '/examples/public_engagement'
	        }, {
	          label: 'Strategic Planning',
	          link: '/examples/strategic_planning'
	        }, {
	          label: 'Decentralized Organizing',
	          link: '/examples/decentralized_decisions'
	        }
	      ]
	    }, {
	      label: 'What will it cost?',
	      links: [
	        {
	          label: 'Plans',
	          link: '/pricing'
	        }, {
	          label: 'Consulting Services',
	          link: '/pricing#consulting'
	        }
	      ]
	    }
	  ];
	};


/***/ },

/***/ 88:
/***/ function(module, exports) {

	var HamburgerMenu, menu_options, nav_links;
	
	menu_options = nav_links = [
	  {
	    href: '/tour',
	    label: 'How it works',
	    short_label: 'Tour'
	  }, {
	    href: '/examples',
	    label: 'Examples'
	  }, {
	    href: '/pricing',
	    label: 'Pricing'
	  }, {
	    href: '/contact',
	    label: 'Contact'
	  }, {
	    href: '/create_forum',
	    label: 'Create a Forum',
	    short_label: 'Create Forum'
	  }
	];
	
	styles += "\n[data-widget=\"ProductHeader\"] .nav_menu_item {\n  font-weight: 400;\n  transition: border 500ms, color 500ms;\n}\n\n[data-widget=\"ProductHeader\"] .header_wrapper {\n  width: var(--SAAS_PAGE_WIDTH);\n  margin: auto;\n  transition: border 500ms;\n}\n\n[data-widget=\"ProductHeader\"] a.considerit_logo {\n  display: inline-block;\n  position: relative;\n  top: 12px;\n  height: 70px;\n}\n\n\n@media (max-width: 598px) {\n  [data-widget=\"ProductHeader\"] .header_wrapper {\n    padding-bottom: 2px;\n  }\n  [data-widget=\"ProductHeader\"] a.considerit_logo {\n    height: 40px;\n  }\n  [data-widget=\"ProductHeader\"] .nav_menu_container {\n    bottom: -12px;\n  }\n} \n\n@media (min-width: 1065px) {\n\n  [data-widget=\"ProductHeader\"] .nav_menu_container {\n    position: relative;\n    bottom: 38px;\n    display: block;\n    float: right;\n  }\n\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    padding: 14px 10px;\n    border: 1px solid transparent;\n    border-bottom: none;\n    text-transform: uppercase;\n    font-size: 18px;\n    margin-left: 25px;\n    text-decoration: none;\n\n  }\n\n  [data-widget=\"ProductHeader\"] .nav_menu_item:last-child {\n    padding: 14px 20px;\n    border-radius: 8px 8px 0px 0;\n  }\n\n}\n\n[data-widget=\"HamburgerMenu\"] {\n  display: none;\n}\n\n@media (max-width: 1064px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_container {\n    padding-top: 24px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 18px 28px;\n  }\n\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 653px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 550px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 500px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_container {\n    gap: 18px 18px;      \n  }\n}\n\n@media (max-width: 400px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 374px) {\n  [data-widget=\"ProductHeader\"] .nav_menu_item {\n    display: none;\n  }\n\n  [data-widget=\"HamburgerMenu\"] {\n    display: block;\n  }\n\n  [data-widget=\"ProductHeader\"] .nav_menu_container {\n    position: absolute;\n    bottom: 0px;\n    display: block;\n    left: calc(100% - 72px);\n    padding-top: 0;\n  }\n}\n\n\n\n";
	
	window.ProductHeader = ReactiveComponent({
	  displayName: "ProductHeader",
	  render: function() {
	    var base, color, current_user, dot_size, homepage, idx, loc, main_color, nav;
	    current_user = fetch("/current_user");
	    loc = fetch('location');
	    this.portrait_mobile = SAAS_PAGE_WIDTH() < 550;
	    if ((base = this.local).dot_x == null) {
	      base.dot_x = 0;
	    }
	    dot_size = this.portrait_mobile ? 6 : 10;
	    homepage = loc.url === '/';
	    color = fetch('colors');
	    main_color = color.primary_color === 'white' ? seattle_salmon : 'white';
	    return HEADER({
	      style: {
	        position: "relative",
	        margin: "0 auto 5px auto"
	      }
	    }, DIV({
	      className: 'header_wrapper'
	    }, DIV({
	      style: {
	        borderBottom: "1px solid " + main_color
	      }
	    }, A({
	      className: 'considerit_logo',
	      ref: 'logo',
	      href: '/'
	    }, drawLogo({
	      height: '100%',
	      main_text_color: main_color,
	      o_text_color: 'transparent',
	      box_shadow: true
	    }), SVG({
	      height: dot_size,
	      viewBox: "0 0 " + dot_size + " " + dot_size,
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      style: {
	        transition: 'left 500ms',
	        position: 'absolute',
	        left: this.local.dot_x - dot_size / 2,
	        zIndex: 2,
	        bottom: 0
	      }
	    }, G(null, CIRCLE({
	      style: {
	        transition: 'fill 500ms'
	      },
	      fill: main_color,
	      cx: dot_size / 2,
	      cy: dot_size / 2,
	      r: dot_size / 2
	    }))))), DIV({
	      className: 'nav_menu_container'
	    }, HamburgerMenu({
	      nav_links: nav_links
	    }), (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = nav_links.length; i < len; idx = ++i) {
	        nav = nav_links[idx];
	        results.push(A({
	          ref: nav.href,
	          key: idx,
	          className: "condensed nav_menu_item",
	          style: {
	            color: main_color,
	            borderColor: idx === nav_links.length - 1 ? main_color : void 0
	          },
	          href: nav.href
	        }, WINDOW_WIDTH() < 464 && nav.short_label ? nav.short_label : nav.label));
	      }
	      return results;
	    })())));
	  },
	  positionDot: function() {
	    var dot_x, link, logo, rect, url;
	    url = fetch('location').url;
	    if (url.indexOf('/examples') > -1) {
	      url = '/examples';
	    }
	    link = ReactDOM.findDOMNode(this.refs[url]);
	    logo = ReactDOM.findDOMNode(this.refs.logo).getBoundingClientRect();
	    if (link && WINDOW_WIDTH() > 374) {
	      rect = link.getBoundingClientRect();
	      dot_x = (rect.left - logo.left) + (rect.right - rect.left) / 2;
	    } else {
	      dot_x = (logo.right - logo.left) - (this.portrait_mobile ? 21 : 38);
	    }
	    if (dot_x !== this.local.dot_x) {
	      this.local.dot_x = dot_x;
	      return save(this.local);
	    }
	  },
	  componentDidMount: function() {
	    return this.positionDot();
	  },
	  componentDidUpdate: function() {
	    return this.positionDot();
	  }
	});
	
	HamburgerMenu = ReactiveComponent({
	  displayName: 'HamburgerMenu',
	  render: function() {
	    var close_menu, homepage, idx, link_color, main_color, option, set_focus, w;
	    w = SAAS_PAGE_WIDTH();
	    this.portrait_mobile = w < 550;
	    set_focus = (function(_this) {
	      return function(idx) {
	        if (idx == null) {
	          idx = 0;
	        }
	        _this.local.focus = idx;
	        save(_this.local);
	        return setTimeout(function() {
	          return ReactDOM.findDOMNode(_this.refs["menuitem-" + idx]).focus();
	        }, 0);
	      };
	    })(this);
	    close_menu = (function(_this) {
	      return function() {
	        document.activeElement.blur();
	        _this.local.menu = false;
	        return save(_this.local);
	      };
	    })(this);
	    homepage = false;
	    main_color = homepage ? seattle_salmon : 'white';
	    link_color = homepage ? seattle_salmon : primary_color();
	    return DIV({
	      key: 'hamburger',
	      ref: 'menu_wrap',
	      style: {
	        position: 'relative'
	      },
	      onTouchEnd: (function(_this) {
	        return function() {
	          _this.local.menu = !_this.local.menu;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function(e) {
	          _this.local.menu = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: close_menu,
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            var el;
	            el = document.querySelector('[data-widget="HamburgerMenu"]');
	            if (el && !$$.closest(document.activeElement, '[data-widget="HamburgerMenu"]')) {
	              _this.local.menu = false;
	              return save(_this.local);
	            }
	          }, 0);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32 || e.which === 27) {
	            close_menu();
	            return e.preventDefault();
	          } else if (e.which === 38 || e.which === 40) {
	            if (_this.local.focus == null) {
	              _this.local.focus = -1;
	            }
	            if (e.which === 38) {
	              _this.local.focus--;
	              if (_this.local.focus < 0) {
	                _this.local.focus = menu_options.length;
	              }
	            } else {
	              _this.local.focus++;
	              if (_this.local.focus > menu_options.length) {
	                _this.local.focus = 0;
	              }
	            }
	            set_focus(_this.local.focus);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, BUTTON({
	      tabIndex: 0,
	      'aria-haspopup': "true",
	      'aria-owns': "hamburger_popup",
	      "aria-label": "Open the navigation menu",
	      style: {
	        border: "1px solid " + main_color,
	        borderBottom: 'none',
	        borderRadius: '8px 8px 0px 0',
	        padding: '0px 6px',
	        position: 'relative',
	        backgroundColor: 'transparent'
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.menu = true;
	            save(_this.local);
	            if (_this.local.focus == null) {
	              set_focus(0);
	            }
	            e.preventDefault();
	            return e.stopPropagation();
	          }
	        };
	      })(this)
	    }, SVG({
	      height: this.portrait_mobile ? 32 : 44,
	      viewBox: "0 0 32 24",
	      width: this.portrait_mobile ? 32 : 44
	    }, PATH({
	      fill: main_color,
	      d: "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
	    }))), UL({
	      id: 'hamburger_popup',
	      role: "menu",
	      'aria-hidden': !this.local.menu,
	      hidden: !this.local.menu,
	      style: {
	        listStyle: 'none',
	        position: 'absolute',
	        left: 'auto',
	        right: !this.local.menu ? -9999 : 8,
	        margin: '-10px 0 0 -8px',
	        padding: "16px 14px 8px 8px",
	        backgroundColor: 'white',
	        textAlign: 'right',
	        zIndex: 999999,
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = menu_options.length; i < len; idx = ++i) {
	        option = menu_options[idx];
	        results.push(LI({
	          key: option.label,
	          role: "presentation"
	        }, A({
	          ref: "menuitem-" + idx,
	          role: "menuitem",
	          tabIndex: this.local.focus === idx ? 0 : -1,
	          href: option.href,
	          key: option.href,
	          style: {
	            color: this.local.focus === idx ? link_color : '#303030',
	            outline: 'none',
	            position: 'relative',
	            bottom: 8,
	            padding: '10px 0 10px 27px',
	            display: 'block',
	            whiteSpace: 'nowrap',
	            fontSize: 30,
	            borderBottom: idx !== menu_options.length - 1 ? '1px solid #eaeaea' : void 0,
	            textDecoration: 'none'
	          },
	          onClick: (function(_this) {
	            return function(e) {
	              return close_menu();
	            };
	          })(this),
	          onTouchEnd: (function(_this) {
	            return function(e) {
	              return close_menu();
	            };
	          })(this),
	          onKeyDown: (function(_this) {
	            return function(e) {
	              if (e.which === 13 || e.which === 32) {
	                e.currentTarget.click();
	                return e.preventDefault();
	              }
	            };
	          })(this),
	          onFocus: (function(_this) {
	            return function(idx) {
	              return function(e) {
	                if (_this.local.focus !== idx) {
	                  set_focus(idx);
	                }
	                return e.stopPropagation();
	              };
	            };
	          })(this)(idx),
	          onMouseEnter: (function(_this) {
	            return function(idx) {
	              return function() {
	                if (_this.local.focus !== idx) {
	                  return set_focus(idx);
	                }
	              };
	            };
	          })(this)(idx),
	          onBlur: (function(_this) {
	            return function(e) {
	              _this.local.focus = null;
	              return save(_this.local);
	            };
	          })(this),
	          onMouseLeave: (function(_this) {
	            return function(e) {
	              _this.local.focus = null;
	              save(_this.local);
	              return e.stopPropagation();
	            };
	          })(this)
	        }, option.label)));
	      }
	      return results;
	    }).call(this)));
	  }
	});


/***/ },

/***/ 89:
/***/ function(module, exports) {

	var UseCases, nav, section_div, use_cases;
	
	styles += "\n[data-widget=\"LandingPage\"] .demo_header_wrapper {\n  margin: auto;\n  position: relative;\n}\n\n[data-widget=\"LandingPage\"] .inspiring_text {\n  color: white;\n  max-width: 1050px;\n  margin: auto;\n  padding: 30px 24px 64px 24px;\n}\n\n[data-widget=\"LandingPage\"] .considerit_creates, [data-widget=\"LandingPage\"] .visual_summaries {\n  font-weight: 400;\n  color: white;\n  font-size: " + (responsive_css_rule({
	  min_size: 16,
	  max_size: 28,
	  min_vw: 605,
	  max_vw: 1000
	})) + ";\n}\n\n[data-widget=\"LandingPage\"] .inspiring_text .main_callout {\n  text-align: left;\n  text-transform: uppercase;\n  font-size: " + (responsive_css_rule({
	  min_size: 24,
	  max_size: 44,
	  min_vw: 548,
	  max_vw: 879
	})) + ";    \n}\n\n[data-widget=\"LandingPage\"] .visual_summaries {\n  text-align: right;\n}\n\n\n@media (max-width: 370px) {\n  [data-widget=\"LandingPage\"] .curious_block a {\n    font-size: 15px;\n    padding: 8px 8px;\n  }\n}\n\n@media (max-width: 652px) {\n  [data-widget=\"LandingPage\"] .inspiring_text {\n    padding: 30px 24px;\n  }\n  [data-widget=\"LandingPage\"] .considerit_creates {\n    display: none;\n  }\n  [data-widget=\"LandingPage\"] .inspiring_text .main_callout, [data-widget=\"LandingPage\"] .visual_summaries {\n    text-align: center;\n  }\n}\n\n@media (min-width: 653px) {\n  [data-widget=\"LandingPage\"] .demo_header_wrapper {\n    padding-top: 32px;\n  }\n  [data-widget=\"LandingPage\"] .inspiring_text .main_callout {\n    margin-left: 48px;\n  }\n  [data-widget=\"LandingPage\"] .considerit_creates, [data-widget=\"LandingPage\"] .visual_summaries {\n    font-style: italic;\n  }\n\n}\n\n\n@media (max-width: 878px) {\n\n  [data-widget=\"LandingPage\"] .curious_block a {\n    display: block;\n    text-transform: capitalize;\n  }\n  [data-widget=\"LandingPage\"] .curious_separator {\n    display: none;\n  }\n\n}\n\n@media (min-width: 652px) and (max-width: 1250px) {\n  [data-widget=\"LandingPage\"] .considerit_creates, [data-widget=\"LandingPage\"] .visual_summaries {\n    margin: 0 24px;\n  }\n}\n\n[data-widget=\"LandingPage\"] .sub_value_prop {\nfont-size: 16px;\nmargin: 0px auto 48px auto;\ntext-align: center;\npadding: 0 24px;\n} @media (max-width: 673px) [data-widget=\"LandingPage\"] .sub_value_prop {\nmargin-bottom: 8px;\n}\n";
	
	window.LandingPage = ReactiveComponent({
	  displayName: 'LandingPage',
	  render: function() {
	    var loc, w;
	    loc = fetch('location');
	    w = SAAS_PAGE_WIDTH();
	    return DIV({
	      style: {
	        color: 'white'
	      }
	    }, DIV({
	      className: 'demo_header_wrapper'
	    }, DIV({
	      className: 'inspiring_text'
	    }, H1({
	      className: 'condensed'
	    }, DIV({
	      className: 'considerit_creates'
	    }, 'Consider.it creates '), DIV({
	      className: 'main_callout'
	    }, w < 327 ? 'Civil & focused dialogue' : w < 1016 ? 'Civil and focused dialogue' : "CIVIL, ORGANIZED, AND FOCUSED ONLINE DIALOGUE"), DIV({
	      className: 'visual_summaries'
	    }, w < 605 ? ' Visual summaries of what your community thinks, and why.' : ' by visually summarizing what your community thinks and why'))), DIV({
	      style: {
	        textAlign: 'center',
	        position: 'relative',
	        zIndex: 1,
	        top: 8,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto'
	      }
	    }, Demo({
	      width: '100%',
	      src: 'overall-small-x264.mp4',
	      href: 'https://seattle2035-key-changes.consider.it',
	      alt: "The City of Seattle is one of many to trust Consider.it with their community engagement needs."
	    })), DIV({
	      dangerouslySetInnerHTML: {
	        __html: "<style>\n  .custom-shape-divider-bottom-1648926759 {\n      position: absolute;\n      bottom: 50px;\n      left: 0;\n      width: 100%;\n      overflow: hidden;\n      line-height: 0;\n      transform: rotate(180deg);\n  }\n\n  .custom-shape-divider-bottom-1648926759 svg {\n      position: relative;\n      display: block;\n      width: calc(131% + 1.3px);\n      height: 243px;\n      max-height: 243px;\n  }\n  @media (max-width: 999px) {\n    .custom-shape-divider-bottom-1648926759 svg {\n      height: calc(100vw / 1000 * 243);\n    }\n  }\n\n  .custom-shape-divider-bottom-1648926759 .shape-fill {\n      fill: #FFFFFF;\n  }\n\n</style>\n<div class=\"custom-shape-divider-bottom-1648926759\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 120\" preserveAspectRatio=\"none\">\n        <path d=\"M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z\" opacity=\".25\" class=\"shape-fill\"></path>\n        <path d=\"M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z\" opacity=\".5\" class=\"shape-fill\"></path>\n        <path d=\"M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z\" class=\"shape-fill\"></path>\n    </svg>\n</div>\n\n\n"
	      }
	    })), DIV({
	      style: {
	        backgroundColor: 'white',
	        color: 'black',
	        position: 'relative',
	        paddingTop: 50,
	        paddingBottom: 50,
	        marginTop: -50
	      }
	    }, ConversionAttempt({
	      backgroundColor: '#dc5f60'
	    }), DIV({
	      className: "sub_value_prop"
	    }, H2({
	      className: 'light_callout'
	    }, DIV(null, "Engage your Community "), DIV({
	      style: {
	        fontSize: 18,
	        fontWeight: 400
	      }
	    }, "Hear diverse voices, learn together, and gain buy-in."))), DIV({
	      style: {
	        position: 'relative',
	        zIndex: 2,
	        paddingBottom: 70,
	        color: 'black'
	      }
	    }, TestimonialGrid({
	      testimonials: [testimonials.kehau, testimonials.susie, testimonials.russ]
	    })), UseCases(), DIV({
	      style: {
	        fontSize: 16,
	        margin: '56px auto 0px auto',
	        textAlign: 'center',
	        padding: "0 12px"
	      }
	    }, H2({
	      className: 'light_callout'
	    }, "Want to start an engagement? ", DIV({
	      style: {
	        fontSize: 16,
	        fontWeight: 400
	      }
	    }, "It only takes a minute to create a forum and start a conversation."))), ConversionAttempt({
	      pages: ['create_forum', 'pricing']
	    }), DIV({
	      className: 'curious_block',
	      style: {
	        textAlign: 'center',
	        fontSize: 18,
	        padding: '0 24px'
	      }
	    }, "Curious about something else? ", BR(null), A({
	      href: conversion_pages().tour.url,
	      style: {
	        color: '#9e4444'
	      }
	    }, "Learn more about the product"), SPAN({
	      className: 'curious_separator',
	      dangerouslySetInnerHTML: {
	        __html: ",&nbsp;&nbsp;&nbsp;"
	      }
	    }), A({
	      href: conversion_pages().demo.url,
	      target: '_blank',
	      style: {
	        color: '#9e4444'
	      }
	    }, "play with a demo forum"), SPAN({
	      className: 'curious_separator',
	      dangerouslySetInnerHTML: {
	        __html: ",&nbsp;&nbsp;&nbsp;"
	      }
	    }), A({
	      href: conversion_pages().examples.url,
	      style: {
	        color: '#9e4444'
	      }
	    }, "browse cases"), SPAN({
	      dangerouslySetInnerHTML: {
	        __html: ",&nbsp;&nbsp;&nbsp;"
	      },
	      className: 'curious_separator'
	    }), A({
	      href: conversion_pages().about_us.url,
	      target: '_blank',
	      style: {
	        color: '#9e4444'
	      }
	    }, "about us"), SPAN({
	      dangerouslySetInnerHTML: {
	        __html: ",&nbsp;&nbsp; or&nbsp;&nbsp;"
	      },
	      className: 'curious_separator'
	    }), A({
	      href: conversion_pages().contact.url,
	      target: '_blank',
	      style: {
	        color: '#9e4444'
	      }
	    }, "contact us"), SPAN({
	      className: 'curious_separator'
	    }, "."))));
	  }
	});
	
	nav = [
	  {
	    label: 'How does it work?',
	    link: '/tour',
	    links: [
	      {
	        label: 'Starting your own forum',
	        link: '/tour'
	      }, {
	        label: 'features',
	        link: '/tour#features'
	      }, {
	        label: 'research findings',
	        link: '/tour#research'
	      }
	    ]
	  }, {
	    label: 'Show me cases!',
	    link: '/examples',
	    links: [
	      {
	        label: 'Strategic planning on a tight budget',
	        link: '/examples/strategic_planning'
	      }, {
	        label: 'civil public engagement',
	        link: '/examples/public_engagement'
	      }, {
	        label: 'decentralized community decision-making',
	        link: '/examples/decentralized_decisions'
	      }
	    ]
	  }, {
	    label: 'What will it cost?',
	    link: '/pricing',
	    links: [
	      {
	        label: 'Free and Customized tiers',
	        link: '/pricing'
	      }, {
	        label: 'consulting services',
	        link: '/pricing#consulting'
	      }, {
	        label: 'FAQ',
	        link: '/pricing#faq'
	      }
	    ]
	  }, {
	    label: 'I\'d like to talk',
	    link: '/contact',
	    links: [
	      {
	        label: 'Request a demo',
	        link: '/contact?form=request_demo'
	      }, {
	        label: 'general inquiry',
	        link: '/contact'
	      }
	    ]
	  }
	];
	
	section_div = function(section) {
	  var idx, link;
	  return DIV(null, H3({
	    className: 'main_callout',
	    style: {
	      paddingBottom: 10,
	      color: 'black',
	      textShadow: 'none'
	    }
	  }, A({
	    href: section.link,
	    className: 'condensed',
	    style: {
	      textDecoration: 'underline'
	    }
	  }, section.label)), UL({
	    style: {
	      listStyle: 'none'
	    }
	  }, (function() {
	    var i, len, ref, results;
	    ref = section.links;
	    results = [];
	    for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	      link = ref[idx];
	      results.push(LI({
	        style: {
	          textAlign: 'center',
	          opacity: .7,
	          display: 'inline'
	        }
	      }, A({
	        href: link.link,
	        style: {
	          textDecoration: 'underline',
	          fontSize: 18,
	          fontWeight: 400
	        }
	      }, link.label), idx < section.links.length - 1 ? ', ' : void 0));
	    }
	    return results;
	  })()));
	};
	
	styles += "[data-widget=\"Demo\"] .salient_video_controls {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  background-color: #534B4B;\n  opacity: .7;\n  padding: 0px 12px;\n  border-radius: 8px;\n  font-size: 24px;\n}\n\n@media (max-width: 780px) {\n  [data-widget=\"Demo\"] .salient_video_controls {\n    display: none;\n  }\n}\n";
	
	window.Demo = ReactiveComponent({
	  displayName: 'Demo',
	  render: function() {
	    var loc, props, watch_demo;
	    if (this.local.playing == null) {
	      this.local.playing = true;
	    }
	    loc = fetch('location');
	    props = this.props;
	    watch_demo = function() {
	      window.scrollTo(0, 0);
	      loc.query_params.play_demo = true;
	      return save(loc);
	    };
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, Webframe({
	      browser_loc: this.props.href,
	      width: "calc(props.width + 2px)",
	      dummy: props.width,
	      dummy2: this.local.playing
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, VIDEO({
	      ref: 'video',
	      preload: 'true',
	      loop: true,
	      autoPlay: true,
	      muted: true,
	      controls: true,
	      title: this.props.alt,
	      style: {
	        aspectRatio: "21/9",
	        width: props.width,
	        display: 'block'
	      }
	    }, SOURCE({
	      key: 'mp4',
	      src: asset("product_page/screencasts/" + this.props.src),
	      type: "video/mp4"
	    }), this.props.alt || "Your browser does not support the video element."), DIV({
	      className: "salient_video_controls"
	    }, BUTTON({
	      style: {
	        cursor: 'pointer',
	        backgroundColor: 'transparent',
	        border: 'none',
	        color: 'white',
	        width: 33,
	        display: 'inline-block'
	      },
	      title: this.local.playing ? 'Pause video demo' : 'Play video demo',
	      onClick: (function(_this) {
	        return function() {
	          return _this.toggleVideoPlay();
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return _this.toggleVideoPlay();
	          }
	        };
	      })(this)
	    }, !this.local.playing ? SPAN({
	      dangerouslySetInnerHTML: {
	        __html: '&#9658;'
	      }
	    }) : [
	      SPAN({
	        key: 'first',
	        dangerouslySetInnerHTML: {
	          __html: '&#10073'
	        }
	      }), SPAN({
	        key: 'second',
	        style: {
	          paddingLeft: 1
	        },
	        dangerouslySetInnerHTML: {
	          __html: '&#10073'
	        }
	      })
	    ]), BUTTON({
	      style: {
	        color: 'white',
	        marginLeft: 6,
	        display: 'inline-block',
	        cursor: 'pointer',
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontSize: 40,
	        lineHeight: '18px',
	        position: 'relative',
	        top: 1
	      },
	      title: 'Restart video demo',
	      onClick: (function(_this) {
	        return function() {
	          return _this.restart();
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return _this.restart();
	          }
	        };
	      })(this),
	      dangerouslySetInnerHTML: {
	        __html: '&#10226;'
	      }
	    })))));
	  },
	  toggleVideoPlay: function() {
	    var el;
	    el = this.refs.video;
	    if (this.local.playing) {
	      if (typeof el.pause === "function") {
	        el.pause();
	      }
	    } else {
	      if (typeof el.play === "function") {
	        el.play();
	      }
	    }
	    this.local.playing = !this.local.playing;
	    save(this.local);
	    return document.activeElement.blur();
	  },
	  restart: function() {
	    var el;
	    el = this.refs.video;
	    el.currentTime = 0;
	    return document.activeElement.blur();
	  },
	  componentDidMount: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this));
	  },
	  componentDidUpdate: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this));
	  }
	});
	
	window.Webframe = ReactiveComponent({
	  displayName: 'Webframe',
	  render: function() {
	    var ref, width;
	    width = this.props.width || 882;
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        borderRadius: 4,
	        boxShadow: '0 2px 8px rgba(0,0,0,.1)',
	        border: '1px solid #DADADA',
	        borderTop: 'none',
	        width: width,
	        margin: 'auto'
	      }
	    }, SVG({
	      viewBox: "0 0 882 26",
	      style: {
	        borderRadius: '4px 4px 0 0',
	        position: 'relative',
	        top: -1,
	        display: 'block'
	      },
	      dangerouslySetInnerHTML: {
	        __html: "<defs>\n    <linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"97.915338%\" id=\"linearGradient-1\">\n        <stop stop-color=\"#F6F4F6\" offset=\"0%\"></stop>\n        <stop stop-color=\"#D5D5D5\" offset=\"99.5416135%\"></stop>\n        <stop stop-color=\"#B7B6B7\" offset=\"100%\"></stop>\n    </linearGradient>\n    <rect id=\"path-2\" x=\"0\" y=\"0\" width=\"882\" height=\"25\" rx=\"0\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\">\n        <feOffset dx=\"0\" dy=\"-1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feComposite in=\"shadowOffsetOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowOffsetOuter1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\">\n        <feGaussianBlur stdDeviation=\"0.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur>\n        <feOffset dx=\"0\" dy=\"1\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-5\" x=\"0\" y=\"0\" width=\"361.581259\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-6\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-7\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-8\" x=\"0\" y=\"0.606608157\" width=\"16.4648609\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-9\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-10\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-11\" x=\"0\" y=\"0.606608157\" width=\"17.1105417\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-12\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-13\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <ellipse id=\"path-14\" cx=\"29.7013177\" cy=\"4.45706419\" rx=\"3.87408492\" ry=\"3.87196696\"></ellipse>\n    <mask id=\"mask-15\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.74393392\" fill=\"white\">\n        <use xlink:href=\"#path-14\"></use>\n    </mask>\n    <ellipse id=\"path-16\" cx=\"16.7877013\" cy=\"4.43125108\" rx=\"3.87408492\" ry=\"3.84615385\"></ellipse>\n    <mask id=\"mask-17\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.69230769\" fill=\"white\">\n        <use xlink:href=\"#path-16\"></use>\n    </mask>\n    <ellipse id=\"path-18\" cx=\"3.87408492\" cy=\"4.43125108\" rx=\"3.87408492\" ry=\"3.84615385\"></ellipse>\n    <mask id=\"mask-19\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.69230769\" fill=\"white\">\n        <use xlink:href=\"#path-18\"></use>\n    </mask>\n</defs>\n<g id=\"landing-page\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Desktop-HD-Copy-34\" transform=\"translate(-328.000000, -749.000000)\">\n        <g id=\"Safari\" transform=\"translate(328.000000, 750.000000)\">\n            <g id=\"background\">\n                <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-3)\" xlink:href=\"#path-2\"></use>\n                <use fill-opacity=\"0.6\" fill=\"url(#linearGradient-1)\" fill-rule=\"evenodd\" xlink:href=\"#path-2\"></use>\n                <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-2\"></use>\n            </g>\n            <!-- \n            <g id=\"New-Tab\" transform=\"translate(866.503660, 8.974359)\">\n                <rect id=\"background\" fill-opacity=\"0.5\" fill=\"#B6B6B6\" x=\"0\" y=\"0\" width=\"15.4963397\" height=\"16.025641\"></rect>\n                <path d=\"M7.74816984,7.69230769 L4.51976574,7.69230769 L4.51976574,8.33763552 L7.74816984,8.33763552 L7.74816984,11.5857856 L8.39385066,11.5857856 L8.39385066,8.33763552 L11.6222548,8.33763552 L11.6222548,7.69230769 L8.39385066,7.69230769 L8.39385066,4.48717949 L7.74816984,4.48717949 L7.74816984,7.69230769 Z M0.64568082,0 L15.4963397,0 L15.4963397,0.645327827 L0.64568082,0.645327827 L0.64568082,0 Z M0,0 L0.64568082,0 L0.64568082,15.376011 L0,15.376011 L0,0 Z\" id=\"Add\" fill=\"#7D7D7D\"></path>\n            </g>\n            -->\n\n\n            <g id=\"Search\" transform=\"translate(260.209370, 5.162623)\" style=\"" + (((ref = this.props.browser_loc) != null ? ref.length : void 0) > 0 ? '' : 'display:none') + "\">\n                <g id=\"background\">\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-6)\" xlink:href=\"#path-5\"></use>\n                    <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-5\"></use>\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-7)\" xlink:href=\"#path-5\"></use>\n                </g>\n                <path d=\"M352.865451,3.86914807 C351.055024,4.03175239 349.636164,5.55230111 349.636164,7.40406126 C349.636164,9.36428721 351.22611,10.9533643 353.187408,10.9533643 C355.148707,10.9533643 356.738653,9.36428721 356.738653,7.40406126 C356.738653,7.29529458 356.733758,7.18767059 356.724176,7.08139735 L356.075239,7.08139735 C356.086957,7.18733884 356.092972,7.29499793 356.092972,7.40406126 C356.092972,9.00788249 354.792107,10.3080365 353.187408,10.3080365 C351.58271,10.3080365 350.281845,9.00788249 350.281845,7.40406126 C350.281845,5.90900072 351.41226,4.67781842 352.865451,4.51771221 L352.865451,5.79162418 L356.09209,4.17742213 L352.865451,2.56322008 L352.865451,3.86914807 Z\" id=\"reload\" fill=\"#7E7E7E\"></path>\n                <text id=\"url\" font-family=\"HelveticaNeue, Helvetica Neue\" font-size=\"10\" font-weight=\"normal\" letter-spacing=\"-0.15384616\" fill=\"#000000\">\n                    <tspan x=\"19.6134701\" y=\"10.5641026\">" + this.props.browser_loc + "</tspan>\n                </text>\n            </g>\n            <g id=\"Back-+-Forward\" transform=\"translate(50.363104, 4.521597)\">\n                <g id=\"forward\" transform=\"translate(17.756223, 0.000000)\">\n                    <g id=\"background\">\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-9)\" xlink:href=\"#path-8\"></use>\n                        <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-8\"></use>\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-10)\" xlink:href=\"#path-8\"></use>\n                    </g>\n                    <g id=\"Icon\" transform=\"translate(6.779649, 4.190329)\" stroke=\"#DADADA\" stroke-width=\"1.5\" stroke-linecap=\"round\">\n                        <path d=\"M0.161420205,0.161331957 L3.425862,3.42398908\" id=\"Line\"></path>\n                        <path d=\"M0.161420205,6.69625979 L3.425862,3.43360266\" id=\"Line\"></path>\n                    </g>\n                </g>\n                <g id=\"back\">\n                    <g id=\"background\">\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-12)\" xlink:href=\"#path-11\"></use>\n                        <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-11\"></use>\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-13)\" xlink:href=\"#path-11\"></use>\n                    </g>\n                    <g id=\"Icon\" transform=\"translate(7.685212, 7.690329) scale(-1, 1) translate(-7.685212, -7.690329) translate(5.685212, 4.190329)\" stroke=\"#585858\" stroke-width=\"1.5\" stroke-linecap=\"round\">\n                        <path d=\"M0.161420205,0.161331957 L3.425862,3.42398908\" id=\"Line\"></path>\n                        <path d=\"M0.161420205,6.69625979 L3.425862,3.43360266\" id=\"Line\"></path>\n                    </g>\n                </g>\n            </g>\n            <g id=\"Close-+-Minimize-+-Full-Screen\" transform=\"translate(8.393851, 7.748236)\">\n                <use id=\"green\" stroke=\"#19B228\" mask=\"url(#mask-15)\" fill=\"#14CA34\" xlink:href=\"#path-14\"></use>\n                <use id=\"yellow\" stroke=\"#E3A300\" mask=\"url(#mask-17)\" fill=\"#FFC008\" xlink:href=\"#path-16\"></use>\n                <use id=\"red\" stroke=\"#E4453A\" mask=\"url(#mask-19)\" fill=\"#FF5F52\" xlink:href=\"#path-18\"></use>\n            </g>\n        </g>\n    </g>\n</g>"
	      }
	    }), this.props.children);
	  }
	});
	
	use_cases = [
	  {
	    title: 'Engaging the public ',
	    subtitle: 'to get focused feedback on proposals',
	    examples: [
	      {
	        img: 'logos/denver.svg',
	        example: 'https://denverclimateaction.consider.it',
	        img_dim: {
	          height: 62,
	          width: 217
	        },
	        color: '#C51100',
	        anchor: "Input on Climate Action Plan",
	        alt: "The City of Denver uses Consider.it to get public feedback on their Climate Action Plan."
	      }, {
	        img: 'logos/seattle-full.svg',
	        example: 'https://hala.consider.it',
	        img_dim: {
	          height: 43,
	          width: 230
	        },
	        color: '#007BC6',
	        anchor: "Housing Affordability dialogue",
	        alt: "The City of Seattle uses Consider.it to get public feedback on policies related to housing affordability."
	      }, {
	        img: 'logos/kauai.svg',
	        example: 'https://oedinnovationgrant.consider.it',
	        img_dim: {
	          height: 55,
	          width: 231
	        },
	        color: '#46315b',
	        anchor: "Innovation grant participatory budgeting",
	        alt: 'The Island of Kauai does participatory budgeting for its Innovation Grant challenge.'
	      }, {
	        img: 'logos/cambridge.png',
	        example: 'https://envisioncambridge.consider.it',
	        img_dim: {
	          height: 59,
	          width: 175
	        },
	        color: '#000000',
	        anchor: "Comprehensive Plan update",
	        alt: 'The City of Cambridge, Massachusetts engages the public on its comprehensive plan update.'
	      }
	    ]
	  }, {
	    title: 'Community ideation ',
	    subtitle: 'to tap the creativity of your community',
	    examples: [
	      {
	        img: 'logos/mozilla.svg',
	        example: 'https://internethealthreport.consider.it',
	        img_dim: {
	          height: 49,
	          width: 171
	        },
	        color: '#000',
	        anchor: "Community ideation about how to measure internet health",
	        alt: "The Mozilla Foundation engages its community about what it should measure to evaluate the health of the internet."
	      }, {
	        img: 'logos/aina.png',
	        example: 'https://ainaalohafutures.consider.it/',
	        img_dim: {
	          height: 51,
	          width: 231
	        },
	        color: '#2A4C7E',
	        anchor: "Towards a regenerative economic plan for Hawai’i",
	        alt: "Helping a native-led community effort to put forward a vision of a regenerative Hawai’i."
	      }, {
	        img: 'logos/dao.svg',
	        example: 'https://dao.consider.it',
	        img_dim: {
	          height: 56,
	          width: 183
	        },
	        color: '#D1170B',
	        anchor: "Open source cryptocurrency community governance",
	        alt: "Helping a large decentralized cryptocurrency project deliberate about proposals."
	      }, {
	        img: 'logos/beeminder.png',
	        example: 'https://beeminder.consider.it',
	        img_dim: {
	          height: 56,
	          width: 206
	        },
	        color: '#3a3a3c',
	        anchor: "Community-informed product direction",
	        alt: "Consider.it is being used by Beeminder to engage its community about development priorities."
	      }
	    ]
	  }, {
	    title: 'Align on a new strategy ',
	    subtitle: 'by engaging relevant stakeholders',
	    examples: [
	      {
	        img: 'logos/wadems.png',
	        example: 'https://newblueplan.consider.it',
	        img_dim: {
	          height: 47,
	          width: 233
	        },
	        color: '#0D4975',
	        anchor: "Participatory strategic planning",
	        alt: "The Democratic Party of Washington State uses Consider.it to help engage in participatory strategic planning."
	      }, {
	        img: 'logos/mozilla.svg',
	        example: 'https://mofo-impact-goal.consider.it',
	        img_dim: {
	          height: 49,
	          width: 171
	        },
	        color: '#000',
	        anchor: "Feedback on candidate impact statements to underpin a new strategy",
	        alt: "The Mozilla Foundation uses Consider.it to engage its community about the pillars of a strategic plan."
	      }, {
	        img: 'logos/wsffn.svg',
	        example: 'https://wsffn.consider.it',
	        img_dim: {
	          height: 74,
	          width: 232
	        },
	        color: '#6C7C00',
	        anchor: "Stakeholder engagement (board, donors, & farmers) on strategic direction",
	        alt: "A non-profit uses Consider.it to do stakeholder engagement for a new strategic plan."
	      }
	    ]
	  }, {
	    title: 'Doing something else ',
	    subtitle: 'that is unexpected!',
	    examples: [
	      {
	        img: 'logos/rupaul_logo.png',
	        example: 'https://rupaul.consider.it',
	        img_dim: {
	          height: 81,
	          width: 192
	        },
	        color: '#D600B1',
	        anchor: "Fans discussing contestants",
	        alt: "Fans of the show Ru Paul's Drag Race use Consider.it to evaluate contestants' performances."
	      }
	    ]
	  }
	];
	
	styles += ".flex-table-row {\n  display: flex;\n  align-items: center; \n  padding: 24px;   \n  border-bottom: 1px dashed #e1e1e1;\n}\n\n.example_forum {\n  display: none;\n}\n\n@media (max-width: 693px) {\n  .flex-table-row {\n    flex-direction: column;\n    justify-content: center;\n    border-bottom: none;\n  }\n\n  .flex-table-cell > div, .flex-table-cell a {\n    text-align: center;\n  }\n\n  .example_forum {\n    display: block;\n    font-style: italic;\n    margin-bottom: 12px;\n  }\n\n\n}\n\n\n\n.flex-table-row.first {\n  position: relative;\n  padding: 24px 24px 36px 24px;\n}\n\n.flex-table-row:last-child {\n  border-bottom: none;\n}\n\n.flex-table-cell {\n  height: 100px;\n  vertical-align: middle;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (min-width: 375px) {\n  .flex-table-cell-title {\n    min-width: 366px;\n  }\n\n}\n\n\n\n.flex-table-cell-title.first {\n  margin-top: 56px;\n}\n\n.flex-table-cell-like {\n  font-style: italic;\n  text-align: center;\n  font-size: 18px;\n  padding-right: 40px;\n  /* min-width: 120px; */\n  flex-grow: 2;\n\n}\n\n.flex-table-cell-logo {\n  min-width: 280px;\n}\n\n.flex-table-cell-link {\n\n}\n\n.toggle_examples {\n  background-color: " + seattle_salmon + ";\n  color: white;\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 4px;\n  border: none;\n  margin-top: 8px;\n  position: absolute;\n  bottom: 12px;\n}\n\n@media (max-width: 725px) {\n  .toggle_examples {\n    display: none;\n  }\n}\n\n@media (max-width: 955px) {\n  .flex-table-cell-like {\n    display: none;\n  }\n}\n\n@media (max-width: 850px) {\n  .flex-table-cell-link {\n    display: none;\n  }\n}\n\n@media (max-width: 450px) {\n  .delightful_surprise {\n    display: none;\n  }\n}\n";
	
	UseCases = ReactiveComponent({
	  displayName: 'UseCases',
	  render: function() {
	    var base, col, forum, forums, get_row, row, use;
	    get_row = (function(_this) {
	      return function(use, example, extra, idx, expanded) {
	        var ref, ref1;
	        return DIV({
	          key: example.example,
	          className: "flex-table-row " + (!extra ? 'first' : 'extra') + " " + (idx % 2 ? 'odd' : 'even') + " " + (expanded ? 'expanded' : 'collapsed')
	        }, DIV({
	          className: "flex-table-cell flex-table-cell-title",
	          style: {
	            visibility: extra ? 'hidden' : void 0
	          }
	        }, H3(null, DIV({
	          style: {
	            fontSize: responsive_css_rule({
	              min_size: 19,
	              max_size: 24,
	              min_vw: 374,
	              max_vw: 474
	            }),
	            fontWeight: 700
	          }
	        }, use.title), DIV({
	          style: {
	            fontWeight: 400,
	            fontSize: responsive_css_rule({
	              min_size: 15,
	              max_size: 18,
	              min_vw: 374,
	              max_vw: 474
	            })
	          }
	        }, use.subtitle)), !extra && use.examples.length > 1 ? BUTTON({
	          className: "toggle_examples",
	          onClick: function() {
	            _this.local.show_more[use.title] = !_this.local.show_more[use.title];
	            return save(_this.local);
	          }
	        }, _this.local.show_more[use.title] ? "Show fewer examples" : "Reveal more examples") : void 0), DIV({
	          className: "flex-table-cell flex-table-cell-like " + (idx % 2 ? 'odd' : 'even'),
	          style: {
	            visibility: extra ? 'hidden' : void 0
	          }
	        }, 'like'), DIV({
	          className: "flex-table-cell flex-table-cell-logo " + (idx % 2 ? 'odd' : 'even')
	        }, DIV({
	          className: 'example_forum'
	        }, "for example:"), A({
	          href: example.example,
	          target: '_blank',
	          style: {
	            fontSize: 18,
	            fontWeight: 700,
	            color: example.color,
	            position: 'relative',
	            top: ((ref = example.adj) != null ? ref.top : void 0) || 0,
	            left: ((ref1 = example.adj) != null ? ref1.left : void 0) || 0
	          }
	        }, IMG({
	          alt: example.alt || ("image for use case " + example.anchor),
	          title: example.alt,
	          src: asset("product_page/" + example.img),
	          style: {
	            width: example.img_dim.width,
	            height: example.img_dim.height,
	            verticalAlign: 'middle'
	          }
	        }), SPAN({
	          style: {
	            fontSize: 0,
	            visibility: 'hidden'
	          }
	        }, example.anchor))), DIV({
	          className: "flex-table-cell flex-table-cell-link " + (idx % 2 ? 'odd' : 'even'),
	          style: {
	            width: responsive_css_rule({
	              min_size: 128,
	              max_size: 300,
	              min_vw: 1100,
	              max_vw: 1101
	            })
	          }
	        }, A({
	          href: example.example,
	          style: {
	            fontSize: 18,
	            fontWeight: 700,
	            textDecoration: 'underline',
	            color: 'black'
	          },
	          target: '_blank'
	        }, example.anchor && WINDOW_WIDTH() > 1100 ? example.anchor : 'Visit example')));
	      };
	    })(this);
	    if ((base = this.local).show_more == null) {
	      base.show_more = {};
	    }
	    return DIV(null, DIV({
	      style: {
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        maxWidth: 720,
	        margin: 'auto',
	        marginBottom: WINDOW_WIDTH() > 450 ? 52 : 4,
	        textAlign: 'center'
	      }
	    }, H2({
	      className: 'light_callout'
	    }, WINDOW_WIDTH() > 450 ? 'What can Consider.it be used for?' : 'What are Consider.it\'s uses?'), SPAN({
	      className: 'delightful_surprise',
	      style: {
	        fontSize: 18
	      }
	    }, "We're often delightfully surprised by the ways Consider.it is put to use!")), DIV({
	      className: 'flex-table'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (row = i = 0, len = use_cases.length; i < len; row = ++i) {
	        use = use_cases[row];
	        forums = use.examples;
	        results.push((function() {
	          var j, len1, results1;
	          results1 = [];
	          for (col = j = 0, len1 = forums.length; j < len1; col = ++j) {
	            forum = forums[col];
	            if (col === 0 || this.local.show_more[use.title]) {
	              results1.push(get_row(use, forum, col > 0, row, this.local.show_more[use.title]));
	            } else {
	              results1.push(void 0);
	            }
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }).call(this))));
	  }
	});


/***/ },

/***/ 90:
/***/ function(module, exports) {

	window.smooth = function(series, window_l) {
	  var d, i, idx, j, k, len, len1, p, range, tot;
	  for (idx = j = 0, len = series.length; j < len; idx = ++j) {
	    d = series[idx];
	    range = (function() {
	      var k, ref, ref1, results;
	      results = [];
	      for (i = k = ref = idx - window_l + 1, ref1 = idx; ref <= ref1 ? k <= ref1 : k >= ref1; i = ref <= ref1 ? ++k : --k) {
	        if (i >= 0) {
	          results.push(i);
	        }
	      }
	      return results;
	    })();
	    tot = 0;
	    for (k = 0, len1 = range.length; k < len1; k++) {
	      p = range[k];
	      tot += series[p][2];
	    }
	    d.push(tot / range.length);
	  }
	  return series;
	};
	
	window.Metrics = ReactiveComponent({
	  displayName: 'Metrics',
	  mixins: [LoadScripts],
	  js_dependencies: ['d3.v7.min.js'],
	  componentDidMount: function() {
	    return this.loadScripts();
	  },
	  componentDidUpdate: function() {
	    return this.loadScripts();
	  },
	  render: function() {
	    var d, m, metrics;
	    m = fetch('/metrics');
	    if (!this.local.loaded) {
	      return SPAN(null);
	    }
	    if (this.local.log == null) {
	      this.local.log = 'linear';
	      this.local.time_frame = 'all time';
	    }
	    if (!m.daily_active_contributors) {
	      return DIV({
	        style: {
	          margin: '100px auto',
	          fontSize: 36,
	          width: 400,
	          textAlign: 'center'
	        }
	      }, 'Loading metrics');
	    }
	    if (this.local.time_frame === 'all time') {
	      metrics = m;
	    } else {
	      metrics = _.extend(m, {
	        daily_active_contributors: (function() {
	          var j, len, ref, results;
	          ref = m.daily_active_contributors;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            d = ref[j];
	            if (d[0] < 365) {
	              results.push(d);
	            }
	          }
	          return results;
	        })(),
	        daily_active_subdomains: (function() {
	          var j, len, ref, results;
	          ref = m.daily_active_subdomains;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            d = ref[j];
	            if (d[0] < 365) {
	              results.push(d);
	            }
	          }
	          return results;
	        })()
	      });
	    }
	    return DIV({
	      style: {
	        margin: 60,
	        minHeight: window.innerHeight
	      }
	    }, STYLE(null, ".axis path,\n.axis line {\n  fill: none;\n  stroke: #000;\n  shape-rendering: crispEdges;\n}\n\n.line {\n  fill: none;\n  stroke: steelblue;\n  stroke-width: 1.5px;\n}\n\n.line2 {\n  fill: none;\n  stroke: magenta;\n  stroke-width: 1.5px;\n}\n\n\n.tick line{\n    opacity: 0.1;\n  }\n\n.tick text{\n    font-size: 12px;\n  }            "), DIV({
	      style: {
	        fontSize: 24,
	        textAlign: 'center'
	      }
	    }, "Daily unique contributors", SPAN({
	      style: {
	        fontSize: 14,
	        border: '1px solid #ccc',
	        padding: '2px 4px',
	        cursor: 'pointer',
	        borderRadius: 8,
	        display: 'inline-block',
	        marginLeft: 10
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.local.log === 'linear') {
	            _this.local.log = 'log10';
	          } else {
	            _this.local.log = 'linear';
	          }
	          return save(_this.local);
	        };
	      })(this)
	    }, this.local.log), SPAN({
	      style: {
	        fontSize: 14,
	        border: '1px solid #ccc',
	        padding: '2px 4px',
	        cursor: 'pointer',
	        borderRadius: 8,
	        display: 'inline-block',
	        marginLeft: 10
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.local.time_frame === 'all time') {
	            _this.local.time_frame = 'past 365 days';
	          } else {
	            _this.local.time_frame = 'all time';
	          }
	          return save(_this.local);
	        };
	      })(this)
	    }, this.local.time_frame)), LineGraph({
	      key: "contributors-" + this.local.log + "-" + this.local.time_frame,
	      data: smooth(metrics.daily_active_contributors, 30),
	      width: WINDOW_WIDTH() - 60 * 2,
	      log: this.local.log
	    }), DIV({
	      style: {
	        fontSize: 24,
	        marginTop: 40,
	        textAlign: 'center'
	      }
	    }, "Daily active subdomains"), LineGraph({
	      key: "subs-" + this.local.log + "-" + this.local.time_frame,
	      data: smooth(metrics.daily_active_subdomains, 30),
	      width: WINDOW_WIDTH() - 60 * 2,
	      log: this.local.log
	    }), DIV({
	      style: {
	        fontSize: 24,
	        marginTop: 40,
	        textAlign: 'center'
	      }
	    }, "Total Usage (sum of Daily Unique Contributors)", (function(_this) {
	      return function() {
	        var cont, contributions, contributors, ref, sort_on_click, subdomain, td_style, th_style;
	        contributions = [];
	        ref = metrics.contributors_per_subdomain;
	        for (subdomain in ref) {
	          contributors = ref[subdomain];
	          if (contributors.lifetime > 1) {
	            contributions.push([parseInt(subdomain), contributors]);
	          }
	        }
	        if (_this.local.sort_contributions_by == null) {
	          _this.local.sort_contributions_by = 'year';
	        }
	        contributions.sort(function(a, b) {
	          var ref1;
	          if ((ref1 = _this.local.sort_contributions_by) === 'opinions_per_subdomain' || ref1 === 'opinions_and_inclusions_per_subdomain') {
	            return (metrics[_this.local.sort_contributions_by][b[0]] || 0) - (metrics[_this.local.sort_contributions_by][a[0]] || 0);
	          } else {
	            return b[1][_this.local.sort_contributions_by] - a[1][_this.local.sort_contributions_by];
	          }
	        });
	        sort_on_click = function(e) {
	          _this.local.sort_contributions_by = e.currentTarget.getAttribute('data-time');
	          return save(_this.local);
	        };
	        td_style = {
	          padding: '0 8px'
	        };
	        th_style = {
	          padding: '2px 8px',
	          fontWeight: 'bold',
	          cursor: 'pointer',
	          borderBottom: '1px solid #999'
	        };
	        return TABLE({
	          style: {
	            margin: 'auto'
	          }
	        }, TBODY(null, TR(null, TH({
	          style: _.extend({}, th_style, {
	            textAlign: 'right',
	            cursor: 'default'
	          })
	        }, 'Name'), TH({
	          onClick: sort_on_click,
	          'data-time': 'opinions_per_subdomain',
	          style: th_style
	        }, 'Opinions'), TH({
	          onClick: sort_on_click,
	          'data-time': 'opinions_and_inclusions_per_subdomain',
	          style: th_style
	        }, '+inclusions'), TH({
	          onClick: sort_on_click,
	          'data-time': 'active',
	          style: th_style
	        }, 'Days active'), TH({
	          onClick: sort_on_click,
	          'data-time': 'lifetime',
	          style: th_style
	        }, 'Lifetime'), TH({
	          onClick: sort_on_click,
	          'data-time': 'year',
	          style: th_style
	        }, 'Past year'), TH({
	          onClick: sort_on_click,
	          'data-time': 'month',
	          style: th_style
	        }, 'Past month'), TH({
	          onClick: sort_on_click,
	          'data-time': 'week',
	          style: th_style
	        }, 'Past week'), TH({
	          onClick: sort_on_click,
	          'data-time': 'day',
	          style: th_style
	        }, 'Past day')), (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = contributions.length; j < len; j++) {
	            cont = contributions[j];
	            subdomain = cont[0], contributors = cont[1];
	            results.push(TR({
	              key: subdomain
	            }, TD({
	              style: _.extend({}, td_style, {
	                textAlign: 'right'
	              })
	            }, A({
	              href: "https://" + (fetch("/subdomain/" + subdomain).name) + ".consider.it",
	              title: fetch("/subdomain/" + subdomain).name,
	              style: {
	                color: focus_color(),
	                textDecoration: 'underline',
	                display: 'inline-block',
	                maxWidth: 200,
	                overflow: 'hidden'
	              }
	            }, fetch("/subdomain/" + subdomain).name)), TD({
	              style: td_style
	            }, metrics.opinions_per_subdomain[subdomain]), TD({
	              style: td_style
	            }, metrics.opinions_and_inclusions_per_subdomain[subdomain]), TD({
	              style: td_style
	            }, contributors.active), TD({
	              style: td_style
	            }, contributors.lifetime), TD({
	              style: td_style
	            }, contributors.year), TD({
	              style: td_style
	            }, contributors.month), TD({
	              style: td_style
	            }, contributors.week), TD({
	              style: td_style
	            }, contributors.day)));
	          }
	          return results;
	        })()));
	      };
	    })(this)()));
	  }
	});
	
	window.LineGraph = ReactiveComponent({
	  displayName: 'LineGraph',
	  render: function() {
	    return DIV({
	      ref: 'container'
	    });
	  },
	  componentDidMount: function() {
	    var container, data, formatDate, g, height, margin, measure, series, svg, valueline, width, x, xAxis, y, yAxis, yAxis_right, z;
	    data = this.props.data;
	    margin = {
	      top: 20,
	      right: 50,
	      bottom: 30,
	      left: 50
	    };
	    width = this.props.width - margin.left - margin.right;
	    height = 250 - margin.top - margin.bottom;
	    x = d3.scaleTime().range([0, width]);
	    if (this.props.log === 'log10') {
	      y = d3.scaleLog().domain([0.1, 100]).range([height, 0]);
	    } else {
	      y = d3.scaleLinear().range([height, 0]);
	    }
	    z = d3.scaleOrdinal(d3.schemeCategory10);
	    xAxis = d3.axisBottom().scale(x);
	    yAxis = d3.axisLeft().scale(y).tickSizeInner(-width).tickSizeOuter(0).tickPadding(10);
	    if (this.props.log === 'log10') {
	      yAxis.ticks(0, ".1s");
	    }
	    yAxis_right = d3.axisRight().scale(y).tickSizeOuter(0);
	    if (this.props.log === 'log10') {
	      yAxis_right.ticks(0, ".1s");
	    }
	    formatDate = d3.timeParse(this.props.time_format || "%d-%b-%y");
	    series = [
	      {
	        id: 'daily',
	        values: data.map(function(d) {
	          return [d[1], Math.max(d[2], .1)];
	        })
	      }, {
	        id: 'monthly',
	        values: data.map(function(d) {
	          return [d[1], Math.max(d[3], .1)];
	        })
	      }
	    ];
	    valueline = d3.line().curve(d3.curveBasis).x(function(d) {
	      return x(formatDate(d[0]));
	    }).y(function(d) {
	      return y(d[1]);
	    });
	    container = d3.select(ReactDOM.findDOMNode(this));
	    svg = container.append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);
	    g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	    x.domain(d3.extent(data, function(d) {
	      return formatDate(d[1]);
	    }));
	    y.domain([
	      d3.min(series, function(c) {
	        return d3.min(c.values, function(d) {
	          return d[1];
	        });
	      }), d3.max(series, function(c) {
	        return d3.max(c.values, function(d) {
	          return d[1];
	        });
	      })
	    ]);
	    z.domain(data.map(function(d) {
	      return d.id;
	    }));
	    g.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);
	    g.append('g').attr('class', 'y axis').call(yAxis);
	    g.append('g').attr('class', 'y axis').attr("transform", "translate(" + width + " ,0)").call(yAxis_right);
	    measure = g.selectAll('.measure').data(series).enter().append('g').attr('class', 'measure');
	    return measure.append('path').attr('class', 'line').attr('d', function(d) {
	      return valueline(d.values);
	    }).style('stroke', function(d) {
	      return z(d.id);
	    });
	  }
	});


/***/ },

/***/ 91:
/***/ function(module, exports) {

	var FAQ, info, per_opinion, pricing_qs, tech_qs;
	
	info = function() {
	  return SPAN({
	    style: {
	      paddingLeft: 3,
	      verticalAlign: 'middle'
	    }
	  }, SVG({
	    viewBox: "3 3 6.5915 6.5915",
	    width: 15,
	    height: 15,
	    style: {
	      display: 'inline-block',
	      shapeRendering: 'geometricPrecision',
	      textRendering: 'geometricPrecision',
	      imageRendering: 'optimizeQuality',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd'
	    }
	  }, G({
	    transform: "matrix(0.443852,0.000000,0.000000,0.443852,3.501380,3.501380)"
	  }, PATH({
	    fill: '#777',
	    d: "M 6.29577,0 C 9.77228,0 12.59154,2.81926 12.59154,6.29577 C 12.59154,9.77228 9.77228,12.59154 6.29577,12.59154 C 2.81926,12.59154 0,9.77228 0,6.29577 C 0,2.81926 2.81926,0 6.29577,0 z M 7.241939,4.51008 L 7.241939,10.10704 L 7.988183,10.10704 L 7.988183,10.773334 L 7.854945,10.773334 L 4.603355,10.773334 L 4.603355,10.10704 L 5.349633,10.10704 L 5.349633,5.17637 L 4.603355,5.17637 L 4.603355,4.510076 L 4.736627,4.510076 L 7.241937,4.510076 L 7.241939,4.51008 z M 5.296309,2.75105 C 5.296309,2.511166 5.3829582,2.295734 5.556188,2.104718 C 5.729418,1.913702 5.953761,1.818211 6.229147,1.818211 L 6.362419,1.818211 C 6.593393,1.818211 6.806615,1.9026157 7.002052,2.071425 C 7.197523,2.2402 7.295224,2.466753 7.295224,2.75105 C 7.295224,2.990899 7.2108533,3.206332 7.042044,3.397348 C 6.873235,3.588364 6.646716,3.683855 6.362419,3.683855 L 6.229147,3.683855 C 5.998173,3.683855 5.784951,3.5994503 5.589514,3.430675 C 5.394043,3.261866 5.296308,3.035313 5.296308,2.75105 L 5.296309,2.75105 z "
	  }))));
	};
	
	styles += "[data-widget=\"Pricing\"] ul.feature_matrix {\n  list-style: none;\n  padding-left: 32px;\n}\n\n[data-widget=\"Pricing\"] ul.feature_matrix li {\n  position: relative;\n\n}\n[data-widget=\"Pricing\"] ul.feature_matrix li svg {\n  position: absolute;\n  left: -36px;\n  top: 1px;\n}\n\n[data-widget=\"Pricing\"] .plan_container {\n  list-style: none;\n  padding-top: 60px;\n  display: flex;\n  justify-content: center;\n}\n\n[data-widget=\"Pricing\"] .plan {\n  padding: 32px 36px;\n  background-color: white;\n  max-width: 420px;\n  display: inline-block;\n  margin: 0px 10px; \n  vertical-align: top;\n  flex: 1 1 1;\n}\n\n[data-widget=\"Pricing\"] .plan_name {\n  font-weight: 800;\n  text-align: center;\n}\n\n[data-widget=\"Pricing\"] .plan_name_subtitle {\n  font-style: italic;\n  font-size: 16px;\n  text-align: center;\n}\n\n[data-widget=\"Pricing\"] .base_text {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n[data-widget=\"Pricing\"] .base_text.details_paragraph {\n  padding-bottom: 30px;\n  text-align: left\n}\n\n[data-widget=\"Pricing\"] .base_text.plan_button {\n  font-size: 18px;\n  font-weight: 700;\n  padding: 14px 12px;\n  width: 100%;\n  max-width: 300px;\n  margin: auto;\n  text-align: center;\n  display: block;\n  text-decoration: none;\n}\n\n[data-widget=\"Pricing\"] .feature_matrix_item {\n  margin-bottom: 12px;\n}\n\n[data-widget=\"Pricing\"] .payment_container {\n  padding-top: 0;\n  text-align: center;\n  display: none;\n}\n\n[data-widget=\"Pricing\"] .money {\n  font-size: 75px;\n  font-weight: 800;\n  line-height: 75px;\n  position: relative;\n}\n\n[data-widget=\"Pricing\"] .dollar {\n  font-size: 32px;\n  position: absolute;\n  top: 10px;\n  left: -20px;\n  font-weight: 400;\n}\n\n@media (max-width: 414px) {\n  [data-widget=\"Pricing\"] .plan {\n    padding: 32px 18px;\n  }\n}\n\n@media (max-width: 1047px) {\n  [data-widget=\"Pricing\"] .plan_container {\n    flex-direction: column;\n  }\n  [data-widget=\"Pricing\"] .plan {\n    margin: 20px auto;\n    display: block;\n    max-width: 600px;\n    width: 95%;\n  }\n  [data-widget=\"Pricing\"] .plan_name {\n    font-size: " + (responsive_css_rule({
	  min_size: 24,
	  max_size: 32,
	  min_vw: 380,
	  max_vw: 800
	})) + ";\n  }\n\n}\n\n@media (min-width: 1048px) {\n  [data-widget=\"Pricing\"] .plan_name {\n    font-size: " + (responsive_css_rule({
	  min_size: 23,
	  max_size: 32,
	  min_vw: 1150,
	  max_vw: 1400
	})) + ";\n  }\n\n\n}  ";
	
	window.Pricing = ReactiveComponent({
	  displayName: 'Pricing',
	  render: function() {
	    return DIV({
	      style: {}
	    }, this.heading(), this.plans(), this.consulting(), FAQ());
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: "var(--SAAS_PAGE_WIDTH)",
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      className: 'main_callout condensed'
	    }, "Invest in your community’s opinions"), DIV({
	      style: {
	        fontSize: responsive_css_rule({
	          min_size: 16,
	          max_size: 18,
	          min_vw: 380,
	          max_vw: 500
	        }),
	        color: 'white',
	        marginTop: 8
	      }
	    }, 'Careful organization and visualization of your stakeholders\' considered opinions'));
	  },
	  plans: function() {
	    var enterprise_features, feature, free_features, premium_features;
	    free_features = [
	      {
	        label: "Unlimited Opinions & Comments",
	        tooltip: "No limitations on the content you or participants can contribute."
	      }, {
	        label: "Unlimited Participants & Hosts",
	        tooltip: "No limitations on the number of people who can participate or act as a dialogue host."
	      }, {
	        label: "Community Ideation",
	        tooltip: "You can specify whether any participant is allowed to add new ideas to open-ended questions you pose."
	      }, {
	        label: "Content Moderation",
	        tooltip: "Select a moderation policy that fits the appropriate level of protection for your engagement."
	      }, {
	        label: "Private Forum option",
	        tooltip: "The forum can be set to private so that only people who have been invited can access the dialogue."
	      }, {
	        label: "Customizable Banner",
	        tooltip: "Welcome people to your forum! Set a title, add details, add a logo, and set a background image."
	      }, {
	        label: "Google Translate Integration",
	        tooltip: "Prominently feature a widget for helping participants select their preferred language."
	      }
	    ];
	    premium_features = [
	      {
	        label: "Data Export",
	        tooltip: "Export your forum data into CSV format. We can work with you if you have other data requirements. "
	      }, {
	        label: "Sign-up questions for collecting demographics from participants",
	        tooltip: "Collect relevant information from participants (e.g. demographics). You can create text, dropdown, and checklist type questions. This data can be used for comparing opinions between subgroups."
	      }, {
	        label: "Opinion analytics for exploratory data analysis",
	        tooltip: "Slice and dice the data to learn what different subgroups think! "
	      }, {
	        label: "Tabs to organize your forum",
	        tooltip: "Separate your topics into different pages to help structure your forum. You can even create an About page."
	      }
	    ];
	    enterprise_features = [
	      {
	        label: "Dedicated engagement expert",
	        tooltip: "We can work with you to craft your conversation, and assist in other ways that emerge."
	      }, {
	        label: "Fully customized banner",
	        tooltip: "If the built-in banner does not fit your forum vision, we can work with you to design one that does. <img style='margin-top: 12px' src='" + (asset('product_page/customize_homepage.gif')) + "' width=300 />"
	      }, {
	        label: "Coordinated data import",
	        tooltip: "Sometimes you are trying to coordinate amongst multiple teams. We can help set up a process that steamlines collaborative data import into Consider.it."
	      }, {
	        label: "Hosting at your web domain",
	        tooltip: "By default, your forum will be hosted at e.g. https://myforum.consider.it. If you'd rather host it at your own domain at e.g. https://consider.gotham.gov, we've got you covered."
	      }, {
	        label: "Single Sign-On (SSO)",
	        tooltip: "We can work with you to implement Single Sign-On integration with your SAML-enabled identity provider."
	      }, {
	        label: "Custom developed components",
	        tooltip: "If there is some important but niche widget you need for your forum, like a zip-code filter, we can code and integrate it into your forum."
	      }, {
	        label: "Service Level Agreement 2",
	        tooltip: "99.5% Uptime Commitment. Guaranteed response to support requests within one business day, with escalation path to CEO available via text and email. Resolution of high severity issues guaranteed within one business day. Custom SLAs possible."
	      }
	    ];
	    return UL({
	      className: 'plan_container'
	    }, LI({
	      className: 'plan'
	    }, H2({
	      className: 'plan_name'
	    }, 'Free Forum'), DIV({
	      className: 'plan_name_subtitle'
	    }, 'Use for as long as you wish'), DIV({
	      style: {
	        paddingTop: 36,
	        paddingBottom: 60
	      }
	    }, A({
	      href: '/create_forum',
	      target: '_blank',
	      className: 'plan_button big_button base_text'
	    }, 'Create a Free Forum')), P({
	      className: 'base_text details_paragraph'
	    }, "Engage as many stakeholders about any number of issues for as long as you \nwish. Your forum can be public or private. No cost, no ads. Make as many free \nforums as you want. You\'re welcome!"), UL({
	      className: 'feature_matrix details_paragraph base_text'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = free_features.length; i < len; i++) {
	        feature = free_features[i];
	        results.push(LI({
	          key: feature.label,
	          className: 'feature_matrix_item'
	        }, checkmark(24, 'green'), SPAN({
	          style: {
	            borderBottom: feature.tooltip ? "2px dotted #1d1c1d" : void 0
	          },
	          "data-tooltip": feature.tooltip ? feature.tooltip : void 0
	        }, feature.label)));
	      }
	      return results;
	    })())), LI({
	      className: 'plan'
	    }, H2({
	      className: 'plan_name'
	    }, 'Premium Forum'), DIV({
	      className: 'plan_name_subtitle'
	    }, '$625 one-time fee'), DIV({
	      style: {
	        paddingTop: 36,
	        paddingBottom: 60
	      }
	    }, A({
	      href: '/create_forum?plan=premium',
	      target: '_blank',
	      className: 'plan_button big_button base_text'
	    }, 'Create a Premium Forum')), P({
	      className: 'details_paragraph base_text'
	    }, "The full suite of Consider.it functionality. Export data, create demographic sign-up questions, and organize your dialogue into different pages using tabs!"), P({
	      style: {
	        fontStyle: 'italic',
	        marginBottom: 24
	      }
	    }, "Everything in a Free Forum, plus:"), UL({
	      className: 'feature_matrix details_paragraph base_text'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = premium_features.length; i < len; i++) {
	        feature = premium_features[i];
	        results.push(LI({
	          key: feature.label,
	          className: 'feature_matrix_item'
	        }, checkmark(24, 'green'), SPAN({
	          style: {
	            borderBottom: feature.tooltip ? "2px dotted #1d1c1d" : void 0
	          },
	          "data-tooltip": feature.tooltip ? feature.tooltip : void 0
	        }, feature.label)));
	      }
	      return results;
	    })())), LI({
	      className: 'plan'
	    }, H2({
	      className: 'plan_name'
	    }, 'Enterprise Forum'), DIV({}, DIV({
	      className: 'plan_name_subtitle'
	    }, 'Get help engaging your community')), DIV({
	      style: {
	        paddingBottom: 60,
	        paddingTop: 36
	      }
	    }, A({
	      href: '/contact?form=upgrade_to_customized_forum',
	      target: '_blank',
	      className: 'plan_button big_button base_text'
	    }, 'Contact Us')), P({
	      className: 'details_paragraph base_text'
	    }, "We can help you design a dialogue to meet your goals, brand it, modify it as your community grows, and \nassist with data analysis."), P({
	      style: {
	        fontStyle: 'italic',
	        marginBottom: 24
	      }
	    }, "Everything in a Premium Forum, plus:"), UL({
	      className: 'feature_matrix details_paragraph base_text'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = enterprise_features.length; i < len; i++) {
	        feature = enterprise_features[i];
	        results.push(LI({
	          key: feature.label,
	          className: 'feature_matrix_item'
	        }, checkmark(24, 'green'), SPAN({
	          style: {
	            borderBottom: feature.tooltip ? "2px dotted #1d1c1d" : void 0
	          },
	          "data-tooltip": feature.tooltip ? feature.tooltip : void 0
	        }, feature.label)));
	      }
	      return results;
	    })()), P({
	      className: 'details_paragraph base_text'
	    }, "Cost varies depending on requirements, timeline, budget, and mission.  \nCost is usually between $2,000 and $9,500.")));
	  },
	  consulting: function() {
	    var plan_button_style, small_para_style;
	    small_para_style = {
	      fontSize: 16
	    };
	    plan_button_style = _.extend({}, big_button(), {
	      fontSize: 18,
	      fontWeight: 600,
	      padding: '10px 32px',
	      textAlign: 'center',
	      textDecoration: 'none'
	    });
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)',
	        position: 'relative',
	        zIndex: 1,
	        paddingTop: 50,
	        paddingBottom: 50
	      }
	    }, A({
	      name: 'consulting'
	    }), A({
	      name: 'testimonials'
	    }), DIV({
	      style: {
	        maxWidth: "var(--SAAS_PAGE_WIDTH)",
	        margin: '0 auto 40px auto'
	      }
	    }, H2({
	      className: 'bold_callout'
	    }, 'Want help designing a conversation?', BR(null), ' Hire us to help with your forum.'), DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, A({
	      href: '/contact?form=consulting_inquiry',
	      target: '_blank',
	      style: plan_button_style
	    }, 'Inquire about our consulting services'))), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, TestimonialGrid({
	      testimonials: [testimonials.susie_pricing, testimonials.russ_pricing, testimonials.auryn_pricing]
	    })));
	  }
	});
	
	styles += ".embedded p {\n  margin-bottom: 12px;\n}\n\n.embedded emph {\n  font-style: italic;\n}\n\n.embedded strong {\n  font-weight: 700;\n}\n.embedded a {\n  text-decoration: underline;\n}\n\n.embedded ul { padding-top: 20px; padding-left: 18px; list-style: outside;}\n\n.embedded li { padding-bottom: 12px; }\n\n\n[data-widget=\"FAQ\"] .faq_col {\n  display: inline-block;\n  width: 48%;\n  padding: 0 20px;\n  vertical-align: top;\n}\n\n@media (max-width: 1000px) {\n  [data-widget=\"FAQ\"] .faq_col {\n    display: block;\n    width: 100%;\n    margin-top: 48px;\n  }\n}\n\n[data-widget=\"FAQ\"] .faq {\n  font-weight: 700;\n  font-size: " + (responsive_css_rule({
	  min_size: 16,
	  max_size: 20,
	  min_vw: 414,
	  max_vw: 500
	})) + ";\n  margin-bottom: 12px;\n}\n\n@media (max-width: 500px) {\n  [data-widget=\"FAQ\"] {\n    display: none;\n  }\n}\n";
	
	FAQ = ReactiveComponent({
	  displayName: 'FAQ',
	  render: function() {
	    var faq, header, question_set, set;
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        padding: '80px 40px 140px 40px'
	      }
	    }, A({
	      name: 'faq'
	    }), DIV({
	      style: {
	        margin: 'auto',
	        maxWidth: 1100
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = [['Tech Questions', tech_qs], ['Pricing Questions', pricing_qs]];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        set = ref[i];
	        header = set[0];
	        question_set = set[1];
	        results.push(DIV({
	          key: header,
	          className: "faq_col"
	        }, H2({
	          className: 'bold_callout',
	          style: {
	            margin: '0px 0px 20px 0px'
	          }
	        }, header), UL({
	          style: {
	            listStyle: 'none'
	          }
	        }, (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = question_set.length; j < len1; j++) {
	            faq = question_set[j];
	            results1.push(LI({
	              key: faq.q,
	              style: {
	                marginBottom: 20
	              }
	            }, faq.l ? A({
	              name: faq.l
	            }) : void 0, H3({
	              className: 'faq'
	            }, faq.q), DIV({
	              style: {
	                fontSize: 16,
	                color: '#303030'
	              }
	            }, DIV({
	              className: 'embedded',
	              dangerouslySetInnerHTML: {
	                __html: faq.a
	              }
	            }))));
	          }
	          return results1;
	        })())));
	      }
	      return results;
	    })()));
	  }
	});
	
	tech_qs = [
	  {
	    l: 'customization',
	    q: "How can I brand my forum and give it my organization’s look and feel?",
	    a: "The Free Forum has a template for customizing to your brand that works for most cases. \nIf you need something more customized, <a href=\"/contact\">contact us</a> and we can talk about\nwhat you need. We can fully customize to your brand, such as \n<a href=\"https://mofo-impact-goal.consider.it\" target=\"_blank\">this forum for the Mozilla Foundation</a>."
	  }, {
	    l: 'profile_questions',
	    q: "I want to know more about participants in my forum. Can I ask about their age? Race & ethnicity? If they’re a renter or homeowner? If they’re a board member?",
	    a: "With the Premium Forum you can configure sign-up questions. These questions are asked of participants after they create an account.  \nThis information can then be used to cross tabulate the results to explore the opinions of segments of your stakeholders. \nIt is also available in the data export."
	  }, {
	    l: 'civility',
	    q: "Can we moderate the forum and maintain civil discourse?",
	    a: "Yes. As a forum host, you have a number of options for hiding incivil and/or off-topic user \nposts. We’ve found an even more powerful mechanism though: a participation pledge that all participants in your forum \nwill need to agree to when creating an account. It is amazing what setting expectations can do. \nOverall, <a href=\"/tour#research\">we have found</a> the structure of our forums to lend themselves to civil discourse. We have hosted \nmunicipal dialogues on very contentious issues without having to moderate a single comment."
	  }, {
	    l: 'access_control',
	    q: "Can I make my forum invite-only so only certain people can access it?",
	    a: "Yes. Once you create your forum you will be able to set the forum as private. Then only people who you invite can participate in the forum. You can set user roles to give people view-only access or the ability to respond. Furthermore, you can make specific questions invite-only."
	  }, {
	    l: 'translation',
	    q: "Do you offer forums in languages other than English?",
	    a: "Yes. First, Google Translate can be enabled in the banner of any forum.  \nThis is a good option for multi-lingual forums. \nSecond, we have created a way for anyone to contribute interface translations for non-English languages. \nThis can provide a higher quality experience for communities whose members’ primary language isn’t English. \n<a href=\"/contact\">Contact us if your language isn't available yet</a>.\nThird, sometimes clients wish to create clones of a forum in order to target different languages. \nIf you've paid for an Premium Forum for one language, we are happy to upgrade the other language forums at no cost."
	  }, {
	    l: 'mobile',
	    q: "Does Consider.it work on mobile?",
	    a: "Yes. It is responsive and works on most mobile devices. We do not currently offer a stand alone mobile app."
	  }, {
	    l: 'accessibility',
	    q: "Is Consider.it compliant with accessibility standards?",
	    a: "Yes, Consider.it is <a href='https://www.w3.org/WAI/intro/wcag.php'>WCAG</a> Level A compliant. <a target=\"_blank\" href='https://docs.google.com/document/u/2/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub'>Learn more</a>."
	  }, {
	    l: 'vanity_url',
	    q: "Can I use a custom URL? Can I host the forum on my own server?",
	    a: "We can set up your forum to use a custom URL. At this time, we do not support self-hosting on your own server. "
	  }, {
	    l: 'saml',
	    q: "Do you support SAML single sign-on?",
	    a: "We have a limited implementation. Contact us to help determine if it fits your needs."
	  }, {
	    l: 'comparison',
	    q: "How is this different than a survey or a web forum?",
	    a: "<p>Some people think of a Consider.it forum as a combination of a survey and a forum. See <a href=\"/tour#comparison_guide\" target=\"_blank\">our comparison guide</a>.</p>"
	  }
	];
	
	per_opinion = {
	  l: 'pay_per_opinion',
	  q: "What counts as an opinion? Why do you charge \"per opinion\" in the paid plans?",
	  a: "<p style='padding-bottom:8px'>An opinion is collected when someone slides and saves their position on a question in your forum. Pro/con points are not counted.</p> \n<div style='text-align:center'>\n  <img width='90%' src='" + (asset('product_page/opinions_count.png')) + "'>\n  <p style='padding-bottom:8px;font-style:italic'>27 opinions</p>\n</div>\n<p style='padding-bottom:8px'>We charge per opinion because it is fair to you \n– you pay only when you’re getting value from our service – \nand fair to us – we get compensated for a fraction of the value we provide you. \nSmall communities pay less. You don't pay during periods of inactivity.</p> \n<p>For comparison, the opinions collected at <a href='https://wsffn.consider.it' target='_blank'>https://wsffn.consider.it</a> that led to an adopted strategic plan cost $1200.</p>"
	};
	
	pricing_qs = [
	  {
	    l: 'free_forum',
	    q: "Tell me about the Free Forum. What's the catch?",
	    a: "No catch. You can <a href='/create_forum'>create</a> as many free forums as you wish and use them for as long as you want. \nYour forums are public by default, but you can make them invite-only. \nAt any point, you can upgrade a forum to the Premium Plan to access several <a href='/tour#features'>premium features</a> like data export, \nsign-up questions, and tab-based organization."
	  }, {
	    l: 'budget',
	    q: "How much can I expect to pay for an Enterprise forum?",
	    a: "This depends on the engagement, your organization's size, and its mission. Engagements that run for several weeks to months with heavy customization typically end up between $2,000 and $5,000."
	  }, {
	    l: 'consultant_partnership',
	    q: "I’m a consultant and want to set up forums for multiple clients. Can you help me? ",
	    a: "Yes. We work with consultants all the time. We can help you customize forums for each of your clients, or create a branded look for your consulting firm. <a href=\"/contact?form=consultant_partnership\">Get in touch</a> and we can talk. "
	  }, {
	    l: 'demo',
	    q: "Can I speak with someone about the plan options and get a demo?",
	    a: "Absolutely! We’re happy to <a href=\"/contact?form=request_demo\">set up a time to talk</a>."
	  }, {
	    l: 'discount',
	    q: "I want to use Consider.it for an innovative project that will benefit society but can’t afford the price. Can you offer a discount? ",
	    a: "Possibly! We take organization size and mission into account in our budgeting process. Please <a href=\"/contact\">contact us</a> to talk."
	  }, {
	    l: 'refunds',
	    q: "What is your refund policy?",
	    a: "We don’t offer refunds on the setup fee if the work has already been done. If you feel we have made an error in billing or haven’t provided the service we promised, please let us know and we'll work with you to create a fair resolution."
	  }, {
	    l: 'invoice',
	    q: "Can you issue invoices and receive checks instead of a credit card? ",
	    a: "Yes. Please <a href=\"/contact\">contact us</a>."
	  }
	];


/***/ },

/***/ 92:
/***/ function(module, exports) {

	window.giftSVG = function(props) {
	  var base_height, base_width, fill_color, style;
	  base_width = 50;
	  base_height = 59;
	  svg.setSize(base_width, base_height, props);
	  fill_color = props.fill_color || 'black';
	  style = props.style || {};
	  return SVG({
	    width: props.width,
	    height: props.height,
	    viewBox: "0 0 " + base_width + " " + base_height,
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    style: style,
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"create-forum\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-4\" transform=\"translate(-1170.000000, -653.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n        <g id=\"noun-gift-132953\" transform=\"translate(1194.514085, 682.500000) scale(-1, 1) translate(-1194.514085, -682.500000) translate(1170.000000, 653.000000)\">\n            <path d=\"M15.9801177,0.0772907817 C15.5302285,-0.0123762809 15.0911567,-0.036464968 14.6200952,0.0723836239 C13.6779986,0.289185233 12.9325156,0.926228395 12.386631,1.82424661 C11.3516693,3.53054288 11.3021395,5.18122265 12.0347581,6.48963818 C12.7663596,7.7975969 14.1119722,8.73885209 15.6396036,9.51291515 C17.604286,10.5072744 19.7665593,11.2090474 21.7328267,11.8714206 C17.1487438,12.5941041 13.4458953,12.2456958 10.8208155,11.5765504 C7.60494404,10.7566122 5.99991407,9.63374116 5.99991407,9.63374116 L5.99939817,9.63329497 C5.79353908,9.43611332 5.49842067,9.32593096 5.19144151,9.33173243 C4.88394725,9.33708555 4.59502337,9.45798305 4.39844946,9.66273632 C4.20239067,9.86705562 4.11881077,10.1351569 4.1693708,10.3974681 C4.21993215,10.6593339 4.39947968,10.8899654 4.66209333,11.028253 C4.66209333,11.028253 6.68145666,12.4339689 10.2429801,13.341306 C13.7333127,14.2303936 18.8029198,14.6331622 25.1468298,13.0763224 C25.3578532,13.1102268 28.5514428,13.6366217 32.5257146,13.4345407 C36.6345755,13.2262129 41.6072362,12.2532323 44.64097,8.92583469 L44.640454,8.92628076 C45.009352,8.52345506 44.9314383,7.93861376 44.4660694,7.61877885 C44.0007005,7.29936649 43.3243083,7.36584364 42.9538913,7.76777857 C40.504213,10.4510754 36.1864024,11.3892471 32.3710222,11.5823631 C30.7354819,11.665338 29.3786293,11.5850397 28.1810645,11.5002803 C29.2041655,10.9475641 29.6509772,10.815512 30.9629228,9.85816566 C32.2032284,8.95302122 33.3815624,7.93328622 34.1276794,6.76351226 C34.8747474,5.59693596 35.1595504,4.13423315 34.2680139,2.88771526 C33.6932568,2.08383399 32.6308886,1.60202599 31.5541766,1.63822811 C30.477425,1.6703475 29.4300742,2.132507 28.4549314,2.92391738 C26.9148845,4.17032107 25.6936775,6.56674173 24.8639542,9.66413599 C24.8381577,9.62175666 24.8200998,9.60971175 24.793787,9.56643936 C23.9564294,8.17728282 22.8028207,6.30984713 21.5150457,4.61245863 C20.228816,2.91507013 18.863682,1.36351795 17.2858604,0.523445973 C16.8906522,0.312879808 16.4278589,0.163446124 15.9779697,0.0751106602 M15.1421575,1.83325477 C15.3521374,1.78507511 15.6689301,1.8198714 16.1626829,2.08396304 C17.1507035,2.6117032 18.4962633,4.00884248 19.7128475,5.61395553 C20.8798886,7.15340227 21.931915,8.86609387 22.746053,10.2124246 C20.6698955,9.49821492 18.5205659,8.82863553 16.7229641,7.91855755 C15.3810364,7.23959073 14.3806664,6.47492652 13.9343698,5.68087807 C13.4896317,4.8863728 13.4122464,4.04184694 14.2258692,2.69962753 C14.6050826,2.07418732 14.9301171,1.88237317 15.1401102,1.83374584 M31.6289138,3.45621764 C32.0303166,3.44328081 32.237721,3.55034544 32.46009,3.86039093 C32.9022525,4.4786935 32.8078289,5.05951488 32.2759052,5.89102168 C31.7450116,6.72255133 30.7394244,7.63306327 29.6080315,8.4556623 C28.3785564,9.35366909 27.9053948,9.5164987 26.9396296,10.0371355 C27.7119908,7.23209906 28.7635153,5.16126911 29.8706056,4.26238296 C30.5748534,3.69137156 31.225477,3.46341238 31.6288477,3.45091865\" id=\"Shape\"></path>\n            <polygon id=\"Path\" points=\"0 15.7887324 23.2676056 15.7887324 23.2676056 36.5633803 3.75442901e-15 36.5633803\"></polygon>\n            <polygon id=\"Path\" points=\"25.7605634 15.7887324 49.028169 15.7887324 49.028169 36.5633803 25.7605634 36.5633803\"></polygon>\n            <polygon id=\"Path\" points=\"0 38.2253521 23.2676056 38.2253521 23.2676056 59 3.75442901e-15 59\"></polygon>\n            <polygon id=\"Path\" points=\"25.7605634 38.2253521 49.028169 38.2253521 49.028169 59 25.7605634 59\"></polygon>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};


/***/ },

/***/ 93:
/***/ function(module, exports) {

	window.infinitySVG = function(props) {
	  var base_height, base_width, fill_color, style;
	  base_width = 59;
	  base_height = 29;
	  svg.setSize(base_width, base_height, props);
	  fill_color = props.fill_color || 'black';
	  style = props.style || {};
	  return SVG({
	    width: props.width,
	    height: props.height,
	    viewBox: "0 0 " + base_width + " " + base_height,
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    style: style,
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"create-forum\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-4\" transform=\"translate(-1872.000000, -674.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n        <g id=\"noun-unlimited-4531056\" transform=\"translate(1872.000000, 674.000000)\">\n            <path d=\"M59,14.499707 C58.9953237,18.3440227 57.4627947,22.0292244 54.7385472,24.7477736 C52.0138292,27.4658533 48.3202651,28.9949199 44.4672259,28.9994961 C39.8520937,29.001788 35.518983,26.7837519 32.8287238,23.0425786 C32.506222,22.602551 32.3716208,22.0529742 32.4552276,21.5144508 C32.5383793,20.9763382 32.8328518,20.4927654 33.2734192,20.1710173 C33.7144453,19.848788 34.2648106,19.7149492 34.8046618,19.7979091 C35.3444542,19.8813313 35.8291243,20.1751359 36.1516143,20.6147059 C38.070019,23.2947673 41.1664926,24.8875498 44.4672495,24.8925954 C48.1889216,24.8925954 51.6275138,22.9120019 53.4885263,19.696163 C55.3490684,16.4807933 55.3490684,12.5186676 53.4885263,9.30329798 C51.6275138,6.08745902 48.1889216,4.1068655 44.4672495,4.1068655 C40.5508202,4.11832452 36.924292,6.16760271 34.9001587,9.51322048 L27.6324015,21.5993116 L27.6324015,21.5988533 C24.8599351,26.1778391 19.8951574,28.9835723 14.5333386,29 C9.34122662,29 4.543686,26.2365094 1.94704199,21.7501054 C-0.649013995,17.2637015 -0.649013995,11.7367203 1.94704199,7.25031629 C4.54309797,2.76391233 9.34063859,0.000421722442 14.5333386,0.000421722442 C19.1484708,-0.00187017593 23.4815816,2.21616598 26.1718407,5.95733922 C26.6064337,6.55000358 26.6914282,7.32834785 26.3946471,8.00024065 C26.0978777,8.67174622 25.464823,9.13469044 24.7334488,9.21401275 C24.001616,9.29330924 23.2835902,8.97750085 22.8490325,8.38529412 C20.9306278,5.70523275 17.8341543,4.11245021 14.5333974,4.10740456 C10.8117252,4.10740456 7.37313299,6.08799808 5.51212049,9.30383705 C3.65157842,12.5192067 3.65157842,16.4813324 5.51212049,19.696702 C7.37313299,22.912541 10.8117252,24.8931345 14.5333974,24.8931345 C18.4498267,24.8816755 22.0763548,22.8323973 24.1004882,19.4867795 L31.3682453,7.40068839 L31.3682453,7.40114672 C34.1407117,2.82216095 39.1054895,0.0164276967 44.4673083,0 C48.3203474,0.00458356206 52.0139115,1.53364283 54.7386295,4.25172258 C57.4628771,6.9702717 58.9954133,10.6554734 59,14.4997891 L59,14.499707 Z\" id=\"Path\"></path>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};


/***/ },

/***/ 94:
/***/ function(module, exports) {

	styles += "[data-widget=\"TestimonialGrid\"] .testifier {\n  padding: 0px 16px;\n  flex: 1;\n} @media (max-width: 374px) { [data-widget=\"TestimonialGrid\"] .testifier {\n  padding: 0px 0px 0px 16px;\n}}\n\n[data-widget=\"TestimonialGrid\"].single .testifier {\n  padding: 0;\n}\n\n\n[data-widget=\"TestimonialGrid\"] .testimonial.embedded {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 16px;\n}\n\n[data-widget=\"TestimonialGrid\"] .testimonial.embedded strong {\n  font-weight: 600;\n}\n\n\n\n[data-widget=\"TestimonialGrid\"] .testifier_name {\n  font-size: " + (responsive_css_rule({
	  min_size: 18,
	  max_size: 22,
	  min_vw: 450,
	  max_vw: 650
	})) + ";\n  font-weight: 600;\n}\n[data-widget=\"TestimonialGrid\"] .testifier_affiliation {\n  font-size: " + (responsive_css_rule({
	  min_size: 15,
	  max_size: 18,
	  min_vw: 360,
	  max_vw: 650
	})) + ";\n  color: black;\n  font-weight: 600;\n  margin-top: 2px;             \n\n}\n[data-widget=\"TestimonialGrid\"] .testifier_role {\n  font-size: " + (responsive_css_rule({
	  min_size: 14,
	  max_size: 15,
	  min_vw: 450,
	  max_vw: 650
	})) + ";\n  margin-top: 2px;\n}\n\n[data-widget=\"TestimonialGrid\"] .testifier_avatar {\n  height: " + (responsive_css_rule({
	  min_size: 40,
	  max_size: 75,
	  min_vw: 400,
	  max_vw: 500
	})) + ";\n  aspect-ratio: 1/1;\n  vertical-align: middle;\n  border-radius: 50%;\n}\n\n[data-widget=\"TestimonialGrid\"] .testifier_name_container {\n  position: relative;\n  top: 20px;\n  padding: 12px " + (responsive_css_rule({
	  min_size: 0,
	  max_size: 20,
	  min_vw: 400,
	  max_vw: 500
	})) + ";\n  white-space: nowrap;\n}\n\n[data-widget=\"TestimonialGrid\"] .testifier_name_wrapper {\n  display: inline-block;\n  padding: 0 16px;\n  padding-right: " + (responsive_css_rule({
	  min_size: 0,
	  max_size: 16,
	  min_vw: 374,
	  max_vw: 500
	})) + ";  \n  vertical-align: middle;\n}\n\n[data-widget=\"TestimonialGrid\"] .quote_bubble {\n  padding: 36px 42px;\n  position: relative;\n  box-shadow: 0px 1px 4px rgba(0,0,0,.3);\n  border-radius: 54px;\n  flex: 1;\n  max-Width: 800px;\n}\n\n@media (max-width: 868px) {\n  [data-testimonial-num=\"1\"] {\n    display: none;\n  }\n}\n@media (max-width: 1119px) {\n  [data-testimonial-num=\"2\"] {\n    display: none;\n  }\n}\n\n";
	
	window.TestimonialGrid = ReactiveComponent({
	  displayName: 'TestimonialGrid',
	  render: function() {
	    var expanded, max_testimonials, min_pixels_per, odd, quote_row, the_testimonials, top, user_row, w;
	    the_testimonials = this.props.testimonials;
	    expanded = this.local.expanded;
	    if (this.props.top == null) {
	      top = true;
	    } else {
	      top = this.props.top;
	    }
	    w = Math.min(WINDOW_WIDTH(), 520 * the_testimonials.length);
	    if (w < 869) {
	      max_testimonials = 1;
	    } else if (w < 1120) {
	      max_testimonials = 2;
	    } else {
	      min_pixels_per = 375;
	      max_testimonials = Math.max(1, w / min_pixels_per);
	    }
	    if (max_testimonials < the_testimonials.length) {
	      the_testimonials = the_testimonials.slice(0, +(max_testimonials - 1) + 1 || 9e9);
	    }
	    odd = the_testimonials.length % 2 === 1;
	    user_row = (function(_this) {
	      return function() {
	        var idx, single, t;
	        single = the_testimonials.length === 1;
	        return DIV({
	          key: 'user_row',
	          style: {
	            display: 'flex'
	          }
	        }, (function() {
	          var i, len1, results;
	          results = [];
	          for (idx = i = 0, len1 = the_testimonials.length; i < len1; idx = ++i) {
	            t = the_testimonials[idx];
	            results.push(DIV({
	              key: idx,
	              "data-testimonial-num": idx,
	              className: 'testifier',
	              style: {
	                opacity: expanded && expanded !== t ? .35 : void 0
	              }
	            }, this.user_credentials({
	              testimonial: t,
	              left: odd || idx < the_testimonials.length / 2,
	              top: top,
	              bg_color: considerit_gray,
	              right_side: idx > the_testimonials.length / 2
	            })));
	          }
	          return results;
	        }).call(_this));
	      };
	    })(this);
	    quote_row = (function(_this) {
	      return function() {
	        var center, i, idx, left, len, len1, t;
	        len = the_testimonials.length;
	        for (idx = i = 0, len1 = the_testimonials.length; i < len1; idx = ++i) {
	          t = the_testimonials[idx];
	          if (!expanded || expanded !== t) {
	            continue;
	          }
	          left = idx === 0;
	          center = len === 3 && idx === 1;
	        }
	        return DIV({
	          key: 'quote_row',
	          style: {
	            display: 'flex',
	            justifyContent: expanded ? (left ? 'left' : center ? 'center' : 'right') : void 0
	          }
	        }, (function() {
	          var j, len2, results;
	          results = [];
	          for (idx = j = 0, len2 = the_testimonials.length; j < len2; idx = ++j) {
	            t = the_testimonials[idx];
	            if (expanded && expanded !== t) {
	              continue;
	            }
	            results.push(this.quote_bubble({
	              idx: idx,
	              key: this.local.key,
	              testimonial: t,
	              top: top,
	              bg_color: considerit_gray,
	              color: 'black',
	              italic: this.props.italic,
	              single: len === 1
	            }));
	          }
	          return results;
	        }).call(_this));
	      };
	    })(this);
	    return DIV({
	      className: the_testimonials.length === 1 ? 'single' : void 0
	    }, top ? [user_row(), quote_row()] : [quote_row(), user_row()]);
	  },
	  user_credentials: function(opts) {
	    var avatar_and_mouth, expanded, left, mouth_dir_left, t, top;
	    t = opts.testimonial;
	    expanded = this.local.expanded === t;
	    left = opts.left;
	    mouth_dir_left = left && !(expanded && opts.right_side);
	    top = opts.top;
	    avatar_and_mouth = (function(_this) {
	      return function() {
	        var size;
	        size = WINDOW_WIDTH() < 400 ? 40 : 75;
	        return DIV({
	          style: {
	            display: 'inline-block'
	          }
	        }, t.avatar ? IMG({
	          title: t.alt,
	          className: 'testifier_avatar',
	          alt: t.alt || ("Image of " + t.name),
	          ref: "avatar-" + (t.name.replace(' ', '-')),
	          src: t.avatar
	        }) : void 0, DIV({
	          style: {
	            transform: !top ? "rotate(180deg) " + (mouth_dir_left ? 'scaleX(-1)' : '') : "" + (!mouth_dir_left ? 'scaleX(-1)' : ''),
	            position: 'absolute',
	            left: left ? size / 2 + (mouth_dir_left ? 28 : 0) : void 0,
	            right: !left ? size / 2 + 20 : void 0,
	            bottom: top ? -30 : void 0,
	            top: !top ? -30 : void 0,
	            zIndex: 2
	          }
	        }, Bubblemouth({
	          apex_xfrac: 0,
	          width: 30,
	          height: 30,
	          fill: opts.bg_color,
	          stroke: 'transparent',
	          stroke_width: 0,
	          box_shadow: {
	            dx: top ? -3 : 3,
	            dy: 0,
	            stdDeviation: top ? 1 : 2,
	            opacity: top ? .15 : .4
	          }
	        })));
	      };
	    })(this);
	    return DIV({
	      className: 'testifier_name_container',
	      style: {
	        float: !left ? 'right' : void 0,
	        cursor: t.long_quote ? 'pointer' : void 0
	      },
	      onClick: t.long_quote ? (function(_this) {
	        return function(e) {
	          if (expanded) {
	            _this.local.expanded = null;
	          } else {
	            _this.local.expanded = t;
	          }
	          return save(_this.local);
	        };
	      })(this) : void 0
	    }, left ? avatar_and_mouth() : void 0, DIV({
	      className: 'testifier_name_wrapper',
	      style: {
	        textAlign: !left ? 'right' : void 0
	      }
	    }, DIV({
	      className: 'testifier_name',
	      style: {
	        color: fetch('colors').primary_color
	      }
	    }, t.name), t.organization ? DIV({
	      className: 'testifier_affiliation'
	    }, t.organization) : void 0, t.role ? DIV({
	      className: 'testifier_role'
	    }, t.role) : void 0), !left ? avatar_and_mouth() : void 0);
	  },
	  quote_bubble: function(opts) {
	    var expanded, quote, t;
	    t = opts.testimonial;
	    expanded = this.local.expanded === t;
	    if (expanded) {
	      quote = opts.long_quote || t.long_quote;
	    } else if (WINDOW_WIDTH() < 414 && (opts.short_mobile_quote || t.short_mobile_quote)) {
	      quote = opts.short_mobile_quote || t.short_mobile_quote;
	    } else {
	      quote = opts.short_quote || t.short_quote;
	    }
	    return DIV({
	      key: opts.idx,
	      "data-testimonial-num": opts.idx,
	      className: 'quote_bubble',
	      style: {
	        backgroundColor: opts.bg_color,
	        marginTop: top ? 20 + 24 : void 0,
	        marginBottom: !top ? 20 : 4,
	        marginRight: !opts.single ? 16 : 4,
	        marginLeft: !opts.single ? 16 : 4,
	        color: opts.color
	      }
	    }, DIV({
	      className: 'testimonial embedded',
	      style: {
	        fontStyle: !expanded && opts.italic ? 'italic' : void 0
	      }
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: quote
	      }
	    })), t.long_quote && !this.props.hide_full ? this.readmore({
	      testimonial: t
	    }) : void 0);
	  },
	  readmore: function(opts) {
	    var onclick, t;
	    t = opts.testimonial;
	    onclick = (function(_this) {
	      return function() {
	        if (_this.local.expanded === t) {
	          _this.local.expanded = null;
	        } else {
	          _this.local.expanded = t;
	        }
	        return save(_this.local);
	      };
	    })(this);
	    return BUTTON({
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        color: 'black',
	        textDecoration: 'underline',
	        paddingTop: 12,
	        paddingLeft: 0
	      },
	      onClick: onclick,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 16 || e.which === 32) {
	            e.preventDefault();
	            return onclick();
	          }
	        };
	      })(this)
	    }, this.local.expanded === t ? "read less from " + (t.name.split(' ')[0]) : "read more from " + (t.name.split(' ')[0]));
	  },
	  componentDidMount: function() {
	    this.local.dummy = true;
	    return save(this.local);
	  }
	});
	
	styles += "blockquote {\n  /* background: #f9f9f9; */\n  /* border-left: 6px solid #ccc; */\n  margin: 1.5em 0px 1.5em 0px;\n  padding: 0.5em 26px;\n  quotes: initial; /*\"\x01C\"\"\x01D\"\"\x018\"\"\x019\";*/\n  color: #333;\n  font-size: 18px;\n  line-height: 1.6;\n  font-weight: 300;\n  font-style: italic;\n}\n\nblockquote:before {\n  color: #ccc;\n  content: open-quote;\n  font-size: 4em;\n  line-height: 0.1em;\n  margin-right: -27px;\n  vertical-align: -0.4em;\n  position: relative;\n  left: -36px;\n}\n";
	
	window.TestimonialBlockquote = ReactiveComponent({
	  displayName: 'TestimonialBlockquote',
	  render: function() {
	    var testimonial;
	    testimonial = this.props.testimonial;
	    return DIV({
	      className: "blockquote",
	      style: {
	        maxWidth: 800,
	        margin: 'auto'
	      }
	    }, BLOCKQUOTE({
	      dangerouslySetInnerHTML: {
	        __html: testimonial.short_quote
	      }
	    }), DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'right'
	      }
	    }, testimonial.avatar ? DIV(null, IMG({
	      title: testimonial.alt,
	      alt: testimonial.alt,
	      ref: "avatar-" + (testimonial.name.replace(' ', '-')),
	      src: testimonial.avatar,
	      style: {
	        height: 40,
	        width: 40,
	        verticalAlign: 'middle'
	      }
	    })) : void 0, DIV({
	      style: {
	        display: 'inline-block',
	        padding: '0 16px',
	        verticalAlign: 'middle'
	      }
	    }, testimonial.name ? DIV({
	      style: {
	        fontSize: 18
	      }
	    }, testimonial.name) : void 0, testimonial.organization ? DIV({
	      style: {
	        fontSize: 16
	      }
	    }, testimonial.organization) : void 0, testimonial.role ? DIV({
	      style: {
	        fontSize: 16
	      }
	    }, testimonial.role) : void 0)));
	  }
	});
	
	window.testimonials = {
	  daniel: {
	    alt: 'Daniel Reeves uses Consider.it to get feedback about priorities from users of his company\'s product Beeminder',
	    name: 'Daniel Reeves, Ph.D.',
	    role: 'Co-founder / CEO',
	    organization: 'Beeminder',
	    avatar: asset('product_page/daniel.png'),
	    short_quote: "<b>Consider.it is a much nicer way to poll opinions and see a consensus emerge than other ways we (Beeminder) know of</b>. \nSo far we've used it for prioritizing features, brainstorming taglines, and for naming things. It's great! \nAnd working with Consider.it has been amazing. They're responsive, brilliant, and passionate."
	  },
	  kehau: {
	    alt: "Kēhau Abad uses Consider.it to help organize her community's efforts to lead Hawai’i toward a regenerative future.",
	    name: 'Kēhau Abad, Ph.D.',
	    role: 'Board of Directors',
	    organization: 'ʻĀina Aloha Economic Futures',
	    avatar: asset('product_page/kehau.jpg'),
	    short_mobile_quote: "<p>The momentum our Consider.it dialogue produced contributed in part to \nthe passage of bills on climate change mitigation, sustainable agriculture, raising \nthe minimum wage, and protections \nfor traditional water rights.</p>\n",
	    short_quote: "<p><a style=\"font-weight: 400; text-decoration: none;\" href=\"https://ainaalohafutures.consider.it\" target=\"_blank\">Our Consider.it record</a> of robust conversation has proven invaluable.</p>\n\n<p>Hawai’i policy makers can readily see that a \nlarge community of engaged participants collectively arrived at the proposals offered in \nit. It helped us garner \n<a style=\"font-weight: 400; text-decoration: none;\" href=\"https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0\" target=\"_blank\">many signatories</a> \nincluding three of four county mayors, three of four county councils, the largest private \nlandowner in Hawai’i, and the Hawai’i Tourism Authority.</p>\n\n<p><b>The momentum our Consider.it dialogue produced contributed in part to \nthe passage of bills on climate change mitigation, sustainable agriculture, raising \nthe minimum wage, and protections \nfor traditional water rights.</b></p> ",
	    long_quote: "<p>\n<a href=\"https://www.ainaalohafutures.com/\" target=\"_blank\">‘Āina Aloha Economic Futures</a> (AAEF) formed \nin response to the reset opportunity COVID provided us in Hawaiʻi. \nFrom spontaneous conversations among like-minded friends arose the idea to organize larger community \nconversations to set a new course for Hawaiʻi. We drafted \n<a href=\"https://www.ainaalohafutures.com/declaration\" target=\"_blank\">core values</a>, \nan <a href=\"https://www.ainaalohafutures.com/action-agenda\" target=\"_blank\">action agenda</a>, and \norganized <a href=\"https://www.ainaalohafutures.com/proposals\" target=\"_blank\">14 virtual community sessions</a> \nopen to all, which encouraged participants from across our \nisland chain to offer proposal sketches for policy changes and action initiatives.\n</p>\n\n<p>\nFollowing those sessions, Consider.it enabled us to continue a meaningful, productive one-month \nvirtual conversation about improving Hawaiʻi’s future.\nWith minimal guidance (a quick sharing of the Consider.it tutorial video), participants could \neasily offer their general level of agreement or disagreement regarding each proposal, share \nas many succinct pro/con comments as they wished regarding the proposals, read what \nothers had to say about the proposals, and adopt comments that resonated with them. \nIn real time, Consider.it created an intuitive pictorial graph of everyone’s level of \nsupport for a proposal, along with the underlying reasoning.\n</p>\n\n\n<p>All told, these Consider.it discussions involved \nnearly 500 participants who offered over 3,250 assessments of 192 proposals. Consider.it was the ideal tool \nfor us to facilitate this level of engagement. Anyone hoping to coordinate a community-wide conversation in a \nway that’s easy for participants and productive for organizers would greatly benefit from \nincluding Consider.it in their process. \n</p>\n\n<p>\nFurthermore, <a href=\"https://ainaalohafutures.consider.it\" target=\"_blank\">the Consider.it record</a> of the robust online conversation we held has proven invaluable. We were able to develop a \n<a href=\"https://docs.google.com/document/d/1GJdVPM84fA0x9UBGpii0UjBgvEiV4INr2ES5FXmRpjk/edit\" target=\"_blank\">Policy Playbook</a> \nthat spotlighted salient points raised through the proposals and the Consider.it discussion of them. It helped AAEF garner \n<a href=\"https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0\" target=\"_blank\">many additional signatories</a> \nsupporting the effort, including three of four county mayors, three of four county councils, the largest private landowner \nin Hawai’i (Kamehameha Schools), the state government agency charged with overseeing Hawaiʻi’s visitor industry \n(Hawai’i Tourism Authority), and the University of Hawaiʻi John A. Burns School of Medicine.\n</p>\n\n\n<p>\nHawai’i state and county policy makers who each received a copy of the Playbook could readily see in our Consider.it \nrecord that a large community of engaged participants collectively arrived at the proposals offered in it, \naffording the Playbook a significant degree of impact. While AAEF did not actively lead the way in specific legislative \nbills this session, the overall momentum the AAEF Consider.it results produced played a contributing role in \nthe passage of bills relating to climate change mitigation, sustainable agriculture, raising the minimum wage, \nand protections for traditional water rights. \n</p>\n\n<p>The Consider.it team has consistently exceeded all our expectations. Travis was \nalways quick to reply to questions and requests and has always gone the extra mile to \nhelp us make the most of the amazing suite of tools that Consider.it offers. He has \neven regularly reached out to provide us options we didn’t even realize were possible.</p> \n<p>It’s clear that Consider.it’s ability to raise up community voices means a lot to \nTravis and the Consider.it team. ‘Āina Aloha Economic Futures most deeply appreciates \nall that Consider.it, Travis, and his team have done to support our initiative.\n</p>      \n\n"
	  },
	  susie: {
	    alt: "Susie Philipsen uses Consider.it to help foster public engagement on behalf of the City of Seattle.",
	    name: 'Susie Philipsen',
	    role: "Senior Public Relations Specialist",
	    organization: "City of Seattle",
	    avatar: asset('product_page/susie.png'),
	    short_quote: "<p>Working with the Consider.it team on \n<a style=\"font-weight: 400; text-decoration: none;\" href=\"https://hala.consider.it\" target=\"_blank\">Seattle’s dialogue about Housing Affordability</a> \nhas been a fantastic experience!</p>\n\n<p><b>We’ve created a great feedback loop with residents \nvia Consider.it. Residents are acknowledging the information we are providing them, \nlearning from it, and even thanking us.</b></p>\n\n<p>If you’re looking to create quality online \ndialogues, Consider.it is an excellent choice. They bring far more to the table than technical skills \n– they think deeply about how the tool is going to be received and help us build a \nbetter dialogue using that knowledge.</p>",
	    long_quote: "<p>Working with the Consider.it team on <a href='https://hala.consider.it'>Seattle’s dialogue about Housing Affordability</a> has been a fantastic experience. They bring far more to the table than technical skills – they think deeply about how the tool is going to be received and help us build a better dialogue using that knowledge. Furthermore, the Consider.it team is very responsive - the back and forth communication has been very easy.</p> \n\n<p>We’ve created a great feedback loop with residents \nvia Consider.it. Residents are acknowledging the information we are providing them, \nlearning from it, and even thanking us.</p>\n\n\n<p>Some of the ways the Consider.it team helped our team include:</p>\n\n<ul>\n<li><strong>Framing content for a general audience</strong>. We spent a lot of time writing technically correct questions, but the Consider.it team helped us recognize how difficult these questions are to understand. They helped us refine all the content. This included setting expectations about how residents’ feedback fits into the larger process. </li>\n\n<li><strong>Translating our needs into a good digital experience</strong>. Being new to online dialogue, the consider.it team helped us focus our goals for information gathering. We wanted to collect demographic information so we could assess outreach effectiveness. We collaborated to identify the minimal information to collect from residents to answer critical questions.</li>\n\n<li><strong>Outreach and recruitment</strong>. The consider.it team helps us understand which populations are providing feedback. I can then focus our online advertising on recruiting people from underrepresented neighborhoods and groups.</li>\n\n<li><strong>How to engage with residents</strong>. The team encouraged us to engage directly with residents by responding to questions and concerns online. This support made me more proactive in answering questions. When I don’t know the answer, I reach out to the technical experts and ask them to respond that day so we can keep the conversation going. Residents are acknowledging the information we are providing them, learning from it, and even thanking us.</li>\n\n</ul>\n<p>If you’re looking to create quality online dialogues, Consider.it is an excellent choice.</p>"
	  },
	  russ: {
	    alt: "Russ Lehman uses Consider.it to engage in participatory strategic planning in his non-profit organization.",
	    name: 'Russ Lehman',
	    role: "Executive Director",
	    organization: "WSFFN",
	    avatar: asset('product_page/Russ.png'),
	    short_quote: "<p>\nWhen we embarked on rebranding, I was daunted with the task of engaging constituents across the state. \nAs a small non-profit, we didn’t have the funds to reach everyone in-person. With Consider.it, we \ncould engage far more people for a cost we could afford.\n</p>\n\n<p>\nBeyond the great tool, the Consider.it team was incredibly knowledgeable, creative, thoughtful, and \navailable in helping craft an engagement strategy. They helped us structure a lightweight dialogue \nwith all our stakeholders.</p>\n\n<p><b>\nWe got legitimacy and momentum for our new direction, without the \nhassle of bringing everyone together physically.\n</b></p>    ",
	    long_quote: "<p>\nWhen we embarked on rebranding, I was daunted with the task of engaging constituents across the state. \nAs a small non-profit, we didn’t have the funds to reach everyone in-person. With Consider.it, we \ncould engage far more people for a cost we could afford.\n</p>\n\n<p>\nBeyond the great tool, the Consider.it team was incredibly knowledgeable, creative, thoughtful, and \navailable in helping craft an engagement strategy. They helped us structure a lightweight dialogue \nwith all our stakeholders.</p>\n\n<p>\nWe got legitimacy and momentum for our new direction, without the \nhassle of bringing everyone together physically.\n</p>\n\n<p>Some of the ways the Consider.it team helped us include:</p>\n\n<ul>\n<li><strong>Creation of questions</strong> to yield the most valuable information.</li>\n\n<li><strong>Designing a multi-phase process</strong> that first used Consider.it to engage our statewide stakeholders, then to discuss results with our board and eventually leading to a board vote at our annual retreat.</li>\n\n<li><strong>Advice on how to interact with stakeholders</strong> to yield even more substantive results and maintain civil discourse.</li>\n\n<li><strong>Interpretation of responses</strong> to gain deeper insight and assist with reporting lessons back to our board and stakeholders.</li>\n\n</ul>"
	  },
	  pierre: {
	    alt: "Pierre-Elouan Réthoré uses Consider.it to help make decisions in his co-housing community.",
	    name: 'Pierre-Elouan Réthoré, Ph.D.',
	    role: 'Senior Researcher',
	    organization: "Danish Technical University",
	    avatar: asset('product_page/pierre.png'),
	    short_quote: "We had a nearly 50/50 deadlocked split in our housing community. <b>After we started using Consider.it, \npeople could clearly express the reasons behind their opinions, and see other’s reasons. We were able \nto work out a compromise.</b> That’s the first time where I felt like democracy was actually working."
	  },
	  auryn: {
	    alt: "Auryn Macmillan uses Consider.it for community ideation and decision making in large decentralized online communities.",
	    name: 'Auryn Macmillan',
	    role: 'Co-founder',
	    organization: "DAOhub",
	    avatar: asset('product_page/auryn.png'),
	    short_quote: "Consider.it’s careful design choices were critical for not only aggregating \ncommunity opinions, but also in understanding the \nrationale. <b>The ability to get a feel for both the gestalt and the \ngranular details of an issue within the one view is an incredible \nachievement</b> and was a vital part of our community’s decision making \nprocess.",
	    long_quote: "\n<p>\nAt DAOhub, a group of volunteers came together to create a home for the communities of a radical new \nform of human interaction, Decentralised Autonomous Organisations (or DAOs for short). We set \nup a <a href='http://discourse.org' target=\"_blank\">Discourse</a> forum to act as our base \nmeans of communication. However one of the major challenges we faced was effectively \naggregating community sentiment on issues and proposals. This was vital for the DAO to \nfunction properly. The simple polls that ship with Discourse were somewhat limited and \ndid not quite fulfill the need.</p>\n\n<p>\nLuckily, Consider.it beats the hell out of simple polls! It is a fantastic tool for gauging \nthe opinion of a large number of users, while not losing sight of the individuals.</p>\n\n<p>\nConsider.it’s careful design choices were instrumental for us not only in terms of aggregating \ncommunity opinions, but also in picking out the rationale behind community member opinions. \nThis ability to get a feel for both the gestalt and the granular details of an issue within \nthe one view is an incredible achievement and was a vital part in our community’s decision making process.\n</p>\n\n<p>If effectively gauging the opinion/sentiment of your community is something that is important \nor necessary for your business/product/community, then the team at Consider.it would be an \ninvaluable partner. Their product and advice is second to none. Seriously, these \nguys are flat out awesome. Incredibly responsive and receptive to suggestions, and, \nas is evident by the nuance of their platform, they really have a fantastic grasp \non the needs of web based and decentralised communities.</p>"
	  },
	  sheri: {
	    alt: "Sheri Richardson helped us evaluate whether our efforts to make Consider.it accessible was successful.",
	    name: 'Sheri Richardson',
	    role: 'President',
	    organization: 'Guide Dog Users of WA State',
	    short_quote: "Consider.it works well with my screen reading software and allows me the \nopportunity to fully participate in the same way all others can. \n<strong>I appreciate Consider.it’s hard work making their website fully accessible to me \nand other blind computer users.</strong>"
	  }
	};
	
	testimonials.susie_pricing = _.extend({}, testimonials.susie, {
	  short_quote: "They bring far more to the table than technical skills – their team thinks deeply about how Consider.it is going to be received and helped us build a better public dialogue using that knowledge, such as by:<ul><li>framing content for a general audience</li><li>teaching best practices for engaging residents</li><li>creating new features to support our use case</li></ul>"
	});
	
	testimonials.auryn_pricing = _.extend({}, testimonials.auryn, {
	  short_quote: "The Consider.it team is incredibly receptive to suggestions, and, as is evident \nby the nuance of their platform, they really have a fantastic grasp on the needs \nof web based and decentralised communities. They:<ul><li>helped restructure our \norganizational processes</li><li>designed a custom forum homepage</li><li>created \na rich custom embed of consider.it</li></ul>"
	});
	
	testimonials.russ_pricing = _.extend({}, testimonials.russ, {
	  short_quote: "Beyond the great tool, the Consider.it team was extremely knowledgeable and available in helping craft an engagement strategy. They helped us:<ul><li>create clear, valuable questions</li><li>design a multi-phase engagement process</li><li>improve interactions with our network</li><li>interpret responses</li></ul>"
	});
	
	testimonials.kehau_example = _.extend({}, testimonials.kehau, {
	  short_quote: "<p>The Consider.it team has consistently exceeded all our expectations. Travis was \nalways quick to reply to questions and requests and has always gone the extra mile to \nhelp us make the most of the amazing suite of tools that Consider.it offers. He has \neven regularly reached out to provide us options we didn’t even realize were possible.</p> \n<p>It’s clear that Consider.it’s ability to raise up community voices means a lot to \nTravis and the Consider.it team. ‘Āina Aloha Economic Futures most deeply appreciates \nall that Consider.it, Travis, and his team have done to support our initiative.</p>"
	});
	
	delete testimonials.kehau_example.long_quote;


/***/ },

/***/ 95:
/***/ function(module, exports) {

	var Basics, BonusAttribute, BonusFeatures, CompareToOtherTools, Feature, Features, Research, all_features, bonus_features, comparisons, steps;
	
	styles += ".iframe_callout {\n  font-size: 34px;\n  font-weight: 700;\n  padding-bottom: 32px;\n  color: white;\n  font-family: 'Fira Sans Condensed';\n}\n";
	
	window.Tour = ReactiveComponent({
	  displayName: 'Tour',
	  render: function() {
	    var embedded_host, local, src, use_iframe;
	    use_iframe = WINDOW_WIDTH() > 900;
	    return DIV(null, DIV({
	      style: {
	        textAlign: 'center',
	        paddingTop: 40,
	        position: 'relative',
	        zIndex: 1,
	        top: 8
	      }
	    }, !use_iframe ? DIV({
	      style: {
	        width: "min(1050px, var(--SAAS_PAGE_WIDTH))",
	        margin: 'auto'
	      }
	    }, Webframe({
	      href: demo_url(),
	      width: "100%"
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, IMG({
	      loading: "lazy",
	      src: asset('product_page/death_star_example.png'),
	      alt: "Consider.it visually summarizes what people think (on a spectrum) and why (through pros and cons).",
	      style: {
	        aspectRatio: '1716/1112',
	        width: '100%',
	        paddingTop: 10,
	        display: 'block'
	      }
	    })))) : (local = location.origin.indexOf('localhost') > -1, embedded_host = local ? location.origin : location.protocol + "//galacticfederation." + location.host, src = embedded_host + "/1-billion-rcs-to-fight-ewok-flu-investment-we-must-make-before-the-council?embedded_demo=true" + (local ? '&domain=galacticfederation' : ''), DIV(null, use_iframe ? DIV({
	      className: 'condensed main_callout'
	    }, "Learn by doing: weigh in on these joke proposals!") : void 0, DIV({
	      style: {
	        fontSize: 18,
	        color: 'white',
	        marginBottom: 48,
	        textAlign: !use_iframe ? 'right' : void 0
	      }
	    }, use_iframe ? "...or access the " : "Access the", A({
	      href: demo_url(),
	      target: "_blank"
	    }, "full parody forum"), "."), DIV({
	      style: {
	        margin: 'auto',
	        width: "min(1502px, 97vw)"
	      }
	    }, Webframe({
	      browser_loc: demo_url(),
	      width: '100%'
	    }, IFRAME({
	      ref: 'iframe',
	      src: src,
	      width: '100%',
	      style: {
	        backgroundColor: 'white',
	        aspectRatio: "6 / 3",
	        height: '100%',
	        width: '100%'
	      }
	    })))))), DIV({
	      style: {
	        position: 'relative',
	        zIndex: 2,
	        backgroundColor: 'white',
	        boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)',
	        paddingTop: 42
	      }
	    }, H1({
	      className: "bold_callout",
	      style: {
	        fontWeight: 600
	      }
	    }, "The only forum to visually summarize ", WINDOW_WIDTH() > 1000 ? BR(null) : void 0, "what your community thinks and why"), TestimonialGrid({
	      testimonials: [testimonials.pierre, testimonials.auryn, testimonials.daniel]
	    }), Basics(), DIV({
	      style: {
	        maxWidth: 660,
	        fontSize: 16,
	        margin: '56px auto 48px auto',
	        textAlign: 'center',
	        padding: '0 24px'
	      }
	    }, DIV({
	      className: 'light_callout'
	    }, "Want to get started now?"), "It only takes a minute to create a forum! Or learn more about features, below."), ConversionAttempt({
	      backgroundColor: "#9816e2"
	    }), Features({
	      features: all_features
	    }), BonusFeatures({
	      features: bonus_features
	    }), ConversionAttempt({
	      backgroundColor: "#734487",
	      pages: ["create_forum", "contact"]
	    }), CompareToOtherTools(), Research()));
	  },
	  setiframeconsole: function() {
	    var iframeWindow, ref;
	    iframeWindow = (ref = this.refs.iframe) != null ? ref.contentWindow : void 0;
	    if (iframeWindow) {
	      return iframeWindow.console.log = function(val) {
	        return console.log("iframe: ", val);
	      };
	    }
	  },
	  componentDidMount: function() {
	    return this.setiframeconsole();
	  },
	  componentDidUpdate: function() {
	    return this.setiframeconsole();
	  }
	});
	
	steps = [
	  {
	    header: 'Create and tailor your forum',
	    alt: 'Starting and configuring your Consider.it forum only takes a few minutes.',
	    desc: ["Easily create a new forum. Then make it your own by explaining the forum's purpose, adding \na logo, setting an evocative background image, or enabling language translation.", "You can also configure sign-up questions to help you collect relevant data from \nyour participants (in the Premium Plan). "],
	    movie: 'tour1-framing-small-x264',
	    browser_loc: 'https://denverclimateaction.consider.it'
	  }, {
	    header: 'Frame the dialogue & invite participation',
	    alt: 'Invite engagement by asking relevant open-ended questions or proposing solutions to problems your community cares about.',
	    desc: ["You can ask open-ended questions to foster community ideation, or just request \nfeedback on specific proposals. Uses include collaborative prioritization, goal setting, \npolicy feedback, and evaluating strategic direction.", "After you've framed the dialogue, invite participation through social media, mailing lists,\nand other engagement channels."],
	    movie: 'tour2-seeding-small-x264',
	    browser_loc: 'https://denverclimateaction.consider.it'
	  }, {
	    header: 'Participants engage',
	    alt: "Consider.it can create a transparent account of your community’s opinions about the issues and opportunities confronting it.",
	    desc: ["\nParticipants share their overall opinion about proposals \non a spectrum, using a slider. They are also guided to express their underlying \nreasoning, as points in a pro & con list. \nThey can incorporate the pros and cons others have already shared into their own list. \nThis helps show which reasons resonate most.   ", "Your community learns from each other. Important tradeoffs are identified. \nPersonal attacks don’t make sense in the pro/con format. "],
	    movie: 'trimmed-tour3-participation-small-x264',
	    browser_loc: 'https://denverclimateaction.consider.it'
	  }, {
	    header: 'Explore patterns of thought in your community',
	    alt: "Consider.it gives you data that is like a hybrid between a survey and a focus group.",
	    desc: ["Consider.it provides a dynamically updating, interactive summary of what your \ncommunity thinks and why. Use it to learn more about your community!", "For example, you can easily learn the reservations of those who oppose a proposal. \nPerhaps 80% of those who oppose share a concern that can be resolved to \nclear the path forward. "],
	    movie: 'tour4-analyze-small-x264',
	    browser_loc: 'https://denverclimateaction.consider.it'
	  }
	];
	
	styles += "[data-widget=\"Basics\"] {\n  margin: auto;\n  padding: 60px 0px 0px 0px;\n}\n\n[data-widget=\"Basics\"] .step {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 96px 12px 96px 12px;\n  position: relative;\n  margin: auto;\n}\n\n@media (max-width: 700px) {\n  [data-widget=\"Basics\"] .step {\n    padding: 48px 12px 48px 12px;\n  }\n}\n\n\n[data-widget=\"Basics\"] .step.even {\n  background-color: #f5f7fa;\n}\n\n.custom-shape-divider-top-1652629163 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.custom-shape-divider-top-1652629163 svg {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 43px;\n}\n\n[data-widget=\"Basics\"] .step.odd .custom-shape-divider-top-1652629163 .shape-fill {\n  fill: #f5f7fa;\n}  \n\n.custom-shape-divider-top-1652629163 .shape-fill {  \n  fill: #fff;\n}\n\n[data-widget=\"Basics\"] .step.even .text {\n  margin-right: 64px;\n}\n\n[data-widget=\"Basics\"] .step.odd .text {\n  margin-right: 64px;\n}\n\n\n\n\n[data-widget=\"Basics\"] .text {\n  max-width: 420px;\n  /* min-width: 350px; */\n  position: relative;\n}\n\n@media (max-width: 1050px) {\n  [data-widget=\"Basics\"] .step {\n    flex-direction: column;\n  }\n  [data-widget=\"Basics\"] .step.odd .text, [data-widget=\"Basics\"] .step.even .text {\n    margin: 0;\n    max-width: 650px;\n    margin-bottom: 24px;\n  }\n\n}\n\n\n[data-widget=\"Basics\"] .text h2 .numbered {\n  padding-right: 18px;\n}\n\n\n@media (max-width: 810px) {\n  [data-widget=\"Basics\"] .text h2 .numbered {\n  }\n}\n\n@media (min-width: 811px) and (max-width: 1549px) {\n  [data-widget=\"Basics\"] .text h2 .numbered {\n    left: -32px;\n    position: absolute;\n\n  }\n\n}\n\n@media (min-width: 1550px) {\n  [data-widget=\"Basics\"] .text h2 .numbered {\n    position: absolute;\n    font-size: 150px;\n    font-family: 'Fira Sans Condensed';\n    font-weight: 400;\n    color: #c3d5e6;\n    left: -180px;\n  }\n}\n\n\n[data-widget=\"Basics\"] .visual {\n  width: min(650px, var(--SAAS_PAGE_WIDTH));\n}\n\n@media (min-width: 1050px) and (max-width: 1200px){\n  [data-widget=\"Basics\"] .visual {\n    width: 550px;\n  }\n}\n\n\n[data-widget=\"Basics\"] .text h2 {\n  padding-bottom: 16px;\n  font-weight: 700;\n  font-size: 24px;\n  color: #333;\n}\n\n[data-widget=\"Basics\"] .description {\n\n}\n[data-widget=\"Basics\"] .description p {\n  font-size: 15px;\n  color: #333;    \n  padding-bottom: 16px;\n}\n\n[data-widget=\"Basics\"] .video_container {\n  width: 100%;\n  margin: auto;\n  position: relative;\n  background-color: black;\n}\n[data-widget=\"Basics\"] video {\n  width: 100%;\n  margin: auto;\n  position: relative;\n  display: block;\n}";
	
	Basics = ReactiveComponent({
	  displayName: 'Basics',
	  render: function() {
	    var desc, idx, para, play_video, step, visual;
	    play_video = (function(_this) {
	      return function() {
	        var e;
	        e = function() {
	          _this.local.playing = false;
	          _this.local.finished = true;
	          save(_this.local);
	          return _this.refs.video.removeEventListener('ended', e);
	        };
	        _this.refs.video.play();
	        _this.refs.video.addEventListener('ended', e);
	        _this.local.playing = true;
	        _this.local.hovering = true;
	        _this.local.finished = false;
	        return save(_this.local);
	      };
	    })(this);
	    return DIV(null, A({
	      name: 'basics'
	    }), DIV({
	      style: {
	        maxWidth: 820,
	        margin: '48px auto 36px auto',
	        textAlign: 'center'
	      }
	    }, H2({
	      className: 'light_callout'
	    }, "Have you started to imagine hosting a forum?"), "If you decide to host a forum, these are the common stages you'll experience."), (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = steps.length; i < len; idx = ++i) {
	        step = steps[idx];
	        desc = DIV({
	          key: 'desc',
	          className: "text"
	        }, H2(null, SPAN({
	          className: "numbered"
	        }, (idx + 1) + "."), step.header), DIV({
	          className: 'description'
	        }, (function() {
	          var j, len1, ref, results1;
	          ref = step.desc;
	          results1 = [];
	          for (j = 0, len1 = ref.length; j < len1; j++) {
	            para = ref[j];
	            results1.push(P({
	              key: para
	            }, para));
	          }
	          return results1;
	        })()));
	        visual = DIV({
	          key: 'visual',
	          className: "visual"
	        }, Webframe({
	          browser_loc: step.browser_loc,
	          width: "100%",
	          dummy: this.local.hovering,
	          dummy2: this.local.current_step,
	          dummy3: this.local.playing,
	          key: this.local.current_step
	        }, DIV({
	          className: 'video_container'
	        }, VIDEO({
	          loading: "lazy",
	          key: this.local.current_step,
	          ref: 'video',
	          preload: 'true',
	          loop: true,
	          autoPlay: true,
	          controls: true,
	          muted: true,
	          title: step.alt,
	          style: {
	            aspectRatio: "21/9"
	          },
	          onKeyPress: (function(_this) {
	            return function(e) {
	              if (e.which === 32 || e.which === 13) {
	                if (_this.local.hovering) {
	                  return inactivate();
	                } else {
	                  return activate();
	                }
	              }
	            };
	          })(this)
	        }, SOURCE({
	          src: asset("product_page/screencasts/" + step.movie + ".mp4"),
	          type: "video/mp4"
	        }), step.alt || "Your browser does not support the video element."))));
	        results.push(DIV({
	          key: idx,
	          className: "step " + (idx % 2 ? 'odd' : 'even')
	        }, DIV({
	          dangerouslySetInnerHTML: {
	            __html: "\n<div class=\"custom-shape-divider-top-1652629163\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 120\" preserveAspectRatio=\"none\">\n        <path d=\"M649.97 0L550.03 0 599.91 54.12 649.97 0z\" class=\"shape-fill\"></path>\n    </svg>\n</div>"
	          }
	        }), [desc, visual]));
	      }
	      return results;
	    }).call(this));
	  },
	  componentDidMount: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this), {
	      play_only_topmost_video: true
	    });
	  },
	  componentDidUpdate: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this), {
	      play_only_topmost_video: true
	    });
	  }
	});
	
	styles += "[data-widget=\"Features\"] {\n  background-image: linear-gradient(180deg, #8800FF 0%, #FF7900 100%);    \n  color: white;\n  position: relative;\n  padding-top: 0px;\n  padding-bottom: 140px;\n  /* top: -80px; */\n}\n\n[data-widget=\"Features\"] .features {\n  display: flex;\n  width: 100%;\n  padding: 250px 0px 100px 0px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n";
	
	Features = ReactiveComponent({
	  displayName: 'Features',
	  render: function() {
	    var feature;
	    return DIV(null, A({
	      name: 'features'
	    }), DIV({
	      dangerouslySetInnerHTML: {
	        __html: "\n<style> \n  .custom-shape-divider-top-1652638490 {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      overflow: hidden;\n      line-height: 0;\n  }\n\n  .custom-shape-divider-top-1652638490 svg {\n      position: relative;\n      display: block;\n      width: 100%;\n      top: -1px;\n  }\n\n  .custom-shape-divider-top-1652638490 .shape-fill {\n      fill: #FFFFFF;\n  }\n\n  [data-widget=\"Features\"] div.features {\n    padding-top: " + (250 * WINDOW_WIDTH() / 1700) + "px;\n  }\n\n\n</style>\n<div class=\"custom-shape-divider-top-1652638490\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 180\" preserveAspectRatio=\"none\">\n        <path id=\"curve2\" d=\"M 0 0 Q 600 300 1200 0 M 1200 0 V 0 H 0 V 0\" class=\"shape-fill\"/>\n        <text style=\"font-size: 72px; font-weight: 800; fill: #9816e2; text-transform: uppercase;\" text-anchor=\"middle\" x=\"51%\" dy=\"2\">\n          <textPath xlink:href=\"#curve2\">Features</textPath>\n        </text>\n    \n    </svg>\n</div>\n"
	      }
	    }), DIV({
	      className: 'features',
	      style: {
	        width: '100%'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = this.props.features;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        feature = ref[i];
	        results.push(Feature({
	          key: feature.label,
	          feature: feature
	        }));
	      }
	      return results;
	    }).call(this)), DIV({
	      dangerouslySetInnerHTML: {
	        __html: "<style>\n  .custom-shape-divider-bottom-1649436271 {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      overflow: hidden;\n      line-height: 0;\n  }\n\n  .custom-shape-divider-bottom-1649436271 svg {\n      position: relative;\n      display: block;\n      width: 100%;\n  }\n\n  .custom-shape-divider-bottom-1649436271 .shape-fill {\n      fill: #FFFFFF;\n  }\n</style>\n<div class=\"custom-shape-divider-bottom-1649436271\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 160\" preserveAspectRatio=\"none\">\n        <path d=\"M 0 0 Q 600 299 1200 0 M 1200 0 v 160 H 0 V 0\" class=\"shape-fill\"></path>\n    </svg>\n</div>"
	      }
	    }));
	  },
	  componentDidMount: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this));
	  },
	  componentDidUpdate: function() {
	    return play_videos_when_in_viewport(ReactDOM.findDOMNode(this));
	  }
	});
	
	styles += "[data-widget=\"Feature\"] {\n  position: relative;\n  /* min-width: 496px; */\n  max-width: 550px;\n  padding: 36px 24px;\n}\n\n[data-widget=\"Feature\"] h3 {\n  font-weight: 800;\n  font-size: 24px;\n  text-align: center;\n  margin-bottom: 16px;\n  color: white;\n  text-transform: capitalize;\n}\n\n@media (max-width: 700px) {\n  [data-widget=\"Feature\"] h3 {\n    font-size: 20px;\n  }\n}\n\n\n[data-widget=\"Feature\"] .paid_forum {\n  margin-left: 8px;\n  background-color: " + upgrade_color + ";\n  font-size: 12px;\n  padding: 4px 6px;\n  text-transform: lowercase;\n  color: white;\n  border-radius: 8px;\n  vertical-align: middle;\n}\n\n[data-widget=\"Feature\"] .description {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 16px;\n  min-height: 70px;\n}";
	
	Feature = ReactiveComponent({
	  displayName: 'Feature',
	  render: function() {
	    var activate, boxShadow, feature, has_media, inactivate, is_gif, sty;
	    feature = this.props.feature;
	    has_media = !!feature.img || !!feature.video;
	    activate = (function(_this) {
	      return function() {
	        _this.local.hovering = true;
	        return save(_this.local);
	      };
	    })(this);
	    inactivate = (function(_this) {
	      return function() {
	        _this.local.hovering = false;
	        return save(_this.local);
	      };
	    })(this);
	    return DIV({
	      'data-id': feature.id
	    }, A({
	      name: feature.id
	    }), H3(null, feature.label, feature.paid ? SPAN({
	      className: 'paid_forum'
	    }, 'paid') : void 0), DIV({
	      className: 'description embedded',
	      dangerouslySetInnerHTML: {
	        __html: feature.html
	      }
	    }), has_media ? (boxShadow = !feature.testimonial ? '0 1px 4px rgba(0,0,0,.25)' : null, DIV({
	      style: {
	        verticalAlign: 'top',
	        lineHeight: 0,
	        margin: '8px auto 20px auto'
	      }
	    }, feature.img ? (is_gif = feature.img.indexOf('.gif') > -1, sty = {
	      width: '100%',
	      backgroundColor: 'white',
	      transition: is_gif ? 'opacity 500ms' : void 0,
	      boxShadow: boxShadow,
	      transition: 'box-shadow 500ms'
	    }, IMG({
	      loading: "lazy",
	      src: feature.img,
	      style: sty,
	      alt: feature.alt
	    })) : feature.video ? VIDEO({
	      loading: "lazy",
	      ref: 'video',
	      preload: 'true',
	      loop: true,
	      autoPlay: true,
	      muted: true,
	      controls: true,
	      title: feature.alt,
	      style: {
	        position: 'relative',
	        width: '100%',
	        aspectRatio: '1920/1080',
	        boxShadow: boxShadow,
	        transition: 'box-shadow 500ms',
	        display: 'block'
	      }
	    }, SOURCE({
	      key: 'mp4',
	      src: feature.video,
	      type: "video/mp4"
	    }), feature.alt || "Your browser does not support the video element.") : void 0)) : void 0);
	  },
	  componentDidMount: function() {
	    if (this.refs.video && (this.local.video_height == null)) {
	      return this.local.video_height = this.refs.video.parentNode.offsetWidth * 1080 / 1920;
	    }
	  }
	});
	
	all_features = [
	  {
	    id: 'ideas',
	    label: 'Idea generation',
	    html: "Pose open-ended questions to your community, and learn from them! \nSee which ideas gain traction.",
	    video: asset('product_page/screencasts/ideation-x264.mp4'),
	    paid: false,
	    alt: "In Consider.it, you can enable community ideation by asking open-ended questions like \"What are your most important questions?\"."
	  }, {
	    id: 'profile_questions',
	    label: 'Sign-up questions',
	    html: "Collect relevant information from participants (e.g. demographics). This data \ncan be used for comparing opinions between subgroups. ",
	    video: asset('product_page/profile_questions.mp4'),
	    paid: true,
	    alt: "Sign-up questions can help you understand who your participants are."
	  }, {
	    id: 'opinion_analytics',
	    label: 'Opinion analytics',
	    html: "Slice and dice the data to learn what different subgroups think! Can draw on \ndata from sign-up questions. ",
	    video: asset('product_page/screencasts/trimmed-opinion_analytics-small-x264.mp4'),
	    paid: false,
	    alt: "In Consider.it, you can examine similarities and differences of opinions between subgroups."
	  }, {
	    id: 'tab_organization',
	    label: 'Multi-page forums',
	    html: "Structure your forum by separating your topics into different pages. \nYou can even create an About page. ",
	    video: asset('product_page/screencasts/tabs-small-x264.mp4'),
	    paid: true,
	    alt: "When you have lots of questions to ask of your community, you can break them into different tabs to help organize them."
	  }, {
	    id: 'private_forums',
	    label: 'Private forums',
	    html: "Your forum can be set to private so that only people who have been invited can access the dialogue.",
	    img: asset('product_page/private_forum_new.png'),
	    alt: "Private forums allow for sensitive conversations to be accessed only be the relevant parties."
	  }, {
	    id: 'anonymization',
	    label: 'Anonymization',
	    html: "Sometimes names can distort participation. Enable anonymous mode to hide names.",
	    video: asset('product_page/screencasts/anonymization-x264.mp4'),
	    paid: false,
	    alt: "Anonymous mode can help conversations get going when power dynamics are at play."
	  }, {
	    id: 'translation',
	    label: 'Language translation',
	    html: "Google Translate can be featured prominently for multi-lingual forums. We also offer interface translations for a number of languages.",
	    img: asset('product_page/translation.gif'),
	    paid: false,
	    alt: "Language translation in forums is hard to do, but we have options for you."
	  }, {
	    id: 'data_export',
	    label: 'Data export',
	    html: "Export data to CSV for record keeping, or for analysis in an external system. \nWe can work with you if you have other data requirements.         ",
	    img: asset('product_page/data_export_new.png'),
	    paid: true,
	    alt: "The data export feature is easy to use."
	  }, {
	    id: 'moderation',
	    label: 'Comment moderation',
	    html: "Choose an appropriate moderation policy. Explicit moderation is often \nunnecessary as <a href=\"#research\">Consider.it can itself help create more civil discourse</a>.",
	    video: asset('product_page/screencasts/moderation-small-x264.mp4'),
	    paid: false,
	    alt: "Moderation is a great way to feel the pulse of your engagement."
	  }
	];
	
	bonus_features = [
	  {
	    id: 'accessibility',
	    label: 'Disability accessibility',
	    html: "Consider.it is <strong>Level A compliant</strong> with the <a href=\"https://www.w3.org/WAI/intro/wcag.php\" target=\"_blank\" style=\"text-decoration: underline;\">Web Content Accessibility Guidelines (WCAG)</a>. See our <a target=\"_blank\" href=\"https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub\">Accessibility Statement</a>.</p>"
	  }, {
	    id: 'open_source',
	    label: 'Open Source Software',
	    html: "Consider.it's initial design and development was funded by the <a target=\"_blank\" href=\"https://cjmd.com.uw.edu/project-archives/nsf-grant-developing-technologies-for-public-engagement-and-deliberation/\">National Science Foundation</a>. We honor our public support by keeping <a href=\"https://github.com/Considerit/ConsiderIt\" target=\"_blank\">our code </a> open source!"
	  }
	];
	
	styles += "@media (max-width: 566px) {\n  [data-widget=\"BonusFeatures\"] [data-widget=\"BonusAttribute\"]:last-child {\n    display: none;\n  }\n}";
	
	BonusFeatures = ReactiveComponent({
	  displayName: 'BonusFeatures',
	  render: function() {
	    var feature, idx;
	    return DIV({
	      style: {
	        margin: '80px 0'
	      }
	    }, DIV({
	      style: {
	        width: '100%',
	        display: 'flex',
	        justifyContent: 'center',
	        marginTop: -230
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = this.props.features;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        feature = ref[idx];
	        results.push(BonusAttribute({
	          key: feature.label,
	          feature: feature
	        }));
	      }
	      return results;
	    }).call(this)), DIV({
	      style: {
	        paddingTop: 20
	      }
	    }, TestimonialBlockquote({
	      testimonial: testimonials.sheri
	    })));
	  }
	});
	
	styles += "[data-widget=\"BonusAttribute\"] {\n  position: relative;\n  width: 496px;\n}\n\n[data-widget=\"BonusAttribute\"] .tag {\n  padding: 36px 46px;\n  margin: 0 24px;\n  background: #FFFFFF;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.26);    \n}\n\n[data-widget=\"BonusAttribute\"] h3 {\n  font-weight: 600;\n  font-size: 22px;\n  text-align: center;\n  margin-bottom: 16px;\n  text-transform: capitalize;\n}\n\n[data-widget=\"BonusAttribute\"] .description {\n  font-weight: 500;\n  font-size: 15px;\n  margin-bottom: 16px;\n  min-height: 84px;\n}\n\n[data-widget=\"BonusAttribute\"] .accessibility_to_testimony_connector {\n  position: absolute;\n  bottom: -26px;\n  left: calc(50% - 20px);\n}\n@media (max-width: 768px) {\n  [data-widget=\"BonusAttribute\"] .accessibility_to_testimony_connector {\n    display: none;\n  }\n}";
	
	BonusAttribute = ReactiveComponent({
	  displayName: 'BonusAttribute',
	  render: function() {
	    var feature, has_media;
	    feature = this.props.feature;
	    has_media = !!feature.img || !!feature.video || !!feature.testimonial;
	    return DIV({
	      className: 'feature',
	      'data-id': feature.id,
	      style: {
	        position: 'relative'
	      }
	    }, A({
	      name: feature.id
	    }), feature.id === 'accessibility' ? DIV({
	      className: 'accessibility_to_testimony_connector',
	      dangerouslySetInnerHTML: {
	        __html: "<svg width=\"40px\" style=\"height:100%; filter: drop-shadow(0px 2px 1px hsla(0, 0%, 0%, 0.25));\" viewBox=\"0 0 40 20\">\n    <polygon fill=\"white\" points=\"0,0 20,20 40,0\"></polygon>\n</svg>"
	      }
	    }) : void 0, DIV({
	      className: 'tag',
	      style: {
	        paddingBottom: feature.testimonial ? 50 : void 0
	      }
	    }, feature.label ? H3(null, feature.label) : void 0, feature.html ? DIV({
	      className: 'embedded description',
	      dangerouslySetInnerHTML: {
	        __html: feature.html
	      }
	    }) : void 0), feature.testimonial ? DIV({
	      style: {
	        marginTop: -70,
	        padding: '0 20px'
	      }
	    }, TestimonialGrid({
	      testimonials: [testimonials.sheri],
	      minWidth: "min( var(--SAAS_PAGE_WIDTH), 992px )"
	    })) : void 0);
	  }
	});
	
	styles += "[data-widget=\"Research\"] {\n  max-width: 800px;\n  margin: 0px auto 0 auto;\n}\n\n[data-widget=\"Research\"] .intro {\n  margin-bottom: 64px;\n}\n\n@media (max-width: 414px) {\n  [data-widget=\"Research\"] {\n    display: none;\n  }\n}\n\n";
	
	Research = ReactiveComponent({
	  displayName: 'Research',
	  render: function() {
	    var authors, idx, left, paper, papers, reveal, size;
	    authors = function(author_list) {
	      var author, idx;
	      return UL({
	        style: {
	          display: 'inline',
	          position: 'relative',
	          left: 20,
	          top: 5
	        }
	      }, (function() {
	        var i, len, results;
	        results = [];
	        for (idx = i = 0, len = author_list.length; i < len; idx = ++i) {
	          author = author_list[idx];
	          results.push(LI({
	            key: idx,
	            style: {
	              display: 'inline-block',
	              listStyle: 'none',
	              zIndex: 10 - idx,
	              position: 'absolute',
	              left: 40 * idx,
	              top: 4
	            }
	          }, Avatar({
	            key: "/user/" + author,
	            user: "/user/" + author,
	            img_size: 'large',
	            alt: fetch("/user/" + author).name,
	            style: {
	              width: 50,
	              height: 50
	            }
	          })));
	        }
	        return results;
	      })());
	    };
	    papers = [
	      {
	        url: "http://www.sciencedirect.com/science/article/pii/S0747563215003891",
	        title: 'Facilitating Personal Deliberation Online: Effects of Two Consider.it Variations',
	        venue: 'Computers in Human Behavior, Volume 51, Part A',
	        quote: "...<b>working with Consider.it had significant and meaningful effects on \nparticipants’ deliberation and deliberative attitudes</b>. The application urged participants \nto reconsider and often change their original opinion, and the participants generally felt \ntheir knowledge and understanding of the subject-matter had changed.",
	        authors: [324679, 324678]
	      }, {
	        url: "https://homes.cs.washington.edu/~borning/papers/kriplean-cscw2012.pdf",
	        title: 'Supporting Reflective Public Thought with Consider.it',
	        venue: 'ACM Conference on Computer Supported Cooperative Work',
	        quote: "…Given the partisan rancor of our political discourse, especially in online web forums, \none might expect few people participating in a public [Consider.it] online discussion \nduring a contentious election to acknowledge the importance of factors on both sides \nof the debate. However, <strong>we found 41.4% of all Consider.it opinions included \nboth a pro and a con</strong>.",
	        authors: [323666, 324672, 324669, 324670, 324671],
	        hide_quote: true
	      }, {
	        url: "https://f.consider.it/papers/jitp.pdf",
	        title: 'Facilitating Diverse Political Engagement',
	        venue: 'Journal of Information Technology & Politics, Volume 9, Issue 3',
	        quote: "Citizens rely on group identity cues to direct their political attentions, which \ncan lead to the views of opposing groups being ignored. But many [Consider.it] users \ndid engage with the ideas of users who took stances opposite their own. Over \none-third (33.7%) of point-considering stances recognized points written by \ndissenting others and over half (56.4%) chose to read more about such points. \nTaken together, these metrics show <b>[Consider.it] users embraced political \ndiversity in terms of both arguments and the stances of other users</b>.",
	        authors: [324669, 323666, 324672, 324671, 324670],
	        hide_quote: true
	      }, {
	        url: "http://homes.cs.washington.edu/~borning/papers/kriplean-cscw2014.pdf",
	        title: 'On-demand Fact-checking in Public Dialogue',
	        venue: 'ACM Conference on Computer Supported Cooperative Work',
	        authors: [324673, 323666, 324670, 324675, 324674]
	      }
	    ];
	    reveal = (function(_this) {
	      return function() {
	        _this.local.show = !_this.local.show;
	        document.activeElement.blur();
	        return save(_this.local);
	      };
	    })(this);
	    return DIV({
	      style: {
	        padding: '0 24px'
	      }
	    }, A({
	      name: 'research'
	    }), H2({
	      className: 'light_callout',
	      style: {
	        marginBottom: 18
	      }
	    }, "🤓 Academic Research about Consider.it 🤓"), DIV({
	      className: 'intro embedded',
	      dangerouslySetInnerHTML: {
	        __html: "<p>Consider.it was invented at the University of Washington as \n   part of the National Science Foundation funded <b>\n   <a href='https://f.consider.it/papers/dissertation.pdf'>doctoral research</a></b> of \n   Consider.it founder <a href=\"https://traviskriplean.com\" target=\"_blank\">Travis Kriplean</a>.</p>\n</p>\n\n<p>\n   Our goal was to create \n   a method by which large groups of people could civily \n   deliberate together online and find common ground, even on contentious topics. Our interdisciplinary team \n   included researchers from Computer Science, Political Communication, and \n   Human-centered Design.</p>\n\n<p>Below are some of the peer-reviewed findings about Consider.it.</p>"
	      }
	    }), UL({
	      style: {
	        listStyle: 'none',
	        position: 'relative',
	        margin: '20px 0px 0px 0px',
	        paddingBottom: 40
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = papers.length; i < len; idx = ++i) {
	        paper = papers[idx];
	        left = false;
	        size = 20;
	        results.push(LI({
	          key: paper.title,
	          style: {
	            position: 'relative',
	            marginBottom: paper.quote && !paper.hide_quote ? 30 : 90
	          }
	        }, DIV({
	          style: {
	            display: 'inline-block',
	            textAlign: 'left'
	          }
	        }, A({
	          className: 'monospaced',
	          style: {
	            color: '#303030',
	            fontSize: 24,
	            fontWeight: 700,
	            lineHeight: 1.1,
	            textDecoration: 'underline'
	          },
	          href: paper.url,
	          target: "_blank"
	        }, paper.title), DIV({
	          style: {
	            fontSize: 16,
	            paddingTop: 8,
	            lineHeight: 1.1
	          }
	        }, SPAN({
	          style: {
	            fontStyle: 'italic'
	          }
	        }, paper.venue)), DIV({
	          style: {
	            display: 'inline',
	            fontSize: 16,
	            position: 'relative',
	            top: 23,
	            fontWeight: 300
	          }
	        }, 'Researchers: '), authors(paper.authors)), paper.quote && !paper.hide_quote ? DIV({
	          style: {
	            padding: '36px 50px',
	            position: 'relative',
	            backgroundColor: considerit_gray,
	            boxShadow: '#b5b5b5 0 1px 1px 0px',
	            borderRadius: 64,
	            marginBottom: 40,
	            flex: 1,
	            marginLeft: 80,
	            marginTop: 70,
	            maxWidth: 600,
	            right: 0,
	            display: 'inline-block'
	          }
	        }, DIV({
	          style: {
	            transform: "rotate(180deg) scale(-1,-1)",
	            position: 'absolute',
	            left: 56,
	            top: -30,
	            zIndex: 2
	          }
	        }, Bubblemouth({
	          apex_xfrac: 0,
	          width: 30,
	          height: 30,
	          fill: considerit_gray,
	          stroke: 'transparent',
	          stroke_width: 0,
	          box_shadow: {
	            dx: -3,
	            dy: 0,
	            stdDeviation: 2,
	            opacity: .1
	          }
	        })), DIV({
	          className: 'embedded',
	          style: {
	            fontSize: 16
	          }
	        }, DIV({
	          dangerouslySetInnerHTML: {
	            __html: paper.quote
	          }
	        }))) : void 0));
	      }
	      return results;
	    })()));
	  }
	});
	
	styles += "[data-widget=\"CompareToOtherTools\"] {\n  margin-top: 140px;\n  margin-bottom: 80px;\n}\n\n@media (max-width: 900px) {\n  [data-widget=\"CompareToOtherTools\"] {\n    display: none;\n  }\n}\n\n[data-widget=\"CompareToOtherTools\"] .bold_callout {\n  margin-bottom: 20px;\n}\n[data-widget=\"CompareToOtherTools\"] .intro {\n  margin: 0px auto 36px auto;\n  max-width: 800px;\n  text-align: center;\n\n}\n\n\n[data-widget=\"CompareToOtherTools\"] h3 {\n  font-size: 36px;\n  text-align: center;\n  padding-top: 48px;\n  padding-bottom: 48px;\n  color: inherit;\n}\n\n\n[data-widget=\"CompareToOtherTools\"] .wrapper {\n  background: rgb(255,255,255);\n  transition: background 1s;\n  padding: 0 48px 68px 48px;\n  color: white;\n  position: relative;\n\n}\n\n[data-widget=\"CompareToOtherTools\"] .side-by-side {\n  display: flex;\n  justify-content: center;\n  align-items: baseline; \n}\n\n\n\n[data-widget=\"CompareToOtherTools\"] .col {\n\n}\n\n[data-widget=\"CompareToOtherTools\"] .middle {\n  flex-grow: 0;\n  width: 96px;\n  text-align: center;\n  font-size: 26px;\n  color: black;\n}\n\n\n[data-widget=\"CompareToOtherTools\"] .considerit-col > h3 {\n  color: black;\n  margin-bottom: 22px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .other-col > h3 {\n  color: black;\n\n}\n\n\n[data-widget=\"CompareToOtherTools\"] .recommendation {\n  max-width: 800px;\n  margin: auto;\n  margin-top: 48px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .recommendation h3 {\n  text-align: left;\n  color: white;\n\n}\n\n[data-widget=\"CompareToOtherTools\"] .recommendation p {\n  max-width: 730px;\n  margin-bottom: 18px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .attributes {\n  margin-top: 38px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .attribute {\n  margin-top: 28px;\n  font-size: 19px;\n  display: flex;\n}\n\n[data-widget=\"CompareToOtherTools\"] .attribute.won {\n  \n}\n\n[data-widget=\"CompareToOtherTools\"] .attribute.lost {\n  opacity: .6;\n} \n\n[data-widget=\"CompareToOtherTools\"] .attribute svg {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n[data-widget=\"CompareToOtherTools\"] .attribute > span {\n  max-width: 500px;\n  display: inline-block;\n}\n\n[data-widget=\"CompareToOtherTools\"] .other-col .attribute svg {\n  margin-left: -36px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .other-col .attribute.won > span{\n  padding-left: 8px;\n}\n\n@media all and (max-width: 1100px) {\n  [data-widget=\"CompareToOtherTools\"] .other-col .attribute.won > span{\n    padding-left: 0px;\n  }\n}\n\n\n[data-widget=\"CompareToOtherTools\"] .considerit-col .attribute {\n  text-align: right;\n  justify-content: right;\n\n}\n\n[data-widget=\"CompareToOtherTools\"] .considerit-col .attribute svg {\n  margin-right: -36px;\n}\n\n[data-widget=\"CompareToOtherTools\"] .considerit-col .attribute.won > span{\n  padding-right: 8px;\n}\n    \n\n";
	
	CompareToOtherTools = ReactiveComponent({
	  displayName: 'CompareToOtherTools',
	  render: function() {
	    var attribute, base, comparison, k, v;
	    if ((base = this.local).current_comparison == null) {
	      base.current_comparison = 'survey';
	    }
	    comparison = comparisons[this.local.current_comparison];
	    return DIV(null, A({
	      name: 'comparison_guide'
	    }), H2({
	      className: 'light_callout'
	    }, "Is Consider.it the right tool for you?"), DIV({
	      className: 'intro'
	    }, "Use this comparison guide to help figure out which tool suits your needs. "), DIV({
	      key: 'wrapper',
	      className: 'wrapper',
	      style: {
	        background: comparison.background
	      }
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: "  <style>\n    .custom-shape-divider-bottom-1649525836 {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        overflow: hidden;\n        line-height: 0;\n    }\n\n    .custom-shape-divider-bottom-1649525836 svg {\n        position: relative;\n        display: block;\n        width: calc(100% + 1.3px);\n        height: 53px;\n    }\n\n    .custom-shape-divider-bottom-1649525836 .shape-fill {\n        fill: #FFFFFF;\n    }\n</style>\n<div class=\"custom-shape-divider-bottom-1649525836\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 120\" preserveAspectRatio=\"none\">\n        <path d=\"M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z\" class=\"shape-fill\"></path>\n    </svg>\n</div>"
	      }
	    }), DIV({
	      className: 'side-by-side'
	    }, DIV({
	      className: 'considerit-col col'
	    }, H3(null, 'Consider.it'), Webframe({
	      browser_loc: 'https://livingvotersguide.consider.it/legalize',
	      width: "100%"
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, IMG({
	      alt: "Consider.it shows what people think (on a spectrum) and why (using pros and cons)",
	      loading: "lazy",
	      src: asset('product_page/considerit-comparison.png'),
	      style: {
	        aspectRatio: '580/340',
	        width: '100%',
	        maxWidth: 582,
	        paddingTop: 10,
	        display: 'block'
	      }
	    }))), DIV({
	      className: 'attributes'
	    }, (function() {
	      var i, len, ref, results;
	      ref = comparison.attributes;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        attribute = ref[i];
	        results.push(DIV({
	          key: attribute.other,
	          className: "attribute " + (!attribute.wins && attribute.wins !== 'both' ? 'lost' : 'won')
	        }, SPAN(null, attribute.considerit), attribute.wins && WINDOW_WIDTH() > 1100 ? checkmark(28, 'white') : void 0));
	      }
	      return results;
	    })())), DIV({
	      className: 'middle col'
	    }, 'vs'), DIV({
	      className: 'other-col col'
	    }, H3(null, DIV({
	      style: {
	        position: 'relative',
	        textAlign: 'center'
	      }
	    }, SELECT({
	      className: 'unstyled',
	      style: {
	        fontSize: 24,
	        padding: '28px 40px',
	        fontWeight: 400,
	        backgroundSize: '24px 20px',
	        backgroundColor: 'white',
	        border: '1px solid #979797',
	        borderRadius: 32
	      },
	      value: this.local.current_comparison,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.current_comparison = e.target.value;
	          save(_this.local);
	          return document.activeElement.blur();
	        };
	      })(this)
	    }, (function() {
	      var results;
	      results = [];
	      for (k in comparisons) {
	        v = comparisons[k];
	        results.push(OPTION({
	          key: k,
	          value: k,
	          style: {}
	        }, v.name));
	      }
	      return results;
	    })()))), Webframe({
	      browser_loc: comparison.browser_loc,
	      width: "100%"
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, IMG({
	      alt: comparison.alt,
	      loading: "lazy",
	      src: comparison.img,
	      style: {
	        aspectRatio: '580/340',
	        width: '100%',
	        paddingTop: 10,
	        display: 'block',
	        maxWidth: 582
	      }
	    }))), DIV({
	      className: 'attributes'
	    }, (function() {
	      var i, len, ref, results;
	      ref = comparison.attributes;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        attribute = ref[i];
	        results.push(DIV({
	          key: attribute.other,
	          className: "attribute " + (attribute.wins && attribute.wins !== 'both' ? 'lost' : 'won')
	        }, (!attribute.wins || attribute.wins === 'both') && WINDOW_WIDTH() > 1100 ? checkmark(28, 'white') : void 0, SPAN(null, attribute.other)));
	      }
	      return results;
	    })()))), DIV({
	      className: 'recommendation'
	    }, typeof comparison.recommendation === "function" ? comparison.recommendation() : void 0)));
	  }
	});
	
	comparisons = {
	  webforum: {
	    name: 'Message Boards',
	    alt: "Message boards show a post-reply structure.",
	    browser_loc: 'https://reddit.com/r/politics',
	    img: asset('product_page/comparison-messageboard.png'),
	    background: "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 300px, rgba(69,78,167,1) 300px, #2d3588 100%)",
	    recommendation: function() {
	      return [
	        H3({
	          key: 'h3'
	        }, "Recommendation: Use a standard web forum if unstructured conversation and individual \nexpression is most important."), P({
	          key: 'p'
	        }, "If so, check out the well-designed ", A({
	          key: 'a',
	          href: "https://discourse.org",
	          target: "_blank"
	        }, 'Discourse'), " web forum product. ", A({
	          key: 'a2',
	          href: "https://loomio.com",
	          target: "_blank"
	        }, 'Loomio'), " is another high quality forum technology with additional functionality for decision making in small groups.")
	      ];
	    },
	    attributes: [
	      {
	        considerit: 'The interface is novel.',
	        other: 'A familiar interface for participants.',
	        wins: false
	      }, {
	        considerit: 'Host can set and maintain focus.',
	        other: 'Supports flexible unstructured discussion.',
	        wins: 'both'
	      }, {
	        considerit: 'Stays organized and understandable even if hundreds participate.',
	        other: 'Gets more overwhelming as more people participate.',
	        wins: true
	      }, {
	        considerit: 'Consider.it encourages civility because personal attacks don’t fit the pro/con format.',
	        other: 'Post / reply format magnifies disagreement and can lead to personal attacks.',
	        wins: true
	      }, {
	        considerit: 'People see their opinion in relation to others. Back-and-forth tangents are hidden by default.',
	        other: 'A few loud voices can hijack the discussion. People can feel their voice is lost in the cacophony.',
	        wins: true
	      }
	    ]
	  },
	  survey: {
	    name: 'Surveys',
	    alt: "Surveys ask pre-determined questions of people, who answer them independently from each other.",
	    browser_loc: 'https://www.surveymonkey.com/mp/k-12-parent-survey-template',
	    img: asset('product_page/comparison-survey.png'),
	    background: "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 300px, #734487 300px, #63217f 100%)",
	    preamble: "Consider.it is like a hybrid of a survey and a focus group: you get quantitative data \nlike a survey and rich qualitative data like a focus group. Unlike either, Consider.it \norganizes the quantitative and qualititative data together, so you can make sense of it.",
	    recommendation: function() {
	      return [
	        H3({
	          key: 'h3'
	        }, "Recommendation: Use a survey if it is most important for participants to not influence each other.")
	      ];
	    },
	    attributes: [
	      {
	        considerit: 'The interface is novel.',
	        other: 'A familiar interface for participants.',
	        wins: false
	      }, {
	        considerit: 'Easy to collect demographic-style information, and use it to analyze opinions.',
	        other: 'Easy to collect demographic-style information, and visualize it.',
	        wins: 'both'
	      }, {
	        considerit: 'Opens up a dialogue. Your community can see sticking points and common ground.',
	        other: 'People respond independently. They don’t influence or learn from each other.',
	        wins: 'both'
	      }, {
	        considerit: 'Visualizes what your stakeholders think and why, linked together in an interactive summary.',
	        other: 'Open-ended questions are expensive to review, and may require follow-up with stakeholders to validate.',
	        wins: true
	      }, {
	        considerit: 'Unanticipated ideas and rationale can emerge and gain traction, illuminating community sentiment.',
	        other: 'Response categories are set in advance. Learning is limited by the foresight of the survey authors.',
	        wins: true
	      }
	    ]
	  }
	};


/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** product_page.bc74a212168a52ccaff1.js
 **/